import { createNavigation } from "next-intl/navigation"
import { defineRouting } from "next-intl/routing"

export const locales = [
  "de",
  "en",
  "fr",
  "it",
  "es",
  "pl",
  "cs",
  "nl",
  "sv",
  "no",
  "fi",
  "da",
  "ru",
] as const
export type Locale = (typeof locales)[number]
//export needed by sitemap
export const pathnames = {
  "/": "/",

  // (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!)
  // ACHTUNG (!) Spezifische Pfade müssen vor generischen Pfaden definiert werden
  // (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!) (!)

  // Rewrite specfic categories (no dynamic segments)
  // the translations come from the "Breadcrumbs" key from es.json, de.json, etc.
  // '/categories/fantasy': {
  //   en: '/categories/fantasy',
  //   de: '/kategorien/fantasie',
  //   fr: '/categories/fantaisie',
  //   it: '/categorie/fantasia',
  //   es: '/categorias/fantasia',
  //   pl: '/kategorie/fantazja',
  //   cs: '/kategorie/fantazie',
  //   nl: '/categorieen/fantasie',
  //   sv: '/kategorier/fantasi',
  //   no: '/kategorier/fantasi',
  //   fi: '/kategoriat/fantasia',
  //   da: '/kategorier/fantasi',
  //   ru: '/категории/фэнтези'

  // },

  /*
    ------------------------------------------------------------------
    |                      Static Paths                             |
    ------------------------------------------------------------------
    */

  "/about-us": {
    de: "/ueber-uns",
    en: "/about-us",
    fr: "/a-propos",
    it: "/chi-siamo",
    es: "/sobre-nosotros",
    pl: "/o-nas",
    cs: "/o-nas",
    nl: "/over-ons",
    sv: "/om-oss",
    no: "/om-oss",
    fi: "/meista",
    da: "/om-os",
    ru: "/o-nas",
  },

  "/rate-limit": {
    de: "/rate-limit",
    en: "/rate-limit",
    fr: "/rate-limit",
    it: "/rate-limit",
    es: "/rate-limit",
    pl: "/rate-limit",
    cs: "/rate-limit",
    nl: "/rate-limit",
    sv: "/rate-limit",
    no: "/rate-limit",
    fi: "/rate-limit",
    da: "/rate-limit",
    ru: "/rate-limit",
  },

  /*
    ------------------------------------------------------------------
    |                      Category Paths                             |
    ------------------------------------------------------------------
    */

  "/categories/fantasy": {
    de: "/kategorien/fantasy",
    en: "/categories/fantasy",
    fr: "/categories/fantasy",
    it: "/categorie/fantasy",
    es: "/categorias/fantasy",
    pl: "/kategorie/fantasy",
    cs: "/kategorie/fantasy",
    nl: "/categorieen/fantasy",
    sv: "/kategorier/fantasy",
    no: "/kategorier/fantasy",
    fi: "/kategoriat/fantasy",
    da: "/kategorier/fantasy",
    ru: "/kategorii/fantasy",
  },
  "/categories/video-games": {
    de: "/kategorien/video-games",
    en: "/categories/video-games",
    fr: "/categories/video-games",
    it: "/categorie/video-games",
    es: "/categorias/video-games",
    pl: "/kategorie/video-games",
    cs: "/kategorie/video-games",
    nl: "/categorieen/video-games",
    sv: "/kategorier/video-games",
    no: "/kategorier/video-games",
    fi: "/kategoriat/video-games",
    da: "/kategorier/video-games",
    ru: "/kategorii/video-games",
  },
  // "/categories/business": {
  //   "de": "/kategorien/business",
  //   "en": "/categories/business",
  //   "fr": "/categories/business",
  //   "it": "/categorie/business",
  //   "es": "/categorias/business",
  //   "pl": "/kategorie/business",
  //   "cs": "/kategorie/business",
  //   "nl": "/categorieen/business",
  //   "sv": "/kategorier/business",
  //   "no": "/kategorier/business",
  //   "fi": "/kategoriat/business",
  //   "da": "/kategorier/business",
  //   "ru": "/kategorii/business"
  // },
  "/categories/fantasy-world-building": {
    de: "/kategorien/fantasy-world-building",
    en: "/categories/fantasy-world-building",
    fr: "/categories/fantasy-world-building",
    it: "/categorie/fantasy-world-building",
    es: "/categorias/fantasy-world-building",
    pl: "/kategorie/fantasy-world-building",
    cs: "/kategorie/fantasy-world-building",
    nl: "/categorieen/fantasy-world-building",
    sv: "/kategorier/fantasy-world-building",
    no: "/kategorier/fantasy-world-building",
    fi: "/kategoriat/fantasy-world-building",
    da: "/kategorier/fantasy-world-building",
    ru: "/kategorii/fantasy-world-building",
  },
  "/categories/dnd": {
    de: "/kategorien/dnd",
    en: "/categories/dnd",
    fr: "/categories/dnd",
    it: "/categorie/dnd",
    es: "/categorias/dnd",
    pl: "/kategorie/dnd",
    cs: "/kategorie/dnd",
    nl: "/categorieen/dnd",
    sv: "/kategorier/dnd",
    no: "/kategorier/dnd",
    fi: "/kategoriat/dnd",
    da: "/kategorier/dnd",
    ru: "/kategorii/dnd",
  },
  "/categories/gaming": {
    de: "/kategorien/gaming",
    en: "/categories/gaming",
    fr: "/categories/gaming",
    it: "/categorie/gaming",
    es: "/categorias/gaming",
    pl: "/kategorie/gaming",
    cs: "/kategorie/gaming",
    nl: "/categorieen/gaming",
    sv: "/kategorier/gaming",
    no: "/kategorier/gaming",
    fi: "/kategoriat/gaming",
    da: "/kategorier/gaming",
    ru: "/kategorii/gaming",
  },

  /*
    ------------------------------------------------------------------
    |                      Subcategory Paths                          |
    ------------------------------------------------------------------
    */

  // Rewrite specific /categories/[category]/[subcategory] paths
  // the translations come from the "Breadcrumbs" key from es.json, de.json, etc.
  // "/categories/business/general": {
  //   "de": "/kategorien/firmen/allgemein",
  //   "en": "/categories/business/general",
  //   "fr": "/categories/entreprise/general",
  //   "it": "/categorie/attivita-commerciale/generale",
  //   "es": "/categorias/negocio/general",
  //   "pl": "/kategorie/biznes/ogolny",
  //   "cs": "/kategorie/podnikani/vseobecne",
  //   "nl": "/categorieen/bedrijf/algemeen",
  //   "sv": "/kategorier/foeretag/allmaen",
  //   "no": "/kategorier/virksomhet/generell",
  //   "fi": "/kategoriat/liiketoimintaa/kenraali",
  //   "da": "/kategorier/forretning/generel",
  //   "ru": "/kategorii/biznes/obschiy"
  // },
  // "/categories/business/industry": {
  //   "de": "/kategorien/firmen/branche",
  //   "en": "/categories/business/industry",
  //   "fr": "/categories/entreprise/secteur-d-activite",
  //   "it": "/categorie/attivita-commerciale/settore",
  //   "es": "/categorias/negocio/industria",
  //   "pl": "/kategorie/biznes/branzy",
  //   "cs": "/kategorie/podnikani/odvetvi",
  //   "nl": "/categorieen/bedrijf/branche",
  //   "sv": "/kategorier/foeretag/industri",
  //   "no": "/kategorier/virksomhet/bransje",
  //   "fi": "/kategoriat/liiketoimintaa/ala",
  //   "da": "/kategorier/forretning/industri",
  //   "ru": "/kategorii/biznes/otrasli"
  // },
  "/categories/fantasy/dark-fantasy": {
    de: "/kategorien/fantasie/dark-fantasy",
    en: "/categories/fantasy/dark-fantasy",
    fr: "/categories/fantaisie/fantaisie-sombre",
    it: "/categorie/fantasia/fantasia-oscura",
    es: "/categorias/fantasia/fantasia-oscura",
    pl: "/kategorie/fantazja/ciemna-fantazja",
    cs: "/kategorie/fantazie/temna-fantazie",
    nl: "/categorieen/fantasie/donkere-fantasie",
    sv: "/kategorier/fantasi/moerk-fantasy",
    no: "/kategorier/fantasi/dark-fantasy",
    fi: "/kategoriat/fantasia/dark-fantasia",
    da: "/kategorier/fantasi/mork-fantasy",
    ru: "/kategorii/fantaziya/temnaya-fentezi",
  },
  "/categories/fantasy/high-fantasy": {
    de: "/kategorien/fantasie/high-fantasy",
    en: "/categories/fantasy/high-fantasy",
    fr: "/categories/fantaisie/haute-fantaisie",
    it: "/categorie/fantasia/alta-fantasia",
    es: "/categorias/fantasia/alta-fantasia",
    pl: "/kategorie/fantazja/wysoka-fantazja",
    cs: "/kategorie/fantazie/vysoka-fantazie",
    nl: "/categorieen/fantasie/hoge-fantasie",
    sv: "/kategorier/fantasi/high-fantasy",
    no: "/kategorier/fantasi/hoy-fantasy",
    fi: "/kategoriat/fantasia/korkea-fantasia",
    da: "/kategorier/fantasi/hoj-fantasy",
    ru: "/kategorii/fantaziya/vysokoe-fentezi",
  },
  "/categories/fantasy/historical-fantasy": {
    de: "/kategorien/fantasie/historische-fantasie",
    en: "/categories/fantasy/historical-fantasy",
    fr: "/categories/fantaisie/fantaisie-historique",
    it: "/categorie/fantasia/fantasia-storica",
    es: "/categorias/fantasia/fantasia-historica",
    pl: "/kategorie/fantazja/fantazja-historyczna",
    cs: "/kategorie/fantazie/historicka-fantasy",
    nl: "/categorieen/fantasie/historische-fantasie",
    sv: "/kategorier/fantasi/historisk-fantasy",
    no: "/kategorier/fantasi/historisk-fantasy",
    fi: "/kategoriat/fantasia/historiallinen-fantasia",
    da: "/kategorier/fantasi/historisk-fantasy",
    ru: "/kategorii/fantaziya/istoricheskoe-fentezi",
  },
  "/categories/fantasy/mythological-fantasy": {
    de: "/kategorien/fantasie/mythologische-fantasie",
    en: "/categories/fantasy/mythological-fantasy",
    fr: "/categories/fantaisie/fantaisie-mythologique",
    it: "/categorie/fantasia/fantasia-mitologica",
    es: "/categorias/fantasia/fantasia-mitologica",
    pl: "/kategorie/fantazja/fantazja-mitologiczna",
    cs: "/kategorie/fantazie/mytologicka-fantazie",
    nl: "/categorieen/fantasie/mythologische-fantasie",
    sv: "/kategorier/fantasi/mytologisk-fantasi",
    no: "/kategorier/fantasi/mytologisk-fantasi",
    fi: "/kategoriat/fantasia/mytologinen-fantasia",
    da: "/kategorier/fantasi/mytologisk-fantasi",
    ru: "/kategorii/fantaziya/mifologicheskaya-fantaziya",
  },
  "/categories/fantasy/urban-fantasy": {
    de: "/kategorien/fantasie/urban-fantasy",
    en: "/categories/fantasy/urban-fantasy",
    fr: "/categories/fantaisie/fantaisie-urbaine",
    it: "/categorie/fantasia/fantasia-urbana",
    es: "/categorias/fantasia/fantasia-urbana",
    pl: "/kategorie/fantazja/miejska-fantazja",
    cs: "/kategorie/fantazie/mestska-fantazie",
    nl: "/categorieen/fantasie/stedelijke-fantasie",
    sv: "/kategorier/fantasi/urban-fantasy",
    no: "/kategorier/fantasi/urban-fantasy",
    fi: "/kategoriat/fantasia/urbaani-fantasia",
    da: "/kategorier/fantasi/urban-fantasy",
    ru: "/kategorii/fantaziya/gorodskoe-fentezi",
  },
  "/categories/fantasy-world-building/buildings": {
    de: "/kategorien/fantasy-world-building/gebaeude",
    en: "/categories/fantasy-world-building/buildings",
    fr: "/categories/fantasy-world-building/batiments",
    it: "/categorie/fantasy-world-building/edifici",
    es: "/categorias/fantasy-world-building/edificios",
    pl: "/kategorie/budynek-swiata-fantasy/budynki",
    cs: "/kategorie/fantasy-world-building/budovy",
    nl: "/categorieen/fantasiewereld-bouwen/gebouwen",
    sv: "/kategorier/fantasy-world-building/byggnader",
    no: "/kategorier/fantasy-world-building/bygninger",
    fi: "/kategoriat/fantasiamaailman-rakennus/rakennukset",
    da: "/kategorier/fantasy-world-building/bygninger",
    ru: "/kategorii/zdanie-fantasticheskogo-mira/zdaniya",
  },
  "/categories/fantasy-world-building/environment": {
    de: "/kategorien/fantasy-world-building/umfeld",
    en: "/categories/fantasy-world-building/environment",
    fr: "/categories/fantasy-world-building/environnement",
    it: "/categorie/fantasy-world-building/ambiente",
    es: "/categorias/fantasy-world-building/ambiente",
    pl: "/kategorie/budynek-swiata-fantasy/srodowisko",
    cs: "/kategorie/fantasy-world-building/zivotni-prostredi",
    nl: "/categorieen/fantasiewereld-bouwen/omgeving",
    sv: "/kategorier/fantasy-world-building/miljoe",
    no: "/kategorier/fantasy-world-building/miljo",
    fi: "/kategoriat/fantasiamaailman-rakennus/ympaeristoe",
    da: "/kategorier/fantasy-world-building/miljo",
    ru: "/kategorii/zdanie-fantasticheskogo-mira/sreda",
  },
  "/categories/fantasy-world-building/items": {
    de: "/kategorien/fantasy-world-building/gegenstaende",
    en: "/categories/fantasy-world-building/items",
    fr: "/categories/fantasy-world-building/articles",
    it: "/categorie/fantasy-world-building/elementi",
    es: "/categorias/fantasy-world-building/elementos",
    pl: "/kategorie/budynek-swiata-fantasy/rzeczy",
    cs: "/kategorie/fantasy-world-building/polozky",
    nl: "/categorieen/fantasiewereld-bouwen/artikelen",
    sv: "/kategorier/fantasy-world-building/foeremal",
    no: "/kategorier/fantasy-world-building/varer",
    fi: "/kategoriat/fantasiamaailman-rakennus/tuotteet",
    da: "/kategorier/fantasy-world-building/genstande",
    ru: "/kategorii/zdanie-fantasticheskogo-mira/predmety",
  },
  "/categories/fantasy-world-building/vehicles-and-vessels": {
    de: "/kategorien/fantasy-world-building/fahrzeuge-und-schiffe",
    en: "/categories/fantasy-world-building/vehicles-and-vessels",
    fr: "/categories/fantasy-world-building/vehicules-et-navires",
    it: "/categorie/fantasy-world-building/veicoli-e-navi",
    es: "/categorias/fantasy-world-building/vehiculos-y-embarcaciones",
    pl: "/kategorie/budynek-swiata-fantasy/pojazdy-i-statki",
    cs: "/kategorie/fantasy-world-building/vozidla-a-plavidla",
    nl: "/categorieen/fantasiewereld-bouwen/voertuigen-en-schepen",
    sv: "/kategorier/fantasy-world-building/fordon-och-fartyg",
    no: "/kategorier/fantasy-world-building/kjoretoy-og-fartoy",
    fi: "/kategoriat/fantasiamaailman-rakennus/ajoneuvot-ja-alukset",
    da: "/kategorier/fantasy-world-building/koretojer-og-fartojer",
    ru: "/kategorii/zdanie-fantasticheskogo-mira/transportnye-sredstva-i-suda",
  },
  "/categories/dnd/a-c": {
    de: "/kategorien/dnd/kreaturen-a-c",
    en: "/categories/dnd/creatures-a-c",
    fr: "/categories/dnd/creatures-ac",
    it: "/categorie/dnd/creature-a-c",
    es: "/categorias/dnd/criaturas-a-c",
    pl: "/kategorie/dnd/stworzenia-a-c",
    cs: "/kategorie/dnd/bytosti-a-c",
    nl: "/categorieen/dnd/wezens-a-c",
    sv: "/kategorier/dnd/varelser-a-c",
    no: "/kategorier/dnd/skapninger-a-c",
    fi: "/kategoriat/dnd/olennot-a-c",
    da: "/kategorier/dnd/vaesner-a-c",
    ru: "/kategorii/dnd/suschestva-ac",
  },
  "/categories/dnd/d-f": {
    de: "/kategorien/dnd/kreaturen-d-f",
    en: "/categories/dnd/creatures-d-f",
    fr: "/categories/dnd/creatures-df",
    it: "/categorie/dnd/creature-d-f",
    es: "/categorias/dnd/criaturas-d-f",
    pl: "/kategorie/dnd/stworzenia-d-f",
    cs: "/kategorie/dnd/tvorove-d-f",
    nl: "/categorieen/dnd/wezens-d-f",
    sv: "/kategorier/dnd/varelser-d-f",
    no: "/kategorier/dnd/skapninger-d-f",
    fi: "/kategoriat/dnd/olennot-d-f",
    da: "/kategorier/dnd/vaesner-d-f",
    ru: "/kategorii/dnd/suschestva-d-f",
  },
  "/categories/dnd/g-i": {
    de: "/kategorien/dnd/kreaturen-g-i",
    en: "/categories/dnd/creatures-g-i",
    fr: "/categories/dnd/creatures-gi",
    it: "/categorie/dnd/creature-g-i",
    es: "/categorias/dnd/criaturas-g-i",
    pl: "/kategorie/dnd/stworzenia-g-i",
    cs: "/kategorie/dnd/tvorove-g-i",
    nl: "/categorieen/dnd/wezens-g-i",
    sv: "/kategorier/dnd/varelser-g-i",
    no: "/kategorier/dnd/skapninger-g-i",
    fi: "/kategoriat/dnd/olennot-g-i",
    da: "/kategorier/dnd/vaesner-g-i",
    ru: "/kategorii/dnd/suschestva",
  },
  "/categories/dnd/j-l": {
    de: "/kategorien/dnd/kreaturen-j-l",
    en: "/categories/dnd/creatures-j-l",
    fr: "/categories/dnd/creatures-j-l",
    it: "/categorie/dnd/creature-j-l",
    es: "/categorias/dnd/criaturas-j-l",
    pl: "/kategorie/dnd/stworzenia-j-l",
    cs: "/kategorie/dnd/bytosti-j-l",
    nl: "/categorieen/dnd/wezens-j-l",
    sv: "/kategorier/dnd/varelser-j-l",
    no: "/kategorier/dnd/skapninger-j-l",
    fi: "/kategoriat/dnd/olennot-j-l",
    da: "/kategorier/dnd/vaesner-j-l",
    ru: "/kategorii/dnd/suschestva-dzhey-el",
  },
  "/categories/dnd/m-o": {
    de: "/kategorien/dnd/kreaturen-m-o",
    en: "/categories/dnd/creatures-m-o",
    fr: "/categories/dnd/creatures-m-o",
    it: "/categorie/dnd/creature-m-o",
    es: "/categorias/dnd/criaturas-mo",
    pl: "/kategorie/dnd/stworzenia-m-o",
    cs: "/kategorie/dnd/tvorove-m-o",
    nl: "/categorieen/dnd/wezens-m-o",
    sv: "/kategorier/dnd/varelser-m-o",
    no: "/kategorier/dnd/skapninger-m-o",
    fi: "/kategoriat/dnd/olennot-m-o",
    da: "/kategorier/dnd/vaesner-m-o",
    ru: "/kategorii/dnd/suschestva-m-o",
  },
  "/categories/dnd/p-r": {
    de: "/kategorien/dnd/kreaturen-p-r",
    en: "/categories/dnd/creatures-p-r",
    fr: "/categories/dnd/creatures-p-r",
    it: "/categorie/dnd/creature-p-r",
    es: "/categorias/dnd/criaturas-p-r",
    pl: "/kategorie/dnd/stworzenia-p-r",
    cs: "/kategorie/dnd/tvorove-p-r",
    nl: "/categorieen/dnd/wezens-p-r",
    sv: "/kategorier/dnd/varelser-p-r",
    no: "/kategorier/dnd/skapninger-p-r",
    fi: "/kategoriat/dnd/olennot-p-r",
    da: "/kategorier/dnd/vaesner-p-r",
    ru: "/kategorii/dnd/suschestva",
  },
  "/categories/dnd/s-u": {
    de: "/kategorien/dnd/kreaturen-s-u",
    en: "/categories/dnd/creatures-s-u",
    fr: "/categories/dnd/creatures-s-u",
    it: "/categorie/dnd/creature-s-u",
    es: "/categorias/dnd/criaturas-s-u",
    pl: "/kategorie/dnd/stworzenia-s-u",
    cs: "/kategorie/dnd/bytosti-s-u",
    nl: "/categorieen/dnd/wezens-s-u",
    sv: "/kategorier/dnd/varelser-s-u",
    no: "/kategorier/dnd/skapninger-s-u",
    fi: "/kategoriat/dnd/olennot-s-u",
    da: "/kategorier/dnd/vaesner-s-u",
    ru: "/kategorii/dnd/suschestva-s-u",
  },
  "/categories/dnd/v-z": {
    de: "/kategorien/dnd/kreaturen-v-z",
    en: "/categories/dnd/creatures-v-z",
    fr: "/categories/dnd/creatures-vz",
    it: "/categorie/dnd/creature-v-z",
    es: "/categorias/dnd/criaturas-v-z",
    pl: "/kategorie/dnd/stworzenia-v-z",
    cs: "/kategorie/dnd/bytosti-v-z",
    nl: "/categorieen/dnd/wezens-v-z",
    sv: "/kategorier/dnd/varelser-v-z",
    no: "/kategorier/dnd/skapninger-v-z",
    fi: "/kategoriat/dnd/olennot-v-z",
    da: "/kategorier/dnd/vaesner-v-z",
    ru: "/kategorii/dnd/suschestva-v-z",
  },
  "/categories/gaming/gamertag": {
    de: "/kategorien/spielen/gamertag",
    en: "/categories/gaming/gamertag",
    fr: "/categories/jeux/gamertag",
    it: "/categorie/gioco/tag-gioco",
    es: "/categorias/juego-de-azar/etiqueta-de-jugador",
    pl: "/kategorie/hazard/tag-gracza",
    cs: "/kategorie/hrani/gamertag",
    nl: "/categorieen/gamen/gamertag",
    sv: "/kategorier/spelande/gamertag",
    no: "/kategorier/gaming/gamertag",
    fi: "/kategoriat/pelaaminen/gamertag",
    da: "/kategorier/spil/gamertag",
    ru: "/kategorii/igry/teg-igroka",
  },
  "/categories/gaming/platform": {
    de: "/kategorien/spielen/plattform",
    en: "/categories/gaming/platform",
    fr: "/categories/jeux/plate-forme",
    it: "/categorie/gioco/piattaforma",
    es: "/categorias/juego-de-azar/plataforma",
    pl: "/kategorie/hazard/platforma",
    cs: "/kategorie/hrani/plosina",
    nl: "/categorieen/gamen/platform",
    sv: "/kategorier/spelande/plattform",
    no: "/kategorier/gaming/plattform",
    fi: "/kategoriat/pelaaminen/alusta",
    da: "/kategorier/spil/platform",
    ru: "/kategorii/igry/platforma",
  },
  "/categories/gaming/teams": {
    de: "/kategorien/spielen/teams",
    en: "/categories/gaming/teams",
    fr: "/categories/jeux/equipes",
    it: "/categorie/gioco/squadre",
    es: "/categorias/juego-de-azar/equipos",
    pl: "/kategorie/hazard/zespoly",
    cs: "/kategorie/hrani/tymy",
    nl: "/categorieen/gamen/teams",
    sv: "/kategorier/spelande/lag",
    no: "/kategorier/gaming/lag",
    fi: "/kategoriat/pelaaminen/joukkueet",
    da: "/kategorier/spil/hold",
    ru: "/kategorii/igry/komandy",
  },
  "/categories/video-games/animal-crossing": {
    de: "/kategorien/videospiele/animal-crossing",
    en: "/categories/video-games/animal-crossing",
    fr: "/categories/jeux-video/animal-crossing",
    it: "/categorie/videogiochi/animal-crossing",
    es: "/categorias/juegos-de-video/animal-crossing",
    pl: "/kategorie/gry-wideo/animal-crossing",
    cs: "/kategorie/videohry/animal-crossing",
    nl: "/categorieen/computerspellen/animal-crossing",
    sv: "/kategorier/videospel/animal-crossing",
    no: "/kategorier/videospill/animal-crossing",
    fi: "/kategoriat/videopelit/animal-crossing",
    da: "/kategorier/computerspil/animal-crossing",
    ru: "/kategorii/videoigry/animal-crossing",
  },
  "/categories/video-games/fortnite": {
    de: "/kategorien/videospiele/fortnite",
    en: "/categories/video-games/fortnite",
    fr: "/categories/jeux-video/fortnite",
    it: "/categorie/videogiochi/fortnite",
    es: "/categorias/juegos-de-video/fortnite",
    pl: "/kategorie/gry-wideo/fortnite",
    cs: "/kategorie/videohry/fortnite",
    nl: "/categorieen/computerspellen/fortnite",
    sv: "/kategorier/videospel/fortnite",
    no: "/kategorier/videospill/fortnite",
    fi: "/kategoriat/videopelit/fortnite",
    da: "/kategorier/computerspil/fortnite",
    ru: "/kategorii/videoigry/fortnite",
  },
  "/categories/video-games/pokemon": {
    de: "/kategorien/videospiele/pokemon",
    en: "/categories/video-games/pokemon",
    fr: "/categories/jeux-video/pokemon",
    it: "/categorie/videogiochi/pokemon",
    es: "/categorias/juegos-de-video/pokemon",
    pl: "/kategorie/gry-wideo/pokemon",
    cs: "/kategorie/videohry/pokemon",
    nl: "/categorieen/computerspellen/pokemon",
    sv: "/kategorier/videospel/pokemon",
    no: "/kategorier/videospill/pokemon",
    fi: "/kategoriat/videopelit/pokemon",
    da: "/kategorier/computerspil/pokemon",
    ru: "/kategorii/videoigry/pokemon",
  },
  "/categories/video-games/roblox": {
    de: "/kategorien/videospiele/roblox",
    en: "/categories/video-games/roblox",
    fr: "/categories/jeux-video/roblox",
    it: "/categorie/videogiochi/roblox",
    es: "/categorias/juegos-de-video/roblox",
    pl: "/kategorie/gry-wideo/roblox",
    cs: "/kategorie/videohry/roblox",
    nl: "/categorieen/computerspellen/roblox",
    sv: "/kategorier/videospel/roblox",
    no: "/kategorier/videospill/roblox",
    fi: "/kategoriat/videopelit/roblox",
    da: "/kategorier/computerspil/roblox",
    ru: "/kategorii/videoigry/robloks",
  },
  "/categories/video-games/valorant": {
    de: "/kategorien/videospiele/valorant",
    en: "/categories/video-games/valorant",
    fr: "/categories/jeux-video/valorant",
    it: "/categorie/videogiochi/valorant",
    es: "/categorias/juegos-de-video/valorant",
    pl: "/kategorie/gry-wideo/valorant",
    cs: "/kategorie/videohry/valorant",
    nl: "/categorieen/computerspellen/valorant",
    sv: "/kategorier/videospel/valorant",
    no: "/kategorier/videospill/valorant",
    fi: "/kategoriat/videopelit/valorant",
    da: "/kategorier/computerspil/valorant",
    ru: "/kategorii/videoigry/valorant",
  },
  "/categories/video-games/skyrim": {
    de: "/kategorien/videospiele/skyrim",
    en: "/categories/video-games/skyrim",
    fr: "/categories/jeux-video/skyrim",
    it: "/categorie/videogiochi/skyrim",
    es: "/categorias/juegos-de-video/skyrim",
    pl: "/kategorie/gry-wideo/skyrim",
    cs: "/kategorie/videohry/skyrim",
    nl: "/categorieen/computerspellen/skyrim",
    sv: "/kategorier/videospel/skyrim",
    no: "/kategorier/videospill/skyrim",
    fi: "/kategoriat/videopelit/skyrim",
    da: "/kategorier/computerspil/skyrim",
    ru: "/kategorii/videoigry/skayrim",
  },
  "/categories/video-games/league-of-legends": {
    de: "/kategorien/videospiele/league-of-legends",
    en: "/categories/video-games/league-of-legends",
    fr: "/categories/jeux-video/league-of-legends",
    it: "/categorie/videogiochi/league-of-legends",
    es: "/categorias/juegos-de-video/league-of-legends",
    pl: "/kategorie/gry-wideo/league-of-legends",
    cs: "/kategorie/videohry/league-of-legends",
    nl: "/categorieen/computerspellen/league-of-legends",
    sv: "/kategorier/videospel/league-of-legends",
    no: "/kategorier/videospill/league-of-legends",
    fi: "/kategoriat/videopelit/league-of-legends",
    da: "/kategorier/computerspil/liga-af-legender",
    ru: "/kategorii/videoigry/league-of-legends",
  },
  "/categories/video-games/dota-2": {
    de: "/kategorien/videospiele/dota-2",
    en: "/categories/video-games/dota-2",
    fr: "/categories/jeux-video/dota-2",
    it: "/categorie/videogiochi/dota-2",
    es: "/categorias/juegos-de-video/dota-2",
    pl: "/kategorie/gry-wideo/dota-2",
    cs: "/kategorie/videohry/dota-2",
    nl: "/categorieen/computerspellen/dota-2",
    sv: "/kategorier/videospel/dota-2",
    no: "/kategorier/videospill/dota-2",
    fi: "/kategoriat/videopelit/dota-2",
    da: "/kategorier/computerspil/dota-2",
    ru: "/kategorii/videoigry/dota-2",
  },
  "/categories/video-games/call-of-duty": {
    de: "/kategorien/videospiele/call-of-duty",
    en: "/categories/video-games/call-of-duty",
    fr: "/categories/jeux-video/call-of-duty",
    it: "/categorie/videogiochi/call-of-duty",
    es: "/categorias/juegos-de-video/call-of-duty",
    pl: "/kategorie/gry-wideo/call-of-duty",
    cs: "/kategorie/videohry/call-of-duty",
    nl: "/categorieen/computerspellen/call-of-duty",
    sv: "/kategorier/videospel/call-of-duty",
    no: "/kategorier/videospill/call-of-duty",
    fi: "/kategoriat/videopelit/velvollisuuden-kutsu",
    da: "/kategorier/computerspil/call-of-duty",
    ru: "/kategorii/videoigry/call-of-duty",
  },
  "/categories/video-games/escape-from-tarkov": {
    de: "/kategorien/videospiele/escape-from-tarkov",
    en: "/categories/video-games/escape-from-tarkov",
    fr: "/categories/jeux-video/escape-from-tarkov",
    it: "/categorie/videogiochi/escape-from-tarkov",
    es: "/categorias/juegos-de-video/escape-from-tarkov",
    pl: "/kategorie/gry-wideo/escape-from-tarkov",
    cs: "/kategorie/videohry/escape-from-tarkov",
    nl: "/categorieen/computerspellen/escape-from-tarkov",
    sv: "/kategorier/videospel/escape-from-tarkov",
    no: "/kategorier/videospill/escape-from-tarkov",
    fi: "/kategoriat/videopelit/pakene-tarkovista",
    da: "/kategorier/computerspil/escape-from-tarkov",
    ru: "/kategorii/videoigry/escape-from-tarkov",
  },
  "/categories/video-games/diablo-4": {
    de: "/kategorien/videospiele/diablo-4",
    en: "/categories/video-games/diablo-4",
    fr: "/categories/jeux-video/diablo-4",
    it: "/categorie/videogiochi/diablo-4",
    es: "/categorias/juegos-de-video/diablo-4",
    pl: "/kategorie/gry-wideo/diablo-4",
    cs: "/kategorie/videohry/diablo-4",
    nl: "/categorieen/computerspellen/diablo-4",
    sv: "/kategorier/videospel/diablo-4",
    no: "/kategorier/videospill/diablo-4",
    fi: "/kategoriat/videopelit/diablo-4",
    da: "/kategorier/computerspil/diablo-4",
    ru: "/kategorii/videoigry/diablo-4",
  },
  "/categories/video-games/cyberpunk": {
    de: "/kategorien/videospiele/cyberpunk",
    en: "/categories/video-games/cyberpunk",
    fr: "/categories/jeux-video/cyberpunk",
    it: "/categorie/videogiochi/cyberpunk",
    es: "/categorias/juegos-de-video/ciberpunk",
    pl: "/kategorie/gry-wideo/cyberpunk",
    cs: "/kategorie/videohry/cyberpunk",
    nl: "/categorieen/computerspellen/cyberpunk",
    sv: "/kategorier/videospel/cyberpunk",
    no: "/kategorier/videospill/cyberpunk",
    fi: "/kategoriat/videopelit/kyberpunk",
    da: "/kategorier/computerspil/cyberpunk",
    ru: "/kategorii/videoigry/kiberpank",
  },
  "/categories/video-games/hogwarts-legacy": {
    de: "/kategorien/videospiele/hogwarts-legacy",
    en: "/categories/video-games/hogwarts-legacy",
    fr: "/categories/jeux-video/hogwarts-legacy",
    it: "/categorie/videogiochi/hogwarts-legacy",
    es: "/categorias/juegos-de-video/hogwarts-legacy",
    pl: "/kategorie/gry-wideo/hogwarts-legacy",
    cs: "/kategorie/videohry/hogwarts-legacy",
    nl: "/categorieen/computerspellen/hogwarts-legacy",
    sv: "/kategorier/videospel/hogwarts-legacy",
    no: "/kategorier/videospill/hogwarts-legacy",
    fi: "/kategoriat/videopelit/tylypahkan-perintoe",
    da: "/kategorier/computerspil/hogwarts-legacy",
    ru: "/kategorii/videoigry/hogwarts-legacy",
  },
  "/categories/video-games/minecraft": {
    de: "/kategorien/videospiele/minecraft",
    en: "/categories/video-games/minecraft",
    fr: "/categories/jeux-video/minecraft",
    it: "/categorie/videogiochi/minecraft",
    es: "/categorias/juegos-de-video/minecraft",
    pl: "/kategorie/gry-wideo/minecraft",
    cs: "/kategorie/videohry/minecraft",
    nl: "/categorieen/computerspellen/minecraft",
    sv: "/kategorier/videospel/minecraft",
    no: "/kategorier/videospill/minecraft",
    fi: "/kategoriat/videopelit/minecraft",
    da: "/kategorier/computerspil/minecraft",
    ru: "/kategorii/videoigry/minecraft",
  },
  "/categories/video-games/world-of-warcraft": {
    de: "/kategorien/videospiele/world-of-warcraft",
    en: "/categories/video-games/world-of-warcraft",
    fr: "/categories/jeux-video/world-of-warcraft",
    it: "/categorie/videogiochi/world-of-warcraft",
    es: "/categorias/juegos-de-video/world-of-warcraft",
    pl: "/kategorie/gry-wideo/world-of-warcraft",
    cs: "/kategorie/videohry/world-of-warcraft",
    nl: "/categorieen/computerspellen/world-of-warcraft",
    sv: "/kategorier/videospel/world-of-warcraft",
    no: "/kategorier/videospill/world-of-warcraft",
    fi: "/kategoriat/videopelit/world-of-warcraft",
    da: "/kategorier/computerspil/world-of-warcraft",
    ru: "/kategorii/videoigry/world-of-warcraft",
  },

  /*
    ------------------------------------------------------------------
    |                      Namegenerator Paths                         |
    ------------------------------------------------------------------
    */

  // Add other category/subcategory paths here

  // Rewrite specific namegenerator paths
  // the path is /[category]/[subcategory]/[namegenerator]
  // the translations come from the "Breadcrumbs" key within es.json, de.json, etc.

  "/fantasy/dark-fantasy/demon": {
    de: "/fantasie/dark-fantasy/daemon",
    en: "/fantasy/dark-fantasy/demon",
    fr: "/fantaisie/fantaisie-sombre/demon",
    it: "/fantasia/fantasia-oscura/demone",
    es: "/fantasia/fantasia-oscura/demonio",
    pl: "/fantazja/ciemna-fantazja/demon",
    cs: "/fantazie/temna-fantazie/demon",
    nl: "/fantasie/donkere-fantasie/demon",
    sv: "/fantasi/moerk-fantasy/demon",
    no: "/fantasi/dark-fantasy/demon",
    fi: "/fantasia/dark-fantasia/demoni",
    da: "/fantasi/mork-fantasy/daemon",
    ru: "/fantaziya/temnaya-fentezi/demon",
  },
  "/fantasy/dark-fantasy/evil": {
    de: "/fantasie/dark-fantasy/teuflisch",
    en: "/fantasy/dark-fantasy/evil",
    fr: "/fantaisie/fantaisie-sombre/mal",
    it: "/fantasia/fantasia-oscura/cattivo",
    es: "/fantasia/fantasia-oscura/demonio",
    pl: "/fantazja/ciemna-fantazja/zlo",
    cs: "/fantazie/temna-fantazie/zlo",
    nl: "/fantasie/donkere-fantasie/kwaadaardig",
    sv: "/fantasi/moerk-fantasy/ondska",
    no: "/fantasi/dark-fantasy/ond",
    fi: "/fantasia/dark-fantasia/paha",
    da: "/fantasi/mork-fantasy/ond",
    ru: "/fantaziya/temnaya-fentezi/zlo",
  },
  "/fantasy/dark-fantasy/mage": {
    de: "/fantasie/dark-fantasy/magier",
    en: "/fantasy/dark-fantasy/mage",
    fr: "/fantaisie/fantaisie-sombre/mage",
    it: "/fantasia/fantasia-oscura/mago",
    es: "/fantasia/fantasia-oscura/mago",
    pl: "/fantazja/ciemna-fantazja/mag",
    cs: "/fantazie/temna-fantazie/kouzelnik",
    nl: "/fantasie/donkere-fantasie/magier",
    sv: "/fantasi/moerk-fantasy/magiker",
    no: "/fantasi/dark-fantasy/trollmann",
    fi: "/fantasia/dark-fantasia/velho",
    da: "/fantasi/mork-fantasy/mage",
    ru: "/fantaziya/temnaya-fentezi/mag",
  },
  "/fantasy/dark-fantasy/necromancer": {
    de: "/fantasie/dark-fantasy/nekromant",
    en: "/fantasy/dark-fantasy/necromancer",
    fr: "/fantaisie/fantaisie-sombre/necromancien",
    it: "/fantasia/fantasia-oscura/negromante",
    es: "/fantasia/fantasia-oscura/nigromante",
    pl: "/fantazja/ciemna-fantazja/nekromanta",
    cs: "/fantazie/temna-fantazie/nekromant",
    nl: "/fantasie/donkere-fantasie/geestenbezweerder",
    sv: "/fantasi/moerk-fantasy/andebesvaerjare",
    no: "/fantasi/dark-fantasy/necromancer",
    fi: "/fantasia/dark-fantasia/necromancer",
    da: "/fantasi/mork-fantasy/necromancer",
    ru: "/fantaziya/temnaya-fentezi/nekromant",
  },
  "/fantasy/dark-fantasy/sorcerer": {
    de: "/fantasie/dark-fantasy/zauberer",
    en: "/fantasy/dark-fantasy/sorcerer",
    fr: "/fantaisie/fantaisie-sombre/sorcier",
    it: "/fantasia/fantasia-oscura/stregone",
    es: "/fantasia/fantasia-oscura/hechicero",
    pl: "/fantazja/ciemna-fantazja/czarownik",
    cs: "/fantazie/temna-fantazie/kouzelnik",
    nl: "/fantasie/donkere-fantasie/tovenaar",
    sv: "/fantasi/moerk-fantasy/trollkarl",
    no: "/fantasi/dark-fantasy/trollmann",
    fi: "/fantasia/dark-fantasia/velho",
    da: "/fantasi/mork-fantasy/troldmand",
    ru: "/fantaziya/temnaya-fentezi/koldun",
  },
  "/fantasy/dark-fantasy/succubus": {
    de: "/fantasie/dark-fantasy/sukkubus",
    en: "/fantasy/dark-fantasy/succubus",
    fr: "/fantaisie/fantaisie-sombre/succube",
    it: "/fantasia/fantasia-oscura/succube",
    es: "/fantasia/fantasia-oscura/sucubo",
    pl: "/fantazja/ciemna-fantazja/sukkub",
    cs: "/fantazie/temna-fantazie/succubus",
    nl: "/fantasie/donkere-fantasie/succubus",
    sv: "/fantasi/moerk-fantasy/succubus",
    no: "/fantasi/dark-fantasy/succubus",
    fi: "/fantasia/dark-fantasia/succubus",
    da: "/fantasi/mork-fantasy/succubus",
    ru: "/fantaziya/temnaya-fentezi/sukkub",
  },
  "/fantasy/dark-fantasy/villain": {
    de: "/fantasie/dark-fantasy/schurke",
    en: "/fantasy/dark-fantasy/villain",
    fr: "/fantaisie/fantaisie-sombre/mechant",
    it: "/fantasia/fantasia-oscura/furfante",
    es: "/fantasia/fantasia-oscura/villano",
    pl: "/fantazja/ciemna-fantazja/zloczynca",
    cs: "/fantazie/temna-fantazie/darebak",
    nl: "/fantasie/donkere-fantasie/schurk",
    sv: "/fantasi/moerk-fantasy/skurk",
    no: "/fantasi/dark-fantasy/kriminell-kjeltring",
    fi: "/fantasia/dark-fantasia/konna",
    da: "/fantasi/mork-fantasy/skurk",
    ru: "/fantaziya/temnaya-fentezi/zlodey",
  },
  "/fantasy/dark-fantasy/warlock": {
    de: "/fantasie/dark-fantasy/hexenmeister",
    en: "/fantasy/dark-fantasy/warlock",
    fr: "/fantaisie/fantaisie-sombre/demoniste",
    it: "/fantasia/fantasia-oscura/stregone",
    es: "/fantasia/fantasia-oscura/brujo",
    pl: "/fantazja/ciemna-fantazja/czarodziej",
    cs: "/fantazie/temna-fantazie/carodej",
    nl: "/fantasie/donkere-fantasie/tovenaar",
    sv: "/fantasi/moerk-fantasy/trollkarl",
    no: "/fantasi/dark-fantasy/trollmann",
    fi: "/fantasia/dark-fantasia/warlock",
    da: "/fantasi/mork-fantasy/warlock",
    ru: "/fantaziya/temnaya-fentezi/chernoknizhnik",
  },
  "/fantasy/dark-fantasy/witch": {
    de: "/fantasie/dark-fantasy/hexe",
    en: "/fantasy/dark-fantasy/witch",
    fr: "/fantaisie/fantaisie-sombre/sorciere",
    it: "/fantasia/fantasia-oscura/strega",
    es: "/fantasia/fantasia-oscura/bruja",
    pl: "/fantazja/ciemna-fantazja/czarownica",
    cs: "/fantazie/temna-fantazie/carodejnice",
    nl: "/fantasie/donkere-fantasie/heks",
    sv: "/fantasi/moerk-fantasy/haexa",
    no: "/fantasi/dark-fantasy/heks",
    fi: "/fantasia/dark-fantasia/noita",
    da: "/fantasi/mork-fantasy/heks",
    ru: "/fantaziya/temnaya-fentezi/vedma",
  },
  "/fantasy/high-fantasy/centaur": {
    de: "/fantasie/high-fantasy/zentaur",
    en: "/fantasy/high-fantasy/centaur",
    fr: "/fantaisie/haute-fantaisie/centaure",
    it: "/fantasia/alta-fantasia/centauro",
    es: "/fantasia/alta-fantasia/centauro",
    pl: "/fantazja/wysoka-fantazja/centaur",
    cs: "/fantazie/vysoka-fantazie/kentaur",
    nl: "/fantasie/hoge-fantasie/centaur",
    sv: "/fantasi/high-fantasy/centaur",
    no: "/fantasi/hoy-fantasy/kentaur",
    fi: "/fantasia/korkea-fantasia/kentauri",
    da: "/fantasi/hoj-fantasy/kentaur",
    ru: "/fantaziya/vysokoe-fentezi/kentavr",
  },
  "/fantasy/high-fantasy/dark-elf": {
    de: "/fantasie/high-fantasy/dunkelelf",
    en: "/fantasy/high-fantasy/dark-elf",
    fr: "/fantaisie/haute-fantaisie/elfe-noir",
    it: "/fantasia/alta-fantasia/elfo-oscuro",
    es: "/fantasia/alta-fantasia/duende-oscuro",
    pl: "/fantazja/wysoka-fantazja/ciemny-elf",
    cs: "/fantazie/vysoka-fantazie/temny-elf",
    nl: "/fantasie/hoge-fantasie/donkere-elf",
    sv: "/fantasi/high-fantasy/svartalv",
    no: "/fantasi/hoy-fantasy/mork-alv",
    fi: "/fantasia/korkea-fantasia/tumma-tonttu",
    da: "/fantasi/hoj-fantasy/dark-elf",
    ru: "/fantaziya/vysokoe-fentezi/temniy-elf",
  },
  "/fantasy/high-fantasy/dragon": {
    de: "/fantasie/high-fantasy/drachen",
    en: "/fantasy/high-fantasy/dragon",
    fr: "/fantaisie/haute-fantaisie/dragon",
    it: "/fantasia/alta-fantasia/drago",
    es: "/fantasia/alta-fantasia/continuar",
    pl: "/fantazja/wysoka-fantazja/smok",
    cs: "/fantazie/vysoka-fantazie/drak",
    nl: "/fantasie/hoge-fantasie/draak",
    sv: "/fantasi/high-fantasy/drake",
    no: "/fantasi/hoy-fantasy/drage",
    fi: "/fantasia/korkea-fantasia/lohikaeaerme",
    da: "/fantasi/hoj-fantasy/traekke-pa",
    ru: "/fantaziya/vysokoe-fentezi/drakon",
  },
  "/fantasy/high-fantasy/dwarf": {
    de: "/fantasie/high-fantasy/zwerg",
    en: "/fantasy/high-fantasy/dwarf",
    fr: "/fantaisie/haute-fantaisie/nain",
    it: "/fantasia/alta-fantasia/nano",
    es: "/fantasia/alta-fantasia/enano",
    pl: "/fantazja/wysoka-fantazja/krasnolud",
    cs: "/fantazie/vysoka-fantazie/trpaslik",
    nl: "/fantasie/hoge-fantasie/dwerg",
    sv: "/fantasi/high-fantasy/dvaerg",
    no: "/fantasi/hoy-fantasy/dverg",
    fi: "/fantasia/korkea-fantasia/kaeaepioe",
    da: "/fantasi/hoj-fantasy/dvaerg",
    ru: "/fantaziya/vysokoe-fentezi/karlik",
  },
  "/fantasy/high-fantasy/elemental": {
    de: "/fantasie/high-fantasy/elementar",
    en: "/fantasy/high-fantasy/elemental",
    fr: "/fantaisie/haute-fantaisie/elementaire",
    it: "/fantasia/alta-fantasia/elementare",
    es: "/fantasia/alta-fantasia/elemental",
    pl: "/fantazja/wysoka-fantazja/pierwiastkowy",
    cs: "/fantazie/vysoka-fantazie/elementarni",
    nl: "/fantasie/hoge-fantasie/elementair",
    sv: "/fantasi/high-fantasy/elementaer",
    no: "/fantasi/hoy-fantasy/elementaert",
    fi: "/fantasia/korkea-fantasia/alkuaine",
    da: "/fantasi/hoj-fantasy/elementaert",
    ru: "/fantaziya/vysokoe-fentezi/elemental",
  },
  "/fantasy/high-fantasy/elf": {
    de: "/fantasie/high-fantasy/elf",
    en: "/fantasy/high-fantasy/elf",
    fr: "/fantaisie/haute-fantaisie/elfe",
    it: "/fantasia/alta-fantasia/elfo",
    es: "/fantasia/alta-fantasia/duende",
    pl: "/fantazja/wysoka-fantazja/elf",
    cs: "/fantazie/vysoka-fantazie/elf",
    nl: "/fantasie/hoge-fantasie/elf",
    sv: "/fantasi/high-fantasy/aelva",
    no: "/fantasi/hoy-fantasy/alv",
    fi: "/fantasia/korkea-fantasia/elf",
    da: "/fantasi/hoj-fantasy/nisse",
    ru: "/fantaziya/vysokoe-fentezi/elf",
  },
  "/fantasy/high-fantasy/fairy": {
    de: "/fantasie/high-fantasy/fee",
    en: "/fantasy/high-fantasy/fairy",
    fr: "/fantaisie/haute-fantaisie/fee",
    it: "/fantasia/alta-fantasia/fata",
    es: "/fantasia/alta-fantasia/hada",
    pl: "/fantazja/wysoka-fantazja/wrozka",
    cs: "/fantazie/vysoka-fantazie/vila",
    nl: "/fantasie/hoge-fantasie/fee",
    sv: "/fantasi/high-fantasy/fe",
    no: "/fantasi/hoy-fantasy/fe",
    fi: "/fantasia/korkea-fantasia/keiju",
    da: "/fantasi/hoj-fantasy/fe",
    ru: "/fantaziya/vysokoe-fentezi/skazochniy",
  },
  "/fantasy/high-fantasy/giant": {
    de: "/fantasie/high-fantasy/riese",
    en: "/fantasy/high-fantasy/giant",
    fr: "/fantaisie/haute-fantaisie/geant",
    it: "/fantasia/alta-fantasia/gigante",
    es: "/fantasia/alta-fantasia/gigante",
    pl: "/fantazja/wysoka-fantazja/ogromny",
    cs: "/fantazie/vysoka-fantazie/obri",
    nl: "/fantasie/hoge-fantasie/reusachtig",
    sv: "/fantasi/high-fantasy/jaette",
    no: "/fantasi/hoy-fantasy/kjempe",
    fi: "/fantasia/korkea-fantasia/jaettilaeinen",
    da: "/fantasi/hoj-fantasy/kaempe-stor",
    ru: "/fantaziya/vysokoe-fentezi/gigant",
  },
  "/fantasy/high-fantasy/goblin": {
    de: "/fantasie/high-fantasy/kobold",
    en: "/fantasy/high-fantasy/goblin",
    fr: "/fantaisie/haute-fantaisie/lutin",
    it: "/fantasia/alta-fantasia/goblin",
    es: "/fantasia/alta-fantasia/duende",
    pl: "/fantazja/wysoka-fantazja/chochlik",
    cs: "/fantazie/vysoka-fantazie/sotek",
    nl: "/fantasie/hoge-fantasie/goblin",
    sv: "/fantasi/high-fantasy/troll",
    no: "/fantasi/hoy-fantasy/goblin",
    fi: "/fantasia/korkea-fantasia/hiisi",
    da: "/fantasi/hoj-fantasy/goblin",
    ru: "/fantaziya/vysokoe-fentezi/goblin",
  },
  "/fantasy/high-fantasy/half-elf": {
    de: "/fantasie/high-fantasy/halbelf",
    en: "/fantasy/high-fantasy/half-elf",
    fr: "/fantaisie/haute-fantaisie/demi-elfe",
    it: "/fantasia/alta-fantasia/mezzelfo",
    es: "/fantasia/alta-fantasia/semielfo",
    pl: "/fantazja/wysoka-fantazja/pol-elf",
    cs: "/fantazie/vysoka-fantazie/pulelf",
    nl: "/fantasie/hoge-fantasie/half-elf",
    sv: "/fantasi/high-fantasy/halv-elf",
    no: "/fantasi/hoy-fantasy/halv-elf",
    fi: "/fantasia/korkea-fantasia/puolitonttu",
    da: "/fantasi/hoj-fantasy/halv-elver",
    ru: "/fantaziya/vysokoe-fentezi/poluelf",
  },
  "/fantasy/high-fantasy/minotaur": {
    de: "/fantasie/high-fantasy/minotaur",
    en: "/fantasy/high-fantasy/minotaur",
    fr: "/fantaisie/haute-fantaisie/minotaure",
    it: "/fantasia/alta-fantasia/minotauro",
    es: "/fantasia/alta-fantasia/minotauro",
    pl: "/fantazja/wysoka-fantazja/minotaur",
    cs: "/fantazie/vysoka-fantazie/minotaur",
    nl: "/fantasie/hoge-fantasie/minotaurus",
    sv: "/fantasi/high-fantasy/minotaurus",
    no: "/fantasi/hoy-fantasy/minotaurus",
    fi: "/fantasia/korkea-fantasia/minotaurus",
    da: "/fantasi/hoj-fantasy/minotaurus",
    ru: "/fantaziya/vysokoe-fentezi/minotavr",
  },
  "/fantasy/high-fantasy/ogre": {
    de: "/fantasie/high-fantasy/oger",
    en: "/fantasy/high-fantasy/ogre",
    fr: "/fantaisie/haute-fantaisie/ogre",
    it: "/fantasia/alta-fantasia/orco",
    es: "/fantasia/alta-fantasia/ogro",
    pl: "/fantazja/wysoka-fantazja/ogr",
    cs: "/fantazie/vysoka-fantazie/ogre",
    nl: "/fantasie/hoge-fantasie/boeman",
    sv: "/fantasi/high-fantasy/troll",
    no: "/fantasi/hoy-fantasy/ogre",
    fi: "/fantasia/korkea-fantasia/ogre",
    da: "/fantasi/hoj-fantasy/ogre",
    ru: "/fantaziya/vysokoe-fentezi/ogr",
  },
  "/fantasy/high-fantasy/orc": {
    de: "/fantasie/high-fantasy/ork",
    en: "/fantasy/high-fantasy/orc",
    fr: "/fantaisie/haute-fantaisie/orque",
    it: "/fantasia/alta-fantasia/orco",
    es: "/fantasia/alta-fantasia/orco",
    pl: "/fantazja/wysoka-fantazja/ork",
    cs: "/fantazie/vysoka-fantazie/orc",
    nl: "/fantasie/hoge-fantasie/ork",
    sv: "/fantasi/high-fantasy/orc",
    no: "/fantasi/hoy-fantasy/orc",
    fi: "/fantasia/korkea-fantasia/orc",
    da: "/fantasi/hoj-fantasy/orc",
    ru: "/fantaziya/vysokoe-fentezi/ork",
  },
  "/fantasy/high-fantasy/phoenix": {
    de: "/fantasie/high-fantasy/phoenix",
    en: "/fantasy/high-fantasy/phoenix",
    fr: "/fantaisie/haute-fantaisie/phenix",
    it: "/fantasia/alta-fantasia/fenice",
    es: "/fantasia/alta-fantasia/fenix",
    pl: "/fantazja/wysoka-fantazja/feniks",
    cs: "/fantazie/vysoka-fantazie/phoenix",
    nl: "/fantasie/hoge-fantasie/feniks",
    sv: "/fantasi/high-fantasy/fagel-fenix",
    no: "/fantasi/hoy-fantasy/foniks",
    fi: "/fantasia/korkea-fantasia/phoenix",
    da: "/fantasi/hoj-fantasy/phoenix",
    ru: "/fantaziya/vysokoe-fentezi/feniks",
  },
  "/fantasy/high-fantasy/shaman": {
    de: "/fantasie/high-fantasy/schamane",
    en: "/fantasy/high-fantasy/shaman",
    fr: "/fantaisie/haute-fantaisie/chaman",
    it: "/fantasia/alta-fantasia/sciamano",
    es: "/fantasia/alta-fantasia/chaman",
    pl: "/fantazja/wysoka-fantazja/szaman",
    cs: "/fantazie/vysoka-fantazie/saman",
    nl: "/fantasie/hoge-fantasie/sjamaan",
    sv: "/fantasi/high-fantasy/schaman",
    no: "/fantasi/hoy-fantasy/sjaman",
    fi: "/fantasia/korkea-fantasia/shamaani",
    da: "/fantasi/hoj-fantasy/shaman",
    ru: "/fantaziya/vysokoe-fentezi/shaman",
  },
  "/fantasy/high-fantasy/troll": {
    de: "/fantasie/high-fantasy/troll",
    en: "/fantasy/high-fantasy/troll",
    fr: "/fantaisie/haute-fantaisie/troll",
    it: "/fantasia/alta-fantasia/troll",
    es: "/fantasia/alta-fantasia/troll",
    pl: "/fantazja/wysoka-fantazja/troll",
    cs: "/fantazie/vysoka-fantazie/troll",
    nl: "/fantasie/hoge-fantasie/trol",
    sv: "/fantasi/high-fantasy/troll",
    no: "/fantasi/hoy-fantasy/troll",
    fi: "/fantasia/korkea-fantasia/peikko",
    da: "/fantasi/hoj-fantasy/trold",
    ru: "/fantaziya/vysokoe-fentezi/troll",
  },
  "/fantasy/high-fantasy/wizard": {
    de: "/fantasie/high-fantasy/magier",
    en: "/fantasy/high-fantasy/wizard",
    fr: "/fantaisie/haute-fantaisie/magicien",
    it: "/fantasia/alta-fantasia/procedura-guidata",
    es: "/fantasia/alta-fantasia/mago",
    pl: "/fantazja/wysoka-fantazja/czarodziej",
    cs: "/fantazie/vysoka-fantazie/kouzelnik",
    nl: "/fantasie/hoge-fantasie/tovenaar",
    sv: "/fantasi/high-fantasy/trollkarl",
    no: "/fantasi/hoy-fantasy/veiviser",
    fi: "/fantasia/korkea-fantasia/ohjattu-toiminto",
    da: "/fantasi/hoj-fantasy/guiden",
    ru: "/fantaziya/vysokoe-fentezi/volshebnik",
  },
  "/fantasy/historical-fantasy/bandit": {
    de: "/fantasie/historische-fantasie/bandit",
    en: "/fantasy/historical-fantasy/bandit",
    fr: "/fantaisie/fantaisie-historique/bandit",
    it: "/fantasia/fantasia-storica/bandito",
    es: "/fantasia/fantasia-historica/bandido",
    pl: "/fantazja/fantazja-historyczna/bandyta",
    cs: "/fantazie/historicka-fantasy/bandita",
    nl: "/fantasie/historische-fantasie/bandiet",
    sv: "/fantasi/historisk-fantasy/bandit",
    no: "/fantasi/historisk-fantasy/banditt",
    fi: "/fantasia/historiallinen-fantasia/bandit",
    da: "/fantasi/historisk-fantasy/bandit",
    ru: "/fantaziya/istoricheskoe-fentezi/bandit",
  },
  "/fantasy/historical-fantasy/barbarian": {
    de: "/fantasie/historische-fantasie/barbar",
    en: "/fantasy/historical-fantasy/barbarian",
    fr: "/fantaisie/fantaisie-historique/barbare",
    it: "/fantasia/fantasia-storica/barbaro",
    es: "/fantasia/fantasia-historica/barbaro",
    pl: "/fantazja/fantazja-historyczna/barbarzynca",
    cs: "/fantazie/historicka-fantasy/barbar",
    nl: "/fantasie/historische-fantasie/barbaar",
    sv: "/fantasi/historisk-fantasy/barbar",
    no: "/fantasi/historisk-fantasy/barbar",
    fi: "/fantasia/historiallinen-fantasia/barbaari",
    da: "/fantasi/historisk-fantasy/barbar",
    ru: "/fantaziya/istoricheskoe-fentezi/varvar",
  },
  "/fantasy/historical-fantasy/cowboy-and-cowgirl": {
    de: "/fantasie/historische-fantasie/cowboy-und-cowgirl",
    en: "/fantasy/historical-fantasy/cowboy-and-cowgirl",
    fr: "/fantaisie/fantaisie-historique/cowboy-et-cow-girl",
    it: "/fantasia/fantasia-storica/cowboy-e-cowgirl",
    es: "/fantasia/fantasia-historica/vaquero-y-vaquera",
    pl: "/fantazja/fantazja-historyczna/kowboj-i-kowbojka",
    cs: "/fantazie/historicka-fantasy/kovboj-a-kovbojka",
    nl: "/fantasie/historische-fantasie/cowboy-en-cowgirl",
    sv: "/fantasi/historisk-fantasy/cowboy-och-cowgirl",
    no: "/fantasi/historisk-fantasy/cowboy-og-cowgirl",
    fi: "/fantasia/historiallinen-fantasia/cowboy-ja-cowgirl",
    da: "/fantasi/historisk-fantasy/cowboy-og-cowgirl",
    ru: "/fantaziya/istoricheskoe-fentezi/kovboy-i-kovboysha",
  },
  "/fantasy/historical-fantasy/gothic-and-goths": {
    de: "/fantasie/historische-fantasie/gothic-und-goten",
    en: "/fantasy/historical-fantasy/gothic-and-goths",
    fr: "/fantaisie/fantaisie-historique/gothique-et-goths",
    it: "/fantasia/fantasia-storica/gotico-e-goti",
    es: "/fantasia/fantasia-historica/gotico-y-godos",
    pl: "/fantazja/fantazja-historyczna/gotyku-i-gotyku",
    cs: "/fantazie/historicka-fantasy/gotika-a-gothove",
    nl: "/fantasie/historische-fantasie/gotisch-en-goten",
    sv: "/fantasi/historisk-fantasy/gothic-och-goths",
    no: "/fantasi/historisk-fantasy/gothic-og-goths",
    fi: "/fantasia/historiallinen-fantasia/gootti-ja-gootit",
    da: "/fantasi/historisk-fantasy/gotisk-og-gotisk",
    ru: "/fantaziya/istoricheskoe-fentezi/gotika-i-goty",
  },
  "/fantasy/historical-fantasy/hero": {
    de: "/fantasie/historische-fantasie/held",
    en: "/fantasy/historical-fantasy/hero",
    fr: "/fantaisie/fantaisie-historique/heros",
    it: "/fantasia/fantasia-storica/eroe",
    es: "/fantasia/fantasia-historica/heroe",
    pl: "/fantazja/fantazja-historyczna/bohater",
    cs: "/fantazie/historicka-fantasy/hrdina",
    nl: "/fantasie/historische-fantasie/held",
    sv: "/fantasi/historisk-fantasy/hjaelte",
    no: "/fantasi/historisk-fantasy/helt",
    fi: "/fantasia/historiallinen-fantasia/sankari",
    da: "/fantasi/historisk-fantasy/helt",
    ru: "/fantaziya/istoricheskoe-fentezi/geroy",
  },
  "/fantasy/historical-fantasy/knight": {
    de: "/fantasie/historische-fantasie/ritter",
    en: "/fantasy/historical-fantasy/knight",
    fr: "/fantaisie/fantaisie-historique/chevalier",
    it: "/fantasia/fantasia-storica/cavaliere",
    es: "/fantasia/fantasia-historica/caballero",
    pl: "/fantazja/fantazja-historyczna/rycerz",
    cs: "/fantazie/historicka-fantasy/rytir",
    nl: "/fantasie/historische-fantasie/ridder",
    sv: "/fantasi/historisk-fantasy/riddare",
    no: "/fantasi/historisk-fantasy/ridder",
    fi: "/fantasia/historiallinen-fantasia/ritari",
    da: "/fantasi/historisk-fantasy/ridder",
    ru: "/fantaziya/istoricheskoe-fentezi/rytsar",
  },
  "/fantasy/historical-fantasy/medieval": {
    de: "/fantasie/historische-fantasie/mittelalterlich",
    en: "/fantasy/historical-fantasy/medieval",
    fr: "/fantaisie/fantaisie-historique/medieval",
    it: "/fantasia/fantasia-storica/medievale",
    es: "/fantasia/fantasia-historica/medieval",
    pl: "/fantazja/fantazja-historyczna/sredniowieczny",
    cs: "/fantazie/historicka-fantasy/stredoveky",
    nl: "/fantasie/historische-fantasie/middeleeuws",
    sv: "/fantasi/historisk-fantasy/medeltida",
    no: "/fantasi/historisk-fantasy/middelalder",
    fi: "/fantasia/historiallinen-fantasia/keskiaikainen",
    da: "/fantasi/historisk-fantasy/middelalderlig",
    ru: "/fantaziya/istoricheskoe-fentezi/srednevekoviy",
  },
  "/fantasy/historical-fantasy/ninja-and-assassin": {
    de: "/fantasie/historische-fantasie/ninja-und-assassine",
    en: "/fantasy/historical-fantasy/ninja-and-assassin",
    fr: "/fantaisie/fantaisie-historique/ninja-et-assassin",
    it: "/fantasia/fantasia-storica/ninja-e-assassino",
    es: "/fantasia/fantasia-historica/ninja-y-asesino",
    pl: "/fantazja/fantazja-historyczna/ninja-i-zabojca",
    cs: "/fantazie/historicka-fantasy/ninja-a-assassin",
    nl: "/fantasie/historische-fantasie/ninja-en-moordenaar",
    sv: "/fantasi/historisk-fantasy/ninja-och-assassin",
    no: "/fantasi/historisk-fantasy/ninja-og-assassin",
    fi: "/fantasia/historiallinen-fantasia/ninja-ja-salamurhaaja",
    da: "/fantasi/historisk-fantasy/ninja-og-assassin",
    ru: "/fantaziya/istoricheskoe-fentezi/nindzya-i-ubiytsa",
  },
  "/fantasy/historical-fantasy/pirate": {
    de: "/fantasie/historische-fantasie/pirat",
    en: "/fantasy/historical-fantasy/pirate",
    fr: "/fantaisie/fantaisie-historique/pirate",
    it: "/fantasia/fantasia-storica/pirata",
    es: "/fantasia/fantasia-historica/pirata",
    pl: "/fantazja/fantazja-historyczna/pirat",
    cs: "/fantazie/historicka-fantasy/pirat",
    nl: "/fantasie/historische-fantasie/piraat",
    sv: "/fantasi/historisk-fantasy/pirat",
    no: "/fantasi/historisk-fantasy/sjorover",
    fi: "/fantasia/historiallinen-fantasia/merirosvo",
    da: "/fantasi/historisk-fantasy/pirat",
    ru: "/fantaziya/istoricheskoe-fentezi/pirat",
  },
  "/fantasy/historical-fantasy/samurai": {
    de: "/fantasie/historische-fantasie/samurai",
    en: "/fantasy/historical-fantasy/samurai",
    fr: "/fantaisie/fantaisie-historique/samourai",
    it: "/fantasia/fantasia-storica/samurai",
    es: "/fantasia/fantasia-historica/samurai",
    pl: "/fantazja/fantazja-historyczna/samuraj",
    cs: "/fantazie/historicka-fantasy/samuraj",
    nl: "/fantasie/historische-fantasie/samoerai",
    sv: "/fantasi/historisk-fantasy/samuraj",
    no: "/fantasi/historisk-fantasy/samurai",
    fi: "/fantasia/historiallinen-fantasia/samurai",
    da: "/fantasi/historisk-fantasy/samurai",
    ru: "/fantaziya/istoricheskoe-fentezi/samuray",
  },
  "/fantasy/historical-fantasy/tribe": {
    de: "/fantasie/historische-fantasie/stamm",
    en: "/fantasy/historical-fantasy/tribe",
    fr: "/fantaisie/fantaisie-historique/tribu",
    it: "/fantasia/fantasia-storica/tribu",
    es: "/fantasia/fantasia-historica/tribu",
    pl: "/fantazja/fantazja-historyczna/plemie",
    cs: "/fantazie/historicka-fantasy/kmen",
    nl: "/fantasie/historische-fantasie/stam",
    sv: "/fantasi/historisk-fantasy/stam",
    no: "/fantasi/historisk-fantasy/stamme",
    fi: "/fantasia/historiallinen-fantasia/heimo",
    da: "/fantasi/historisk-fantasy/stamme",
    ru: "/fantaziya/istoricheskoe-fentezi/plemya",
  },
  "/fantasy/historical-fantasy/victorian-era": {
    de: "/fantasie/historische-fantasie/viktorianisches-zeitalter",
    en: "/fantasy/historical-fantasy/victorian-era",
    fr: "/fantaisie/fantaisie-historique/ere-victorienne",
    it: "/fantasia/fantasia-storica/era-vittoriana",
    es: "/fantasia/fantasia-historica/era-victoriana",
    pl: "/fantazja/fantazja-historyczna/era-wiktorianska",
    cs: "/fantazie/historicka-fantasy/viktorianska-era",
    nl: "/fantasie/historische-fantasie/victoriaanse-tijdperk",
    sv: "/fantasi/historisk-fantasy/viktorianska-eran",
    no: "/fantasi/historisk-fantasy/viktoriansk-tid",
    fi: "/fantasia/historiallinen-fantasia/viktoriaaninen-aikakausi",
    da: "/fantasi/historisk-fantasy/victoriansk-aera",
    ru: "/fantaziya/istoricheskoe-fentezi/viktorianskaya-epokha",
  },
  "/fantasy/historical-fantasy/viking": {
    de: "/fantasie/historische-fantasie/wikinger",
    en: "/fantasy/historical-fantasy/viking",
    fr: "/fantaisie/fantaisie-historique/viking",
    it: "/fantasia/fantasia-storica/vichingo",
    es: "/fantasia/fantasia-historica/vikingo",
    pl: "/fantazja/fantazja-historyczna/wiking",
    cs: "/fantazie/historicka-fantasy/viking",
    nl: "/fantasie/historische-fantasie/viking",
    sv: "/fantasi/historisk-fantasy/viking",
    no: "/fantasi/historisk-fantasy/viking",
    fi: "/fantasia/historiallinen-fantasia/viikinki",
    da: "/fantasi/historisk-fantasy/viking",
    ru: "/fantaziya/istoricheskoe-fentezi/viking",
  },
  "/fantasy/mythological-fantasy/angel": {
    de: "/fantasie/mythologische-fantasie/engel",
    en: "/fantasy/mythological-fantasy/angel",
    fr: "/fantaisie/fantaisie-mythologique/ange",
    it: "/fantasia/fantasia-mitologica/angelo",
    es: "/fantasia/fantasia-mitologica/angel",
    pl: "/fantazja/fantazja-mitologiczna/aniol",
    cs: "/fantazie/mytologicka-fantazie/andel",
    nl: "/fantasie/mythologische-fantasie/engel",
    sv: "/fantasi/mytologisk-fantasi/aengel",
    no: "/fantasi/mytologisk-fantasi/engel",
    fi: "/fantasia/mytologinen-fantasia/enkeli",
    da: "/fantasi/mytologisk-fantasi/engel",
    ru: "/fantaziya/mifologicheskaya-fantaziya/angel",
  },
  "/fantasy/mythological-fantasy/chimera": {
    de: "/fantasie/mythologische-fantasie/chimaere",
    en: "/fantasy/mythological-fantasy/chimera",
    fr: "/fantaisie/fantaisie-mythologique/chimere",
    it: "/fantasia/fantasia-mitologica/chimera",
    es: "/fantasia/fantasia-mitologica/quimera",
    pl: "/fantazja/fantazja-mitologiczna/chimera",
    cs: "/fantazie/mytologicka-fantazie/chimera",
    nl: "/fantasie/mythologische-fantasie/hersenschim",
    sv: "/fantasi/mytologisk-fantasi/chimaer",
    no: "/fantasi/mytologisk-fantasi/chimera",
    fi: "/fantasia/mytologinen-fantasia/chimera",
    da: "/fantasi/mytologisk-fantasi/kimaer",
    ru: "/fantaziya/mifologicheskaya-fantaziya/khimera",
  },
  "/fantasy/mythological-fantasy/god-and-goddess": {
    de: "/fantasie/mythologische-fantasie/gott-und-goettin",
    en: "/fantasy/mythological-fantasy/god-and-goddess",
    fr: "/fantaisie/fantaisie-mythologique/dieu-et-deesse",
    it: "/fantasia/fantasia-mitologica/dio-e-dea",
    es: "/fantasia/fantasia-mitologica/dios-y-diosa",
    pl: "/fantazja/fantazja-mitologiczna/bog-i-bogini",
    cs: "/fantazie/mytologicka-fantazie/buh-a-bohyne",
    nl: "/fantasie/mythologische-fantasie/god-en-godin",
    sv: "/fantasi/mytologisk-fantasi/gud-och-gudinna",
    no: "/fantasi/mytologisk-fantasi/gud-og-gudinne",
    fi: "/fantasia/mytologinen-fantasia/jumala-ja-jumalatar",
    da: "/fantasi/mytologisk-fantasi/gud-og-gudinde",
    ru: "/fantaziya/mifologicheskaya-fantaziya/bog-i-boginya",
  },
  "/fantasy/mythological-fantasy/golem": {
    de: "/fantasie/mythologische-fantasie/golem",
    en: "/fantasy/mythological-fantasy/golem",
    fr: "/fantaisie/fantaisie-mythologique/golem",
    it: "/fantasia/fantasia-mitologica/golem",
    es: "/fantasia/fantasia-mitologica/golem",
    pl: "/fantazja/fantazja-mitologiczna/golema",
    cs: "/fantazie/mytologicka-fantazie/golem",
    nl: "/fantasie/mythologische-fantasie/golem",
    sv: "/fantasi/mytologisk-fantasi/golem",
    no: "/fantasi/mytologisk-fantasi/golem",
    fi: "/fantasia/mytologinen-fantasia/golem",
    da: "/fantasi/mytologisk-fantasi/golem",
    ru: "/fantaziya/mifologicheskaya-fantaziya/golem",
  },
  "/fantasy/mythological-fantasy/griffin": {
    de: "/fantasie/mythologische-fantasie/greif",
    en: "/fantasy/mythological-fantasy/griffin",
    fr: "/fantaisie/fantaisie-mythologique/griffon",
    it: "/fantasia/fantasia-mitologica/grifone",
    es: "/fantasia/fantasia-mitologica/grifo",
    pl: "/fantazja/fantazja-mitologiczna/gryf",
    cs: "/fantazie/mytologicka-fantazie/griffin",
    nl: "/fantasie/mythologische-fantasie/griffioen",
    sv: "/fantasi/mytologisk-fantasi/grip",
    no: "/fantasi/mytologisk-fantasi/griffin",
    fi: "/fantasia/mytologinen-fantasia/griffin",
    da: "/fantasi/mytologisk-fantasi/griffin",
    ru: "/fantaziya/mifologicheskaya-fantaziya/grifon",
  },
  "/fantasy/mythological-fantasy/mermaid": {
    de: "/fantasie/mythologische-fantasie/meerjungfrau",
    en: "/fantasy/mythological-fantasy/mermaid",
    fr: "/fantaisie/fantaisie-mythologique/sirene",
    it: "/fantasia/fantasia-mitologica/sirena",
    es: "/fantasia/fantasia-mitologica/sirena",
    pl: "/fantazja/fantazja-mitologiczna/syrena",
    cs: "/fantazie/mytologicka-fantazie/morska-panna",
    nl: "/fantasie/mythologische-fantasie/meermin",
    sv: "/fantasi/mytologisk-fantasi/sjoejungfru",
    no: "/fantasi/mytologisk-fantasi/havfrue",
    fi: "/fantasia/mytologinen-fantasia/merenneito",
    da: "/fantasi/mytologisk-fantasi/havfrue",
    ru: "/fantaziya/mifologicheskaya-fantaziya/rusalka",
  },
  "/fantasy/mythological-fantasy/siren": {
    de: "/fantasie/mythologische-fantasie/sirene",
    en: "/fantasy/mythological-fantasy/siren",
    fr: "/fantaisie/fantaisie-mythologique/sirene",
    it: "/fantasia/fantasia-mitologica/sirena",
    es: "/fantasia/fantasia-mitologica/sirena",
    pl: "/fantazja/fantazja-mitologiczna/syrena",
    cs: "/fantazie/mytologicka-fantazie/sirena",
    nl: "/fantasie/mythologische-fantasie/sirene",
    sv: "/fantasi/mytologisk-fantasi/siren",
    no: "/fantasi/mytologisk-fantasi/sirene",
    fi: "/fantasia/mytologinen-fantasia/sireeni",
    da: "/fantasi/mytologisk-fantasi/sirene",
    ru: "/fantaziya/mifologicheskaya-fantaziya/sirena",
  },
  "/fantasy/mythological-fantasy/sphinx": {
    de: "/fantasie/mythologische-fantasie/sphinx",
    en: "/fantasy/mythological-fantasy/sphinx",
    fr: "/fantaisie/fantaisie-mythologique/sphinx",
    it: "/fantasia/fantasia-mitologica/sfinge",
    es: "/fantasia/fantasia-mitologica/esfinge",
    pl: "/fantazja/fantazja-mitologiczna/sfinks",
    cs: "/fantazie/mytologicka-fantazie/sfinga",
    nl: "/fantasie/mythologische-fantasie/sfinx",
    sv: "/fantasi/mytologisk-fantasi/sfinx",
    no: "/fantasi/mytologisk-fantasi/sfinks",
    fi: "/fantasia/mytologinen-fantasia/sfinksi",
    da: "/fantasi/mytologisk-fantasi/sphinx",
    ru: "/fantaziya/mifologicheskaya-fantaziya/sfinks",
  },
  "/fantasy/mythological-fantasy/valkyrie": {
    de: "/fantasie/mythologische-fantasie/walkuere",
    en: "/fantasy/mythological-fantasy/valkyrie",
    fr: "/fantaisie/fantaisie-mythologique/valkyrie",
    it: "/fantasia/fantasia-mitologica/valchiria",
    es: "/fantasia/fantasia-mitologica/valquiria",
    pl: "/fantazja/fantazja-mitologiczna/walkiria",
    cs: "/fantazie/mytologicka-fantazie/valkyra",
    nl: "/fantasie/mythologische-fantasie/valkyrie",
    sv: "/fantasi/mytologisk-fantasi/valkyria",
    no: "/fantasi/mytologisk-fantasi/valkyrie",
    fi: "/fantasia/mytologinen-fantasia/valkyrie",
    da: "/fantasi/mytologisk-fantasi/valkyrie",
    ru: "/fantaziya/mifologicheskaya-fantaziya/valkiriya",
  },
  "/fantasy/urban-fantasy/clan": {
    de: "/fantasie/urban-fantasy/clan",
    en: "/fantasy/urban-fantasy/clan",
    fr: "/fantaisie/fantaisie-urbaine/clan",
    it: "/fantasia/fantasia-urbana/clan",
    es: "/fantasia/fantasia-urbana/clan",
    pl: "/fantazja/miejska-fantazja/klan",
    cs: "/fantazie/mestska-fantazie/klan",
    nl: "/fantasie/stedelijke-fantasie/clan",
    sv: "/fantasi/urban-fantasy/klan",
    no: "/fantasi/urban-fantasy/klan",
    fi: "/fantasia/urbaani-fantasia/klaani",
    da: "/fantasi/urban-fantasy/klan",
    ru: "/fantaziya/gorodskoe-fentezi/klan",
  },
  "/fantasy/urban-fantasy/detective": {
    de: "/fantasie/urban-fantasy/detektiv",
    en: "/fantasy/urban-fantasy/detective",
    fr: "/fantaisie/fantaisie-urbaine/detective",
    it: "/fantasia/fantasia-urbana/investigatore",
    es: "/fantasia/fantasia-urbana/detective",
    pl: "/fantazja/miejska-fantazja/detektyw",
    cs: "/fantazie/mestska-fantazie/detektivni",
    nl: "/fantasie/stedelijke-fantasie/detective",
    sv: "/fantasi/urban-fantasy/detektiv",
    no: "/fantasi/urban-fantasy/detektiv",
    fi: "/fantasia/urbaani-fantasia/etsivae",
    da: "/fantasi/urban-fantasy/detektiv",
    ru: "/fantaziya/gorodskoe-fentezi/detektiv",
  },
  "/fantasy/urban-fantasy/gang": {
    de: "/fantasie/urban-fantasy/gang",
    en: "/fantasy/urban-fantasy/gang",
    fr: "/fantaisie/fantaisie-urbaine/gang",
    it: "/fantasia/fantasia-urbana/banda",
    es: "/fantasia/fantasia-urbana/pandilla",
    pl: "/fantazja/miejska-fantazja/banda",
    cs: "/fantazie/mestska-fantazie/gang",
    nl: "/fantasie/stedelijke-fantasie/bende",
    sv: "/fantasi/urban-fantasy/gaeng",
    no: "/fantasi/urban-fantasy/gjeng",
    fi: "/fantasia/urbaani-fantasia/jengi",
    da: "/fantasi/urban-fantasy/bande",
    ru: "/fantaziya/gorodskoe-fentezi/banda",
  },
  "/fantasy/urban-fantasy/ghost": {
    de: "/fantasie/urban-fantasy/geist",
    en: "/fantasy/urban-fantasy/ghost",
    fr: "/fantaisie/fantaisie-urbaine/fantome",
    it: "/fantasia/fantasia-urbana/fantasma",
    es: "/fantasia/fantasia-urbana/fantasma",
    pl: "/fantazja/miejska-fantazja/duch",
    cs: "/fantazie/mestska-fantazie/duch",
    nl: "/fantasie/stedelijke-fantasie/spook",
    sv: "/fantasi/urban-fantasy/spoeke",
    no: "/fantasi/urban-fantasy/spokelse",
    fi: "/fantasia/urbaani-fantasia/aave",
    da: "/fantasi/urban-fantasy/spogelse",
    ru: "/fantaziya/gorodskoe-fentezi/prizrak",
  },
  "/fantasy/urban-fantasy/mobster": {
    de: "/fantasie/urban-fantasy/gangster",
    en: "/fantasy/urban-fantasy/mobster",
    fr: "/fantaisie/fantaisie-urbaine/gangster",
    it: "/fantasia/fantasia-urbana/mafioso",
    es: "/fantasia/fantasia-urbana/gangster",
    pl: "/fantazja/miejska-fantazja/gangster",
    cs: "/fantazie/mestska-fantazie/mafian",
    nl: "/fantasie/stedelijke-fantasie/gangster",
    sv: "/fantasi/urban-fantasy/gangster",
    no: "/fantasi/urban-fantasy/gangster",
    fi: "/fantasia/urbaani-fantasia/gangsteri",
    da: "/fantasi/urban-fantasy/gangster",
    ru: "/fantaziya/gorodskoe-fentezi/gangster",
  },
  "/fantasy/urban-fantasy/monster": {
    de: "/fantasie/urban-fantasy/monster",
    en: "/fantasy/urban-fantasy/monster",
    fr: "/fantaisie/fantaisie-urbaine/monstre",
    it: "/fantasia/fantasia-urbana/mostro",
    es: "/fantasia/fantasia-urbana/monstruo",
    pl: "/fantazja/miejska-fantazja/potwor",
    cs: "/fantazie/mestska-fantazie/netvor",
    nl: "/fantasie/stedelijke-fantasie/monster",
    sv: "/fantasi/urban-fantasy/monster",
    no: "/fantasi/urban-fantasy/monster",
    fi: "/fantasia/urbaani-fantasia/hirvioe",
    da: "/fantasi/urban-fantasy/uhyre",
    ru: "/fantaziya/gorodskoe-fentezi/monstr",
  },
  "/fantasy/urban-fantasy/robot": {
    de: "/fantasie/urban-fantasy/roboter",
    en: "/fantasy/urban-fantasy/robot",
    fr: "/fantaisie/fantaisie-urbaine/robot",
    it: "/fantasia/fantasia-urbana/robot",
    es: "/fantasia/fantasia-urbana/robot",
    pl: "/fantazja/miejska-fantazja/robot",
    cs: "/fantazie/mestska-fantazie/robot",
    nl: "/fantasie/stedelijke-fantasie/robot",
    sv: "/fantasi/urban-fantasy/robot",
    no: "/fantasi/urban-fantasy/robot",
    fi: "/fantasia/urbaani-fantasia/robotti",
    da: "/fantasi/urban-fantasy/robot",
    ru: "/fantaziya/gorodskoe-fentezi/robot",
  },
  "/fantasy/urban-fantasy/skeleton": {
    de: "/fantasie/urban-fantasy/skelett",
    en: "/fantasy/urban-fantasy/skeleton",
    fr: "/fantaisie/fantaisie-urbaine/squelette",
    it: "/fantasia/fantasia-urbana/scheletro",
    es: "/fantasia/fantasia-urbana/esqueleto",
    pl: "/fantazja/miejska-fantazja/szkielet",
    cs: "/fantazie/mestska-fantazie/kostra",
    nl: "/fantasie/stedelijke-fantasie/skelet",
    sv: "/fantasi/urban-fantasy/skelett",
    no: "/fantasi/urban-fantasy/skjelett",
    fi: "/fantasia/urbaani-fantasia/luuranko",
    da: "/fantasi/urban-fantasy/skelet",
    ru: "/fantaziya/gorodskoe-fentezi/skelet",
  },
  "/fantasy/urban-fantasy/superhero": {
    de: "/fantasie/urban-fantasy/superheld",
    en: "/fantasy/urban-fantasy/superhero",
    fr: "/fantaisie/fantaisie-urbaine/super-heros",
    it: "/fantasia/fantasia-urbana/supereroe",
    es: "/fantasia/fantasia-urbana/superheroe",
    pl: "/fantazja/miejska-fantazja/superbohater",
    cs: "/fantazie/mestska-fantazie/super-hrdina",
    nl: "/fantasie/stedelijke-fantasie/superheld",
    sv: "/fantasi/urban-fantasy/superhjaelte",
    no: "/fantasi/urban-fantasy/superhelt",
    fi: "/fantasia/urbaani-fantasia/supersankari",
    da: "/fantasi/urban-fantasy/superhelt",
    ru: "/fantaziya/gorodskoe-fentezi/supergeroy",
  },
  "/fantasy/urban-fantasy/vampire": {
    de: "/fantasie/urban-fantasy/vampir",
    en: "/fantasy/urban-fantasy/vampire",
    fr: "/fantaisie/fantaisie-urbaine/vampire",
    it: "/fantasia/fantasia-urbana/vampiro",
    es: "/fantasia/fantasia-urbana/vampiro",
    pl: "/fantazja/miejska-fantazja/wampir",
    cs: "/fantazie/mestska-fantazie/upir",
    nl: "/fantasie/stedelijke-fantasie/vampier",
    sv: "/fantasi/urban-fantasy/vampyr",
    no: "/fantasi/urban-fantasy/vampyr",
    fi: "/fantasia/urbaani-fantasia/vampyyri",
    da: "/fantasi/urban-fantasy/vampyr",
    ru: "/fantaziya/gorodskoe-fentezi/vampir",
  },
  "/fantasy/urban-fantasy/werewolf": {
    de: "/fantasie/urban-fantasy/werwolf",
    en: "/fantasy/urban-fantasy/werewolf",
    fr: "/fantaisie/fantaisie-urbaine/loup-garou",
    it: "/fantasia/fantasia-urbana/mannaro",
    es: "/fantasia/fantasia-urbana/hombre-lobo",
    pl: "/fantazja/miejska-fantazja/wilkolak",
    cs: "/fantazie/mestska-fantazie/vlkodlak",
    nl: "/fantasie/stedelijke-fantasie/weerwolf",
    sv: "/fantasi/urban-fantasy/varulv",
    no: "/fantasi/urban-fantasy/varulv",
    fi: "/fantasia/urbaani-fantasia/ihmissusi",
    da: "/fantasi/urban-fantasy/varulv",
    ru: "/fantaziya/gorodskoe-fentezi/oboroten",
  },
  "/fantasy/urban-fantasy/zombie": {
    de: "/fantasie/urban-fantasy/zombie",
    en: "/fantasy/urban-fantasy/zombie",
    fr: "/fantaisie/fantaisie-urbaine/zombi",
    it: "/fantasia/fantasia-urbana/zombie",
    es: "/fantasia/fantasia-urbana/zombi",
    pl: "/fantazja/miejska-fantazja/balwan",
    cs: "/fantazie/mestska-fantazie/zombie",
    nl: "/fantasie/stedelijke-fantasie/zombie",
    sv: "/fantasi/urban-fantasy/zombie",
    no: "/fantasi/urban-fantasy/zombie",
    fi: "/fantasia/urbaani-fantasia/zombie",
    da: "/fantasi/urban-fantasy/zombie",
    ru: "/fantaziya/gorodskoe-fentezi/zhivoy-mertvets",
  },
  "/fantasy-world-building/buildings/castle": {
    de: "/fantasy-world-building/gebaeude/schloss",
    en: "/fantasy-world-building/buildings/castle",
    fr: "/fantasy-world-building/batiments/chateau",
    it: "/fantasy-world-building/edifici/castello",
    es: "/fantasy-world-building/edificios/castillo",
    pl: "/budynek-swiata-fantasy/budynki/zamek",
    cs: "/fantasy-world-building/budovy/hrad",
    nl: "/fantasiewereld-bouwen/gebouwen/kasteel",
    sv: "/fantasy-world-building/byggnader/slott",
    no: "/fantasy-world-building/bygninger/borg",
    fi: "/fantasiamaailman-rakennus/rakennukset/linna",
    da: "/fantasy-world-building/bygninger/slot",
    ru: "/zdanie-fantasticheskogo-mira/zdaniya/zamok",
  },
  "/fantasy-world-building/buildings/dungeon": {
    de: "/fantasy-world-building/gebaeude/verlies",
    en: "/fantasy-world-building/buildings/dungeon",
    fr: "/fantasy-world-building/batiments/donjon",
    it: "/fantasy-world-building/edifici/dungeon",
    es: "/fantasy-world-building/edificios/calabozo",
    pl: "/budynek-swiata-fantasy/budynki/loch",
    cs: "/fantasy-world-building/budovy/zalar",
    nl: "/fantasiewereld-bouwen/gebouwen/kerker",
    sv: "/fantasy-world-building/byggnader/dungeon",
    no: "/fantasy-world-building/bygninger/fangehull",
    fi: "/fantasiamaailman-rakennus/rakennukset/dungeon",
    da: "/fantasy-world-building/bygninger/fangehul",
    ru: "/zdanie-fantasticheskogo-mira/zdaniya/podzemele",
  },
  "/fantasy-world-building/buildings/fortress": {
    de: "/fantasy-world-building/gebaeude/festung",
    en: "/fantasy-world-building/buildings/fortress",
    fr: "/fantasy-world-building/batiments/forteresse",
    it: "/fantasy-world-building/edifici/fortezza",
    es: "/fantasy-world-building/edificios/fortaleza",
    pl: "/budynek-swiata-fantasy/budynki/twierdza",
    cs: "/fantasy-world-building/budovy/pevnost",
    nl: "/fantasiewereld-bouwen/gebouwen/vesting",
    sv: "/fantasy-world-building/byggnader/faestning",
    no: "/fantasy-world-building/bygninger/festning",
    fi: "/fantasiamaailman-rakennus/rakennukset/linnoitus",
    da: "/fantasy-world-building/bygninger/faestning",
    ru: "/zdanie-fantasticheskogo-mira/zdaniya/krepost",
  },
  "/fantasy-world-building/buildings/house": {
    de: "/fantasy-world-building/gebaeude/haus",
    en: "/fantasy-world-building/buildings/house",
    fr: "/fantasy-world-building/batiments/maison",
    it: "/fantasy-world-building/edifici/casa",
    es: "/fantasy-world-building/edificios/casa",
    pl: "/budynek-swiata-fantasy/budynki/dom",
    cs: "/fantasy-world-building/budovy/dum",
    nl: "/fantasiewereld-bouwen/gebouwen/huis",
    sv: "/fantasy-world-building/byggnader/hus",
    no: "/fantasy-world-building/bygninger/hus",
    fi: "/fantasiamaailman-rakennus/rakennukset/talo",
    da: "/fantasy-world-building/bygninger/hus",
    ru: "/zdanie-fantasticheskogo-mira/zdaniya/dom",
  },
  "/fantasy-world-building/buildings/noble-house": {
    de: "/fantasy-world-building/gebaeude/edles-haus",
    en: "/fantasy-world-building/buildings/noble-house",
    fr: "/fantasy-world-building/batiments/maison-noble",
    it: "/fantasy-world-building/edifici/casa-nobile",
    es: "/fantasy-world-building/edificios/casa-noble",
    pl: "/budynek-swiata-fantasy/budynki/dom-szlachetny",
    cs: "/fantasy-world-building/budovy/slechticky-dum",
    nl: "/fantasiewereld-bouwen/gebouwen/edele-huis",
    sv: "/fantasy-world-building/byggnader/adelshuset",
    no: "/fantasy-world-building/bygninger/adelshuset",
    fi: "/fantasiamaailman-rakennus/rakennukset/noble-house",
    da: "/fantasy-world-building/bygninger/adelshuset",
    ru: "/zdanie-fantasticheskogo-mira/zdaniya/blagorodniy-dom",
  },
  "/fantasy-world-building/buildings/palace": {
    de: "/fantasy-world-building/gebaeude/palast",
    en: "/fantasy-world-building/buildings/palace",
    fr: "/fantasy-world-building/batiments/palais",
    it: "/fantasy-world-building/edifici/palazzo",
    es: "/fantasy-world-building/edificios/palacio",
    pl: "/budynek-swiata-fantasy/budynki/palac",
    cs: "/fantasy-world-building/budovy/palac",
    nl: "/fantasiewereld-bouwen/gebouwen/paleis",
    sv: "/fantasy-world-building/byggnader/palats",
    no: "/fantasy-world-building/bygninger/slott",
    fi: "/fantasiamaailman-rakennus/rakennukset/palatsi",
    da: "/fantasy-world-building/bygninger/palads",
    ru: "/zdanie-fantasticheskogo-mira/zdaniya/dvorets",
  },
  "/fantasy-world-building/buildings/prison": {
    de: "/fantasy-world-building/gebaeude/gefaengnis",
    en: "/fantasy-world-building/buildings/prison",
    fr: "/fantasy-world-building/batiments/prison",
    it: "/fantasy-world-building/edifici/prigione",
    es: "/fantasy-world-building/edificios/prision",
    pl: "/budynek-swiata-fantasy/budynki/wiezienie",
    cs: "/fantasy-world-building/budovy/vezeni",
    nl: "/fantasiewereld-bouwen/gebouwen/gevangenis",
    sv: "/fantasy-world-building/byggnader/faengelse",
    no: "/fantasy-world-building/bygninger/fengsel",
    fi: "/fantasiamaailman-rakennus/rakennukset/vankila",
    da: "/fantasy-world-building/bygninger/faengsel",
    ru: "/zdanie-fantasticheskogo-mira/zdaniya/tyurma",
  },
  "/fantasy-world-building/buildings/tavern": {
    de: "/fantasy-world-building/gebaeude/taverne",
    en: "/fantasy-world-building/buildings/tavern",
    fr: "/fantasy-world-building/batiments/taverne",
    it: "/fantasy-world-building/edifici/taverna",
    es: "/fantasy-world-building/edificios/taberna",
    pl: "/budynek-swiata-fantasy/budynki/tawerna",
    cs: "/fantasy-world-building/budovy/krcma",
    nl: "/fantasiewereld-bouwen/gebouwen/taverne",
    sv: "/fantasy-world-building/byggnader/krog",
    no: "/fantasy-world-building/bygninger/taverna",
    fi: "/fantasiamaailman-rakennus/rakennukset/taverna",
    da: "/fantasy-world-building/bygninger/vaertshus",
    ru: "/zdanie-fantasticheskogo-mira/zdaniya/taverna",
  },
  "/fantasy-world-building/buildings/temple": {
    de: "/fantasy-world-building/gebaeude/tempel",
    en: "/fantasy-world-building/buildings/temple",
    fr: "/fantasy-world-building/batiments/temple",
    it: "/fantasy-world-building/edifici/tempio",
    es: "/fantasy-world-building/edificios/templo",
    pl: "/budynek-swiata-fantasy/budynki/swiatynia",
    cs: "/fantasy-world-building/budovy/chram",
    nl: "/fantasiewereld-bouwen/gebouwen/tempel",
    sv: "/fantasy-world-building/byggnader/tempel",
    no: "/fantasy-world-building/bygninger/tinning",
    fi: "/fantasiamaailman-rakennus/rakennukset/temppeli",
    da: "/fantasy-world-building/bygninger/tempel",
    ru: "/zdanie-fantasticheskogo-mira/zdaniya/khram",
  },
  "/fantasy-world-building/buildings/wizard-tower": {
    de: "/fantasy-world-building/gebaeude/zauberer-turm",
    en: "/fantasy-world-building/buildings/wizard-tower",
    fr: "/fantasy-world-building/batiments/tour-de-magicien",
    it: "/fantasy-world-building/edifici/torre-del-mago",
    es: "/fantasy-world-building/edificios/torre-del-mago",
    pl: "/budynek-swiata-fantasy/budynki/wieza-czarodzieja",
    cs: "/fantasy-world-building/budovy/vez-carodeju",
    nl: "/fantasiewereld-bouwen/gebouwen/tovenaarstoren",
    sv: "/fantasy-world-building/byggnader/trollkarltornet",
    no: "/fantasy-world-building/bygninger/trollmannstarnet",
    fi: "/fantasiamaailman-rakennus/rakennukset/wizard-tower",
    da: "/fantasy-world-building/bygninger/troldmandstarnet",
    ru: "/zdanie-fantasticheskogo-mira/zdaniya/bashnya-volshebnika",
  },
  "/fantasy-world-building/environment/city": {
    de: "/fantasy-world-building/umfeld/stadt",
    en: "/fantasy-world-building/environment/city",
    fr: "/fantasy-world-building/environnement/ville",
    it: "/fantasy-world-building/ambiente/citta",
    es: "/fantasy-world-building/ambiente/ciudad",
    pl: "/budynek-swiata-fantasy/srodowisko/miasto",
    cs: "/fantasy-world-building/zivotni-prostredi/mesto",
    nl: "/fantasiewereld-bouwen/omgeving/stad",
    sv: "/fantasy-world-building/miljoe/stad",
    no: "/fantasy-world-building/miljo/by",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/kaupunki",
    da: "/fantasy-world-building/miljo/by",
    ru: "/zdanie-fantasticheskogo-mira/sreda/gorod",
  },
  "/fantasy-world-building/environment/continent": {
    de: "/fantasy-world-building/umfeld/kontinent",
    en: "/fantasy-world-building/environment/continent",
    fr: "/fantasy-world-building/environnement/continent",
    it: "/fantasy-world-building/ambiente/continente",
    es: "/fantasy-world-building/ambiente/continente",
    pl: "/budynek-swiata-fantasy/srodowisko/kontynent",
    cs: "/fantasy-world-building/zivotni-prostredi/kontinent",
    nl: "/fantasiewereld-bouwen/omgeving/continent",
    sv: "/fantasy-world-building/miljoe/kontinent",
    no: "/fantasy-world-building/miljo/kontinent",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/manner",
    da: "/fantasy-world-building/miljo/kontinent",
    ru: "/zdanie-fantasticheskogo-mira/sreda/kontinent",
  },
  "/fantasy-world-building/environment/country": {
    de: "/fantasy-world-building/umfeld/land",
    en: "/fantasy-world-building/environment/country",
    fr: "/fantasy-world-building/environnement/pays",
    it: "/fantasy-world-building/ambiente/paese",
    es: "/fantasy-world-building/ambiente/pais",
    pl: "/budynek-swiata-fantasy/srodowisko/kraj",
    cs: "/fantasy-world-building/zivotni-prostredi/zeme",
    nl: "/fantasiewereld-bouwen/omgeving/land",
    sv: "/fantasy-world-building/miljoe/land",
    no: "/fantasy-world-building/miljo/land",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/maa",
    da: "/fantasy-world-building/miljo/land",
    ru: "/zdanie-fantasticheskogo-mira/sreda/strana",
  },
  "/fantasy-world-building/environment/desert": {
    de: "/fantasy-world-building/umfeld/wueste",
    en: "/fantasy-world-building/environment/desert",
    fr: "/fantasy-world-building/environnement/desert",
    it: "/fantasy-world-building/ambiente/deserto",
    es: "/fantasy-world-building/ambiente/desierto",
    pl: "/budynek-swiata-fantasy/srodowisko/pustynia",
    cs: "/fantasy-world-building/zivotni-prostredi/poust",
    nl: "/fantasiewereld-bouwen/omgeving/woestijn",
    sv: "/fantasy-world-building/miljoe/oeken",
    no: "/fantasy-world-building/miljo/orken",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/aavikko",
    da: "/fantasy-world-building/miljo/orken",
    ru: "/zdanie-fantasticheskogo-mira/sreda/pustynya",
  },
  "/fantasy-world-building/environment/elven-city": {
    de: "/fantasy-world-building/umfeld/elfenstadt",
    en: "/fantasy-world-building/environment/elven-city",
    fr: "/fantasy-world-building/environnement/cite-elfique",
    it: "/fantasy-world-building/ambiente/citta-degli-elfi",
    es: "/fantasy-world-building/ambiente/ciudad-elfica",
    pl: "/budynek-swiata-fantasy/srodowisko/elfie-miasto",
    cs: "/fantasy-world-building/zivotni-prostredi/mesto-elfu",
    nl: "/fantasiewereld-bouwen/omgeving/elfen-stad",
    sv: "/fantasy-world-building/miljoe/alven-city",
    no: "/fantasy-world-building/miljo/elven-city",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/haltioiden-kaupunki",
    da: "/fantasy-world-building/miljo/elver-by",
    ru: "/zdanie-fantasticheskogo-mira/sreda/elfiyskiy-gorod",
  },
  "/fantasy-world-building/environment/forest": {
    de: "/fantasy-world-building/umfeld/wald",
    en: "/fantasy-world-building/environment/forest",
    fr: "/fantasy-world-building/environnement/foret",
    it: "/fantasy-world-building/ambiente/foresta",
    es: "/fantasy-world-building/ambiente/bosque",
    pl: "/budynek-swiata-fantasy/srodowisko/las",
    cs: "/fantasy-world-building/zivotni-prostredi/les",
    nl: "/fantasiewereld-bouwen/omgeving/woud",
    sv: "/fantasy-world-building/miljoe/skog",
    no: "/fantasy-world-building/miljo/skog",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/metsae",
    da: "/fantasy-world-building/miljo/skov",
    ru: "/zdanie-fantasticheskogo-mira/sreda/les",
  },
  "/fantasy-world-building/environment/garden": {
    de: "/fantasy-world-building/umfeld/garten",
    en: "/fantasy-world-building/environment/garden",
    fr: "/fantasy-world-building/environnement/jardin",
    it: "/fantasy-world-building/ambiente/giardino",
    es: "/fantasy-world-building/ambiente/jardin",
    pl: "/budynek-swiata-fantasy/srodowisko/ogrod",
    cs: "/fantasy-world-building/zivotni-prostredi/zahrada",
    nl: "/fantasiewereld-bouwen/omgeving/tuin",
    sv: "/fantasy-world-building/miljoe/traedgard",
    no: "/fantasy-world-building/miljo/hage",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/puutarha",
    da: "/fantasy-world-building/miljo/have",
    ru: "/zdanie-fantasticheskogo-mira/sreda/sad",
  },
  "/fantasy-world-building/environment/haunted-forest": {
    de: "/fantasy-world-building/umfeld/verwunschener-wald",
    en: "/fantasy-world-building/environment/haunted-forest",
    fr: "/fantasy-world-building/environnement/foret-hantee",
    it: "/fantasy-world-building/ambiente/foresta-infestata",
    es: "/fantasy-world-building/ambiente/bosque-embrujado",
    pl: "/budynek-swiata-fantasy/srodowisko/nawiedzony-las",
    cs: "/fantasy-world-building/zivotni-prostredi/strasidelny-les",
    nl: "/fantasiewereld-bouwen/omgeving/spook-bos",
    sv: "/fantasy-world-building/miljoe/hemsoekt-skog",
    no: "/fantasy-world-building/miljo/hjemsokt-skog",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/kummitusmetsae",
    da: "/fantasy-world-building/miljo/hjemsogt-skov",
    ru: "/zdanie-fantasticheskogo-mira/sreda/prizrachniy-les",
  },
  "/fantasy-world-building/environment/island": {
    de: "/fantasy-world-building/umfeld/insel",
    en: "/fantasy-world-building/environment/island",
    fr: "/fantasy-world-building/environnement/ile",
    it: "/fantasy-world-building/ambiente/isola",
    es: "/fantasy-world-building/ambiente/isla",
    pl: "/budynek-swiata-fantasy/srodowisko/wyspa",
    cs: "/fantasy-world-building/zivotni-prostredi/ostrov",
    nl: "/fantasiewereld-bouwen/omgeving/eiland",
    sv: "/fantasy-world-building/miljoe/oe",
    no: "/fantasy-world-building/miljo/oy",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/saari",
    da: "/fantasy-world-building/miljo/o",
    ru: "/zdanie-fantasticheskogo-mira/sreda/ostrov",
  },
  "/fantasy-world-building/environment/kingdom": {
    de: "/fantasy-world-building/umfeld/koenigreich",
    en: "/fantasy-world-building/environment/kingdom",
    fr: "/fantasy-world-building/environnement/royaume",
    it: "/fantasy-world-building/ambiente/regno",
    es: "/fantasy-world-building/ambiente/reino",
    pl: "/budynek-swiata-fantasy/srodowisko/krolestwo",
    cs: "/fantasy-world-building/zivotni-prostredi/kralovstvi",
    nl: "/fantasiewereld-bouwen/omgeving/koninkrijk",
    sv: "/fantasy-world-building/miljoe/rike",
    no: "/fantasy-world-building/miljo/kongedomme",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/kuningaskunta",
    da: "/fantasy-world-building/miljo/kongerige",
    ru: "/zdanie-fantasticheskogo-mira/sreda/korolevstvo",
  },
  "/fantasy-world-building/environment/mountain": {
    de: "/fantasy-world-building/umfeld/berg",
    en: "/fantasy-world-building/environment/mountain",
    fr: "/fantasy-world-building/environnement/montagne",
    it: "/fantasy-world-building/ambiente/montagna",
    es: "/fantasy-world-building/ambiente/montana",
    pl: "/budynek-swiata-fantasy/srodowisko/gora",
    cs: "/fantasy-world-building/zivotni-prostredi/hora",
    nl: "/fantasiewereld-bouwen/omgeving/berg",
    sv: "/fantasy-world-building/miljoe/fjaell",
    no: "/fantasy-world-building/miljo/fjell",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/vuori",
    da: "/fantasy-world-building/miljo/bjerg",
    ru: "/zdanie-fantasticheskogo-mira/sreda/gora",
  },
  "/fantasy-world-building/environment/planet": {
    de: "/fantasy-world-building/umfeld/planet",
    en: "/fantasy-world-building/environment/planet",
    fr: "/fantasy-world-building/environnement/planete",
    it: "/fantasy-world-building/ambiente/pianeta",
    es: "/fantasy-world-building/ambiente/planeta",
    pl: "/budynek-swiata-fantasy/srodowisko/planeta",
    cs: "/fantasy-world-building/zivotni-prostredi/planeta",
    nl: "/fantasiewereld-bouwen/omgeving/planeet",
    sv: "/fantasy-world-building/miljoe/planet",
    no: "/fantasy-world-building/miljo/planet",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/planeetta",
    da: "/fantasy-world-building/miljo/planet",
    ru: "/zdanie-fantasticheskogo-mira/sreda/planeta",
  },
  "/fantasy-world-building/environment/realm": {
    de: "/fantasy-world-building/umfeld/reich",
    en: "/fantasy-world-building/environment/realm",
    fr: "/fantasy-world-building/environnement/royaume",
    it: "/fantasy-world-building/ambiente/regno",
    es: "/fantasy-world-building/ambiente/reino",
    pl: "/budynek-swiata-fantasy/srodowisko/krolestwo",
    cs: "/fantasy-world-building/zivotni-prostredi/oblast",
    nl: "/fantasiewereld-bouwen/omgeving/rijk",
    sv: "/fantasy-world-building/miljoe/rike",
    no: "/fantasy-world-building/miljo/realm",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/valtakunta",
    da: "/fantasy-world-building/miljo/rige",
    ru: "/zdanie-fantasticheskogo-mira/sreda/oblast",
  },
  "/fantasy-world-building/environment/river": {
    de: "/fantasy-world-building/umfeld/fluss",
    en: "/fantasy-world-building/environment/river",
    fr: "/fantasy-world-building/environnement/riviere",
    it: "/fantasy-world-building/ambiente/fiume",
    es: "/fantasy-world-building/ambiente/rio",
    pl: "/budynek-swiata-fantasy/srodowisko/rzeka",
    cs: "/fantasy-world-building/zivotni-prostredi/reka",
    nl: "/fantasiewereld-bouwen/omgeving/rivier",
    sv: "/fantasy-world-building/miljoe/flod",
    no: "/fantasy-world-building/miljo/elv",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/joki",
    da: "/fantasy-world-building/miljo/flod",
    ru: "/zdanie-fantasticheskogo-mira/sreda/reka",
  },
  "/fantasy-world-building/environment/sea-and-ocean": {
    de: "/fantasy-world-building/umfeld/meer-und-ozean",
    en: "/fantasy-world-building/environment/sea-and-ocean",
    fr: "/fantasy-world-building/environnement/mer-et-ocean",
    it: "/fantasy-world-building/ambiente/mare-e-oceano",
    es: "/fantasy-world-building/ambiente/mar-y-oceano",
    pl: "/budynek-swiata-fantasy/srodowisko/morze-i-ocean",
    cs: "/fantasy-world-building/zivotni-prostredi/more-a-ocean",
    nl: "/fantasiewereld-bouwen/omgeving/zee-en-oceaan",
    sv: "/fantasy-world-building/miljoe/hav-och-hav",
    no: "/fantasy-world-building/miljo/hav-og-hav",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/meri-ja-valtameri",
    da: "/fantasy-world-building/miljo/hav-og-hav",
    ru: "/zdanie-fantasticheskogo-mira/sreda/more-i-okean",
  },
  "/fantasy-world-building/environment/town": {
    de: "/fantasy-world-building/umfeld/stadt",
    en: "/fantasy-world-building/environment/town",
    fr: "/fantasy-world-building/environnement/ville",
    it: "/fantasy-world-building/ambiente/citta",
    es: "/fantasy-world-building/ambiente/ciudad",
    pl: "/budynek-swiata-fantasy/srodowisko/miasto",
    cs: "/fantasy-world-building/zivotni-prostredi/mesto",
    nl: "/fantasiewereld-bouwen/omgeving/dorp",
    sv: "/fantasy-world-building/miljoe/stad",
    no: "/fantasy-world-building/miljo/by",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/kaupunki",
    da: "/fantasy-world-building/miljo/by",
    ru: "/zdanie-fantasticheskogo-mira/sreda/gorod",
  },
  "/fantasy-world-building/environment/underwater-city": {
    de: "/fantasy-world-building/umfeld/unterwasserstadt",
    en: "/fantasy-world-building/environment/underwater-city",
    fr: "/fantasy-world-building/environnement/ville-sous-marine",
    it: "/fantasy-world-building/ambiente/citta-sottomarina",
    es: "/fantasy-world-building/ambiente/ciudad-submarina",
    pl: "/budynek-swiata-fantasy/srodowisko/podwodne-miasto",
    cs: "/fantasy-world-building/zivotni-prostredi/podvodni-mesto",
    nl: "/fantasiewereld-bouwen/omgeving/onderwater-stad",
    sv: "/fantasy-world-building/miljoe/undervattensstad",
    no: "/fantasy-world-building/miljo/undervannsby",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/vedenalainen-kaupunki",
    da: "/fantasy-world-building/miljo/undervandsby",
    ru: "/zdanie-fantasticheskogo-mira/sreda/podvodniy-gorod",
  },
  "/fantasy-world-building/environment/volcano": {
    de: "/fantasy-world-building/umfeld/vulkan",
    en: "/fantasy-world-building/environment/volcano",
    fr: "/fantasy-world-building/environnement/volcan",
    it: "/fantasy-world-building/ambiente/vulcano",
    es: "/fantasy-world-building/ambiente/volcan",
    pl: "/budynek-swiata-fantasy/srodowisko/wulkan",
    cs: "/fantasy-world-building/zivotni-prostredi/sopka",
    nl: "/fantasiewereld-bouwen/omgeving/vulkaan",
    sv: "/fantasy-world-building/miljoe/vulkan",
    no: "/fantasy-world-building/miljo/vulkan",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/tulivuori",
    da: "/fantasy-world-building/miljo/vulkan",
    ru: "/zdanie-fantasticheskogo-mira/sreda/vulkan",
  },
  "/fantasy-world-building/environment/world": {
    de: "/fantasy-world-building/umfeld/welt",
    en: "/fantasy-world-building/environment/world",
    fr: "/fantasy-world-building/environnement/monde",
    it: "/fantasy-world-building/ambiente/mondo",
    es: "/fantasy-world-building/ambiente/mundo",
    pl: "/budynek-swiata-fantasy/srodowisko/swiat",
    cs: "/fantasy-world-building/zivotni-prostredi/svet",
    nl: "/fantasiewereld-bouwen/omgeving/wereld",
    sv: "/fantasy-world-building/miljoe/vaerld",
    no: "/fantasy-world-building/miljo/verden",
    fi: "/fantasiamaailman-rakennus/ympaeristoe/maailman",
    da: "/fantasy-world-building/miljo/verden",
    ru: "/zdanie-fantasticheskogo-mira/sreda/mir",
  },
  "/fantasy-world-building/items/armor": {
    de: "/fantasy-world-building/gegenstaende/ruestung",
    en: "/fantasy-world-building/items/armor",
    fr: "/fantasy-world-building/articles/armure",
    it: "/fantasy-world-building/elementi/armatura",
    es: "/fantasy-world-building/elementos/armadura",
    pl: "/budynek-swiata-fantasy/rzeczy/zbroja",
    cs: "/fantasy-world-building/polozky/brneni",
    nl: "/fantasiewereld-bouwen/artikelen/schild",
    sv: "/fantasy-world-building/foeremal/rustning",
    no: "/fantasy-world-building/varer/rustning",
    fi: "/fantasiamaailman-rakennus/tuotteet/panssari",
    da: "/fantasy-world-building/genstande/rustning",
    ru: "/zdanie-fantasticheskogo-mira/predmety/bronya",
  },
  "/fantasy-world-building/items/artifact": {
    de: "/fantasy-world-building/gegenstaende/artefakt",
    en: "/fantasy-world-building/items/artifact",
    fr: "/fantasy-world-building/articles/artefact",
    it: "/fantasy-world-building/elementi/artefatto",
    es: "/fantasy-world-building/elementos/artefacto",
    pl: "/budynek-swiata-fantasy/rzeczy/artefakt",
    cs: "/fantasy-world-building/polozky/artefakt",
    nl: "/fantasiewereld-bouwen/artikelen/artefact",
    sv: "/fantasy-world-building/foeremal/artefakt",
    no: "/fantasy-world-building/varer/gjenstand",
    fi: "/fantasiamaailman-rakennus/tuotteet/esine",
    da: "/fantasy-world-building/genstande/artefakt",
    ru: "/zdanie-fantasticheskogo-mira/predmety/artefakt",
  },
  "/fantasy-world-building/items/bow-and-crossbow": {
    de: "/fantasy-world-building/gegenstaende/bogen-und-armbrust",
    en: "/fantasy-world-building/items/bow-and-crossbow",
    fr: "/fantasy-world-building/articles/arc-et-arbalete",
    it: "/fantasy-world-building/elementi/arco-e-balestra",
    es: "/fantasy-world-building/elementos/arco-y-ballesta",
    pl: "/budynek-swiata-fantasy/rzeczy/luk-i-kusza",
    cs: "/fantasy-world-building/polozky/luk-a-kuse",
    nl: "/fantasiewereld-bouwen/artikelen/boog-en-kruisboog",
    sv: "/fantasy-world-building/foeremal/pilbage-och-armborst",
    no: "/fantasy-world-building/varer/bue-og-armbrost",
    fi: "/fantasiamaailman-rakennus/tuotteet/jousi-ja-varsijousi",
    da: "/fantasy-world-building/genstande/bue-og-armbrost",
    ru: "/zdanie-fantasticheskogo-mira/predmety/luk-i-arbalet",
  },
  "/fantasy-world-building/items/magic-potion": {
    de: "/fantasy-world-building/gegenstaende/zaubertrank",
    en: "/fantasy-world-building/items/magic-potion",
    fr: "/fantasy-world-building/articles/potion-magique",
    it: "/fantasy-world-building/elementi/pozione-magica",
    es: "/fantasy-world-building/elementos/pocion-magica",
    pl: "/budynek-swiata-fantasy/rzeczy/magiczna-mikstura",
    cs: "/fantasy-world-building/polozky/magicky-lektvar",
    nl: "/fantasiewereld-bouwen/artikelen/magisch-drankje",
    sv: "/fantasy-world-building/foeremal/magisk-dryck",
    no: "/fantasy-world-building/varer/magisk-drikk",
    fi: "/fantasiamaailman-rakennus/tuotteet/taikajuoma",
    da: "/fantasy-world-building/genstande/trylledrik",
    ru: "/zdanie-fantasticheskogo-mira/predmety/volshebnoe-zele",
  },
  "/fantasy-world-building/items/magic-weapon": {
    de: "/fantasy-world-building/gegenstaende/magische-waffe",
    en: "/fantasy-world-building/items/magic-weapon",
    fr: "/fantasy-world-building/articles/arme-magique",
    it: "/fantasy-world-building/elementi/arma-magica",
    es: "/fantasy-world-building/elementos/arma-magica",
    pl: "/budynek-swiata-fantasy/rzeczy/magiczna-bron",
    cs: "/fantasy-world-building/polozky/magicka-zbran",
    nl: "/fantasiewereld-bouwen/artikelen/magisch-wapen",
    sv: "/fantasy-world-building/foeremal/magiskt-vapen",
    no: "/fantasy-world-building/varer/magisk-vapen",
    fi: "/fantasiamaailman-rakennus/tuotteet/taika-ase",
    da: "/fantasy-world-building/genstande/magisk-vaben",
    ru: "/zdanie-fantasticheskogo-mira/predmety/magicheskoe-oruzhie",
  },
  "/fantasy-world-building/items/scroll": {
    de: "/fantasy-world-building/gegenstaende/scrollen",
    en: "/fantasy-world-building/items/scroll",
    fr: "/fantasy-world-building/articles/faire-defiler",
    it: "/fantasy-world-building/elementi/scorrere",
    es: "/fantasy-world-building/elementos/desplazarse",
    pl: "/budynek-swiata-fantasy/rzeczy/zwoj",
    cs: "/fantasy-world-building/polozky/svitek",
    nl: "/fantasiewereld-bouwen/artikelen/rol",
    sv: "/fantasy-world-building/foeremal/skrolla",
    no: "/fantasy-world-building/varer/rull",
    fi: "/fantasiamaailman-rakennus/tuotteet/selaa",
    da: "/fantasy-world-building/genstande/rul",
    ru: "/zdanie-fantasticheskogo-mira/predmety/prokrutka",
  },
  "/fantasy-world-building/items/weapon": {
    de: "/fantasy-world-building/gegenstaende/waffe",
    en: "/fantasy-world-building/items/weapon",
    fr: "/fantasy-world-building/articles/arme",
    it: "/fantasy-world-building/elementi/arma",
    es: "/fantasy-world-building/elementos/arma",
    pl: "/budynek-swiata-fantasy/rzeczy/bron",
    cs: "/fantasy-world-building/polozky/zbran",
    nl: "/fantasiewereld-bouwen/artikelen/wapen",
    sv: "/fantasy-world-building/foeremal/vapen",
    no: "/fantasy-world-building/varer/vapen",
    fi: "/fantasiamaailman-rakennus/tuotteet/ase",
    da: "/fantasy-world-building/genstande/vaben",
    ru: "/zdanie-fantasticheskogo-mira/predmety/oruzhie",
  },
  "/fantasy-world-building/items/wizard-staff": {
    de: "/fantasy-world-building/gegenstaende/zaubererstab",
    en: "/fantasy-world-building/items/wizards-staff",
    fr: "/fantasy-world-building/articles/baton-du-sorcier",
    it: "/fantasy-world-building/elementi/bastone-del-mago",
    es: "/fantasy-world-building/elementos/baston-del-mago",
    pl: "/budynek-swiata-fantasy/rzeczy/kostur-czarodzieja",
    cs: "/fantasy-world-building/polozky/carodejova-hul",
    nl: "/fantasiewereld-bouwen/artikelen/tovenaarsstaf",
    sv: "/fantasy-world-building/foeremal/trollkarlens-personal",
    no: "/fantasy-world-building/varer/veiviserens-stab",
    fi: "/fantasiamaailman-rakennus/tuotteet/velhon-henkiloekunta",
    da: "/fantasy-world-building/genstande/wizards-staff",
    ru: "/zdanie-fantasticheskogo-mira/predmety/posokh-volshebnika",
  },
  "/fantasy-world-building/vehicles-and-vessels/airship": {
    de: "/fantasy-world-building/fahrzeuge-und-schiffe/luftschiff",
    en: "/fantasy-world-building/vehicles-and-vessels/airship",
    fr: "/fantasy-world-building/vehicules-et-navires/dirigeable",
    it: "/fantasy-world-building/veicoli-e-navi/dirigibile",
    es: "/fantasy-world-building/vehiculos-y-embarcaciones/dirigible",
    pl: "/budynek-swiata-fantasy/pojazdy-i-statki/sterowiec",
    cs: "/fantasy-world-building/vozidla-a-plavidla/vzducholod",
    nl: "/fantasiewereld-bouwen/voertuigen-en-schepen/luchtschip",
    sv: "/fantasy-world-building/fordon-och-fartyg/luftskepp",
    no: "/fantasy-world-building/kjoretoy-og-fartoy/luftskip",
    fi: "/fantasiamaailman-rakennus/ajoneuvot-ja-alukset/ilmalaiva",
    da: "/fantasy-world-building/koretojer-og-fartojer/luftskib",
    ru: "/zdanie-fantasticheskogo-mira/transportnye-sredstva-i-suda/dirizhabl",
  },
  "/fantasy-world-building/vehicles-and-vessels/pirate-ship": {
    de: "/fantasy-world-building/fahrzeuge-und-schiffe/piratenschiff",
    en: "/fantasy-world-building/vehicles-and-vessels/pirate-ship",
    fr: "/fantasy-world-building/vehicules-et-navires/navire-pirate",
    it: "/fantasy-world-building/veicoli-e-navi/nave-pirata",
    es: "/fantasy-world-building/vehiculos-y-embarcaciones/barco-pirata",
    pl: "/budynek-swiata-fantasy/pojazdy-i-statki/statek-piracki",
    cs: "/fantasy-world-building/vozidla-a-plavidla/piratska-lod",
    nl: "/fantasiewereld-bouwen/voertuigen-en-schepen/piratenschip",
    sv: "/fantasy-world-building/fordon-och-fartyg/pirat-skepp",
    no: "/fantasy-world-building/kjoretoy-og-fartoy/pirat-skip",
    fi: "/fantasiamaailman-rakennus/ajoneuvot-ja-alukset/merirosvolaiva",
    da: "/fantasy-world-building/koretojer-og-fartojer/piratskib",
    ru: "/zdanie-fantasticheskogo-mira/transportnye-sredstva-i-suda/piratskiy-korabl",
  },
  "/fantasy-world-building/vehicles-and-vessels/ship": {
    de: "/fantasy-world-building/fahrzeuge-und-schiffe/schiff",
    en: "/fantasy-world-building/vehicles-and-vessels/ship",
    fr: "/fantasy-world-building/vehicules-et-navires/bateau",
    it: "/fantasy-world-building/veicoli-e-navi/nave",
    es: "/fantasy-world-building/vehiculos-y-embarcaciones/barco",
    pl: "/budynek-swiata-fantasy/pojazdy-i-statki/statek",
    cs: "/fantasy-world-building/vozidla-a-plavidla/lod",
    nl: "/fantasiewereld-bouwen/voertuigen-en-schepen/schip",
    sv: "/fantasy-world-building/fordon-och-fartyg/fartyg",
    no: "/fantasy-world-building/kjoretoy-og-fartoy/skip",
    fi: "/fantasiamaailman-rakennus/ajoneuvot-ja-alukset/alus",
    da: "/fantasy-world-building/koretojer-og-fartojer/skib",
    ru: "/zdanie-fantasticheskogo-mira/transportnye-sredstva-i-suda/korabl",
  },
  "/fantasy-world-building/vehicles-and-vessels/spaceship": {
    de: "/fantasy-world-building/fahrzeuge-und-schiffe/raumschiff",
    en: "/fantasy-world-building/vehicles-and-vessels/spaceship",
    fr: "/fantasy-world-building/vehicules-et-navires/vaisseau-spatial",
    it: "/fantasy-world-building/veicoli-e-navi/navicella-spaziale",
    es: "/fantasy-world-building/vehiculos-y-embarcaciones/astronave",
    pl: "/budynek-swiata-fantasy/pojazdy-i-statki/statek-kosmiczny",
    cs: "/fantasy-world-building/vozidla-a-plavidla/kosmicka-lod",
    nl: "/fantasiewereld-bouwen/voertuigen-en-schepen/ruimteschip",
    sv: "/fantasy-world-building/fordon-och-fartyg/rymdskepp",
    no: "/fantasy-world-building/kjoretoy-og-fartoy/romskip",
    fi: "/fantasiamaailman-rakennus/ajoneuvot-ja-alukset/avaruusalus",
    da: "/fantasy-world-building/koretojer-og-fartojer/rumskib",
    ru: "/zdanie-fantasticheskogo-mira/transportnye-sredstva-i-suda/kosmicheskiy-korabl",
  },
  "/fantasy-world-building/vehicles-and-vessels/submarine": {
    de: "/fantasy-world-building/fahrzeuge-und-schiffe/u-boot",
    en: "/fantasy-world-building/vehicles-and-vessels/submarine",
    fr: "/fantasy-world-building/vehicules-et-navires/sous-marin",
    it: "/fantasy-world-building/veicoli-e-navi/sottomarino",
    es: "/fantasy-world-building/vehiculos-y-embarcaciones/submarino",
    pl: "/budynek-swiata-fantasy/pojazdy-i-statki/lodz-podwodna",
    cs: "/fantasy-world-building/vozidla-a-plavidla/ponorka",
    nl: "/fantasiewereld-bouwen/voertuigen-en-schepen/onderzeeer",
    sv: "/fantasy-world-building/fordon-och-fartyg/u-bat",
    no: "/fantasy-world-building/kjoretoy-og-fartoy/undervannsbat",
    fi: "/fantasiamaailman-rakennus/ajoneuvot-ja-alukset/sukellusvene",
    da: "/fantasy-world-building/koretojer-og-fartojer/undervandsbad",
    ru: "/zdanie-fantasticheskogo-mira/transportnye-sredstva-i-suda/podvodnaya-lodka",
  },
  "/fantasy-world-building/vehicles-and-vessels/time-machine": {
    de: "/fantasy-world-building/fahrzeuge-und-schiffe/zeitmaschine",
    en: "/fantasy-world-building/vehicles-and-vessels/time-machine",
    fr: "/fantasy-world-building/vehicules-et-navires/machine-a-remonter-le-temps",
    it: "/fantasy-world-building/veicoli-e-navi/macchina-del-tempo",
    es: "/fantasy-world-building/vehiculos-y-embarcaciones/maquina-del-tiempo",
    pl: "/budynek-swiata-fantasy/pojazdy-i-statki/wehikul-czasu",
    cs: "/fantasy-world-building/vozidla-a-plavidla/stroj-casu",
    nl: "/fantasiewereld-bouwen/voertuigen-en-schepen/tijd-machine",
    sv: "/fantasy-world-building/fordon-och-fartyg/tidsmaskin",
    no: "/fantasy-world-building/kjoretoy-og-fartoy/tidsmaskin",
    fi: "/fantasiamaailman-rakennus/ajoneuvot-ja-alukset/aikakone",
    da: "/fantasy-world-building/koretojer-og-fartojer/tidsmaskine",
    ru: "/zdanie-fantasticheskogo-mira/transportnye-sredstva-i-suda/mashina-vremeni",
  },
  "/fantasy-world-building/vehicles-and-vessels/train": {
    de: "/fantasy-world-building/fahrzeuge-und-schiffe/zug",
    en: "/fantasy-world-building/vehicles-and-vessels/train",
    fr: "/fantasy-world-building/vehicules-et-navires/former",
    it: "/fantasy-world-building/veicoli-e-navi/treno",
    es: "/fantasy-world-building/vehiculos-y-embarcaciones/tren",
    pl: "/budynek-swiata-fantasy/pojazdy-i-statki/pociag",
    cs: "/fantasy-world-building/vozidla-a-plavidla/vlak",
    nl: "/fantasiewereld-bouwen/voertuigen-en-schepen/trein",
    sv: "/fantasy-world-building/fordon-och-fartyg/tag",
    no: "/fantasy-world-building/kjoretoy-og-fartoy/tog",
    fi: "/fantasiamaailman-rakennus/ajoneuvot-ja-alukset/kouluttaa",
    da: "/fantasy-world-building/koretojer-og-fartojer/tog",
    ru: "/zdanie-fantasticheskogo-mira/transportnye-sredstva-i-suda/trenirovatsya",
  },
  "/dnd/a-c/aarakocra": {
    de: "/dnd/kreaturen-a-c/aarakocra",
    en: "/dnd/creatures-a-c/aarakocra",
    fr: "/dnd/creatures-ac/aarakocra",
    it: "/dnd/creature-a-c/aarakocra",
    es: "/dnd/criaturas-a-c/arakocra",
    pl: "/dnd/stworzenia-a-c/aarakokra",
    cs: "/dnd/bytosti-a-c/aarakocra",
    nl: "/dnd/wezens-a-c/aarakocra",
    sv: "/dnd/varelser-a-c/aarakocra",
    no: "/dnd/skapninger-a-c/aarakocra",
    fi: "/dnd/olennot-a-c/aarakocra",
    da: "/dnd/vaesner-a-c/aarakocra",
    ru: "/dnd/suschestva-ac/aarakokra",
  },
  "/dnd/a-c/aasimar": {
    de: "/dnd/kreaturen-a-c/aasimar",
    en: "/dnd/creatures-a-c/aasimar",
    fr: "/dnd/creatures-ac/aasimar",
    it: "/dnd/creature-a-c/aasimar",
    es: "/dnd/criaturas-a-c/aasimar",
    pl: "/dnd/stworzenia-a-c/aasimara",
    cs: "/dnd/bytosti-a-c/aasimar",
    nl: "/dnd/wezens-a-c/aasimar",
    sv: "/dnd/varelser-a-c/aasimar",
    no: "/dnd/skapninger-a-c/aasimar",
    fi: "/dnd/olennot-a-c/aasimar",
    da: "/dnd/vaesner-a-c/aasimar",
    ru: "/dnd/suschestva-ac/aasimar",
  },
  "/dnd/a-c/archfey": {
    de: "/dnd/kreaturen-a-c/archfey",
    en: "/dnd/creatures-a-c/archfey",
    fr: "/dnd/creatures-ac/archfee",
    it: "/dnd/creature-a-c/archfey",
    es: "/dnd/criaturas-a-c/archifey",
    pl: "/dnd/stworzenia-a-c/archfey-a",
    cs: "/dnd/bytosti-a-c/archfey",
    nl: "/dnd/wezens-a-c/archfey",
    sv: "/dnd/varelser-a-c/archfey",
    no: "/dnd/skapninger-a-c/archfey",
    fi: "/dnd/olennot-a-c/archfey",
    da: "/dnd/vaesner-a-c/archfey",
    ru: "/dnd/suschestva-ac/arkhfey",
  },
  "/dnd/a-c/black-dragon": {
    de: "/dnd/kreaturen-a-c/schwarzer-drache",
    en: "/dnd/creatures-a-c/black-dragon",
    fr: "/dnd/creatures-ac/dragon-noir",
    it: "/dnd/creature-a-c/drago-nero",
    es: "/dnd/criaturas-a-c/dragon-negro",
    pl: "/dnd/stworzenia-a-c/czarny-smok",
    cs: "/dnd/bytosti-a-c/cerny-drak",
    nl: "/dnd/wezens-a-c/zwarte-draak",
    sv: "/dnd/varelser-a-c/svart-drake",
    no: "/dnd/skapninger-a-c/svart-drage",
    fi: "/dnd/olennot-a-c/musta-lohikaeaerme",
    da: "/dnd/vaesner-a-c/sort-drage",
    ru: "/dnd/suschestva-ac/cherniy-drakon",
  },
  "/dnd/a-c/blue-dragon": {
    de: "/dnd/kreaturen-a-c/blauer-drache",
    en: "/dnd/creatures-a-c/blue-dragon",
    fr: "/dnd/creatures-ac/dragon-bleu",
    it: "/dnd/creature-a-c/drago-blu",
    es: "/dnd/criaturas-a-c/dragon-azul",
    pl: "/dnd/stworzenia-a-c/niebieski-smok",
    cs: "/dnd/bytosti-a-c/modry-drak",
    nl: "/dnd/wezens-a-c/blauwe-draak",
    sv: "/dnd/varelser-a-c/bla-drake",
    no: "/dnd/skapninger-a-c/bla-drage",
    fi: "/dnd/olennot-a-c/sininen-lohikaeaerme",
    da: "/dnd/vaesner-a-c/bla-drage",
    ru: "/dnd/suschestva-ac/siniy-drakon",
  },
  "/dnd/a-c/bronze-dragon": {
    de: "/dnd/kreaturen-a-c/bronzener-drache",
    en: "/dnd/creatures-a-c/bronze-dragon",
    fr: "/dnd/creatures-ac/dragon-de-bronze",
    it: "/dnd/creature-a-c/drago-di-bronzo",
    es: "/dnd/criaturas-a-c/dragon-de-bronce",
    pl: "/dnd/stworzenia-a-c/brazowy-smok",
    cs: "/dnd/bytosti-a-c/bronzovy-drak",
    nl: "/dnd/wezens-a-c/bronzen-draak",
    sv: "/dnd/varelser-a-c/bronsdrake",
    no: "/dnd/skapninger-a-c/bronsedrage",
    fi: "/dnd/olennot-a-c/pronssilohikaeaerme",
    da: "/dnd/vaesner-a-c/bronze-drage",
    ru: "/dnd/suschestva-ac/bronzoviy-drakon",
  },
  "/dnd/a-c/bugbear": {
    de: "/dnd/kreaturen-a-c/popanz",
    en: "/dnd/creatures-a-c/bugbear",
    fr: "/dnd/creatures-ac/epouvantail",
    it: "/dnd/creature-a-c/spauracchio",
    es: "/dnd/criaturas-a-c/pesadilla",
    pl: "/dnd/stworzenia-a-c/straszak",
    cs: "/dnd/bytosti-a-c/bugbear",
    nl: "/dnd/wezens-a-c/bugbeer",
    sv: "/dnd/varelser-a-c/buse",
    no: "/dnd/skapninger-a-c/bugbear",
    fi: "/dnd/olennot-a-c/bugbear",
    da: "/dnd/vaesner-a-c/bugbear",
    ru: "/dnd/suschestva-ac/bagber",
  },
  "/dnd/a-c/centaur": {
    de: "/dnd/kreaturen-a-c/zentaur",
    en: "/dnd/creatures-a-c/centaur",
    fr: "/dnd/creatures-ac/centaure",
    it: "/dnd/creature-a-c/centauro",
    es: "/dnd/criaturas-a-c/centauro",
    pl: "/dnd/stworzenia-a-c/centaur",
    cs: "/dnd/bytosti-a-c/kentaur",
    nl: "/dnd/wezens-a-c/centaur",
    sv: "/dnd/varelser-a-c/centaur",
    no: "/dnd/skapninger-a-c/kentaur",
    fi: "/dnd/olennot-a-c/kentauri",
    da: "/dnd/vaesner-a-c/kentaur",
    ru: "/dnd/suschestva-ac/kentavr",
  },
  "/dnd/a-c/changeling": {
    de: "/dnd/kreaturen-a-c/wechselbalg",
    en: "/dnd/creatures-a-c/changeling",
    fr: "/dnd/creatures-ac/changelin",
    it: "/dnd/creature-a-c/cambiamento",
    es: "/dnd/criaturas-a-c/cambiante",
    pl: "/dnd/stworzenia-a-c/odmieniec",
    cs: "/dnd/bytosti-a-c/meneni",
    nl: "/dnd/wezens-a-c/wisselaar",
    sv: "/dnd/varelser-a-c/bortbyting",
    no: "/dnd/skapninger-a-c/bytter",
    fi: "/dnd/olennot-a-c/vaihdokas",
    da: "/dnd/vaesner-a-c/a-endring",
    ru: "/dnd/suschestva-ac/podmenysh",
  },
  "/dnd/d-f/deep-gnome": {
    de: "/dnd/kreaturen-d-f/tiefer-gnom",
    en: "/dnd/creatures-d-f/deep-gnome",
    fr: "/dnd/creatures-df/gnome-profond",
    it: "/dnd/creature-d-f/gnomo-delle-profondita",
    es: "/dnd/criaturas-d-f/gnomo-profundo",
    pl: "/dnd/stworzenia-d-f/gleboki-gnom",
    cs: "/dnd/tvorove-d-f/hluboky-gnome",
    nl: "/dnd/wezens-d-f/diepe-kabouter",
    sv: "/dnd/varelser-d-f/deep-gnome",
    no: "/dnd/skapninger-d-f/deep-gnome",
    fi: "/dnd/olennot-d-f/deep-gnome",
    da: "/dnd/vaesner-d-f/deep-gnome",
    ru: "/dnd/suschestva-d-f/glubinniy-gnom",
  },
  "/dnd/d-f/demon-lord": {
    de: "/dnd/kreaturen-d-f/daemonenlord",
    en: "/dnd/creatures-d-f/demon-lord",
    fr: "/dnd/creatures-df/seigneur-demon",
    it: "/dnd/creature-d-f/signore-dei-demoni",
    es: "/dnd/criaturas-d-f/senor-demonio",
    pl: "/dnd/stworzenia-d-f/wladca-demonow",
    cs: "/dnd/tvorove-d-f/pan-demonu",
    nl: "/dnd/wezens-d-f/demonen-heer",
    sv: "/dnd/varelser-d-f/demon-haerskare",
    no: "/dnd/skapninger-d-f/demon-herre",
    fi: "/dnd/olennot-d-f/demon-lord",
    da: "/dnd/vaesner-d-f/daemon-herre",
    ru: "/dnd/suschestva-d-f/povelitel-demonov",
  },
  "/dnd/d-f/dragonborn": {
    de: "/dnd/kreaturen-d-f/drachengeborenes",
    en: "/dnd/creatures-d-f/dragonborn",
    fr: "/dnd/creatures-df/enfant-de-dragon",
    it: "/dnd/creature-d-f/sangue-di-drago",
    es: "/dnd/criaturas-d-f/nacido-de-dragon",
    pl: "/dnd/stworzenia-d-f/zrodzony-ze-smoka",
    cs: "/dnd/tvorove-d-f/dragonborn",
    nl: "/dnd/wezens-d-f/draakgeboren",
    sv: "/dnd/varelser-d-f/dragonborn",
    no: "/dnd/skapninger-d-f/dragonborn",
    fi: "/dnd/olennot-d-f/dragonborn",
    da: "/dnd/vaesner-d-f/dragonborn",
    ru: "/dnd/suschestva-d-f/drakonorozhdenniy",
  },
  "/dnd/d-f/drow": {
    de: "/dnd/kreaturen-d-f/drow",
    en: "/dnd/creatures-d-f/drow",
    fr: "/dnd/creatures-df/drow",
    it: "/dnd/creature-d-f/drow",
    es: "/dnd/criaturas-d-f/drow",
    pl: "/dnd/stworzenia-d-f/drow",
    cs: "/dnd/tvorove-d-f/drow",
    nl: "/dnd/wezens-d-f/droeg",
    sv: "/dnd/varelser-d-f/drow",
    no: "/dnd/skapninger-d-f/drow",
    fi: "/dnd/olennot-d-f/drow",
    da: "/dnd/vaesner-d-f/drow",
    ru: "/dnd/suschestva-d-f/drou",
  },
  "/dnd/d-f/duergar": {
    de: "/dnd/kreaturen-d-f/duergar",
    en: "/dnd/creatures-d-f/duergar",
    fr: "/dnd/creatures-df/duergar",
    it: "/dnd/creature-d-f/duergar",
    es: "/dnd/criaturas-d-f/duergar",
    pl: "/dnd/stworzenia-d-f/duergara",
    cs: "/dnd/tvorove-d-f/duergar",
    nl: "/dnd/wezens-d-f/duergar",
    sv: "/dnd/varelser-d-f/duergar",
    no: "/dnd/skapninger-d-f/duergar",
    fi: "/dnd/olennot-d-f/duergar",
    da: "/dnd/vaesner-d-f/duergar",
    ru: "/dnd/suschestva-d-f/duergar",
  },
  "/dnd/d-f/dwarf": {
    de: "/dnd/kreaturen-d-f/zwerg",
    en: "/dnd/creatures-d-f/dwarf",
    fr: "/dnd/creatures-df/nain",
    it: "/dnd/creature-d-f/nano",
    es: "/dnd/criaturas-d-f/enano",
    pl: "/dnd/stworzenia-d-f/krasnolud",
    cs: "/dnd/tvorove-d-f/trpaslik",
    nl: "/dnd/wezens-d-f/dwerg",
    sv: "/dnd/varelser-d-f/dvaerg",
    no: "/dnd/skapninger-d-f/dverg",
    fi: "/dnd/olennot-d-f/kaeaepioe",
    da: "/dnd/vaesner-d-f/dvaerg",
    ru: "/dnd/suschestva-d-f/karlik",
  },
  "/dnd/d-f/eladrin": {
    de: "/dnd/kreaturen-d-f/eladrin",
    en: "/dnd/creatures-d-f/eladrin",
    fr: "/dnd/creatures-df/eladrine",
    it: "/dnd/creature-d-f/eladrin",
    es: "/dnd/criaturas-d-f/eladrin",
    pl: "/dnd/stworzenia-d-f/eladrin",
    cs: "/dnd/tvorove-d-f/eladrin",
    nl: "/dnd/wezens-d-f/eladrin",
    sv: "/dnd/varelser-d-f/eladrin",
    no: "/dnd/skapninger-d-f/eladrin",
    fi: "/dnd/olennot-d-f/eladrin",
    da: "/dnd/vaesner-d-f/eladrin",
    ru: "/dnd/suschestva-d-f/eladrin",
  },
  "/dnd/d-f/elf": {
    de: "/dnd/kreaturen-d-f/elf",
    en: "/dnd/creatures-d-f/elf",
    fr: "/dnd/creatures-df/elfe",
    it: "/dnd/creature-d-f/elfo",
    es: "/dnd/criaturas-d-f/duende",
    pl: "/dnd/stworzenia-d-f/elf",
    cs: "/dnd/tvorove-d-f/elf",
    nl: "/dnd/wezens-d-f/elf",
    sv: "/dnd/varelser-d-f/aelva",
    no: "/dnd/skapninger-d-f/alv",
    fi: "/dnd/olennot-d-f/elf",
    da: "/dnd/vaesner-d-f/nisse",
    ru: "/dnd/suschestva-d-f/elf",
  },
  "/dnd/d-f/fairy": {
    de: "/dnd/kreaturen-d-f/fee",
    en: "/dnd/creatures-d-f/fairy",
    fr: "/dnd/creatures-df/fee",
    it: "/dnd/creature-d-f/fata",
    es: "/dnd/criaturas-d-f/hada",
    pl: "/dnd/stworzenia-d-f/wrozka",
    cs: "/dnd/tvorove-d-f/vila",
    nl: "/dnd/wezens-d-f/fee",
    sv: "/dnd/varelser-d-f/fe",
    no: "/dnd/skapninger-d-f/fe",
    fi: "/dnd/olennot-d-f/keiju",
    da: "/dnd/vaesner-d-f/fe",
    ru: "/dnd/suschestva-d-f/skazochniy",
  },
  "/dnd/d-f/firbolg": {
    de: "/dnd/kreaturen-d-f/firbolg",
    en: "/dnd/creatures-d-f/firbolg",
    fr: "/dnd/creatures-df/firbolg",
    it: "/dnd/creature-d-f/firbolg",
    es: "/dnd/criaturas-d-f/firbolg",
    pl: "/dnd/stworzenia-d-f/firbolg",
    cs: "/dnd/tvorove-d-f/firbolg",
    nl: "/dnd/wezens-d-f/firbolg",
    sv: "/dnd/varelser-d-f/firbolg",
    no: "/dnd/skapninger-d-f/firbolg",
    fi: "/dnd/olennot-d-f/firbolg",
    da: "/dnd/vaesner-d-f/firbolg",
    ru: "/dnd/suschestva-d-f/firbolg",
  },
  "/dnd/g-i/genasi": {
    de: "/dnd/kreaturen-g-i/genasi",
    en: "/dnd/creatures-g-i/genasi",
    fr: "/dnd/creatures-gi/genasi",
    it: "/dnd/creature-g-i/genasi",
    es: "/dnd/criaturas-g-i/genasi",
    pl: "/dnd/stworzenia-g-i/genasi",
    cs: "/dnd/tvorove-g-i/genasi",
    nl: "/dnd/wezens-g-i/genasi",
    sv: "/dnd/varelser-g-i/genasi",
    no: "/dnd/skapninger-g-i/genasi",
    fi: "/dnd/olennot-g-i/genasi",
    da: "/dnd/vaesner-g-i/genasi",
    ru: "/dnd/suschestva/genasi",
  },
  "/dnd/g-i/giant": {
    de: "/dnd/kreaturen-g-i/riese",
    en: "/dnd/creatures-g-i/giant",
    fr: "/dnd/creatures-gi/geant",
    it: "/dnd/creature-g-i/gigante",
    es: "/dnd/criaturas-g-i/gigante",
    pl: "/dnd/stworzenia-g-i/ogromny",
    cs: "/dnd/tvorove-g-i/obri",
    nl: "/dnd/wezens-g-i/reusachtig",
    sv: "/dnd/varelser-g-i/jaette",
    no: "/dnd/skapninger-g-i/kjempe",
    fi: "/dnd/olennot-g-i/jaettilaeinen",
    da: "/dnd/vaesner-g-i/kaempe-stor",
    ru: "/dnd/suschestva/gigant",
  },
  "/dnd/g-i/githyanki": {
    de: "/dnd/kreaturen-g-i/githyanki",
    en: "/dnd/creatures-g-i/githyanki",
    fr: "/dnd/creatures-gi/githyanki",
    it: "/dnd/creature-g-i/githyanki",
    es: "/dnd/criaturas-g-i/githyanki",
    pl: "/dnd/stworzenia-g-i/githyanki",
    cs: "/dnd/tvorove-g-i/githyanki",
    nl: "/dnd/wezens-g-i/githyanki",
    sv: "/dnd/varelser-g-i/githyanki",
    no: "/dnd/skapninger-g-i/githyanki",
    fi: "/dnd/olennot-g-i/githyanki",
    da: "/dnd/vaesner-g-i/githyanki",
    ru: "/dnd/suschestva/gityanki",
  },
  "/dnd/g-i/gnome": {
    de: "/dnd/kreaturen-g-i/gnom",
    en: "/dnd/creatures-g-i/gnome",
    fr: "/dnd/creatures-gi/gnome",
    it: "/dnd/creature-g-i/gnomo",
    es: "/dnd/criaturas-g-i/gnomo",
    pl: "/dnd/stworzenia-g-i/gnom",
    cs: "/dnd/tvorove-g-i/gnome",
    nl: "/dnd/wezens-g-i/kabouter",
    sv: "/dnd/varelser-g-i/gnome",
    no: "/dnd/skapninger-g-i/gnome",
    fi: "/dnd/olennot-g-i/gnome",
    da: "/dnd/vaesner-g-i/gnome",
    ru: "/dnd/suschestva/gnom",
  },
  "/dnd/g-i/goblin": {
    de: "/dnd/kreaturen-g-i/kobold",
    en: "/dnd/creatures-g-i/goblin",
    fr: "/dnd/creatures-gi/lutin",
    it: "/dnd/creature-g-i/goblin",
    es: "/dnd/criaturas-g-i/duende",
    pl: "/dnd/stworzenia-g-i/chochlik",
    cs: "/dnd/tvorove-g-i/sotek",
    nl: "/dnd/wezens-g-i/goblin",
    sv: "/dnd/varelser-g-i/troll",
    no: "/dnd/skapninger-g-i/goblin",
    fi: "/dnd/olennot-g-i/hiisi",
    da: "/dnd/vaesner-g-i/goblin",
    ru: "/dnd/suschestva/goblin",
  },
  "/dnd/g-i/gold-dragon": {
    de: "/dnd/kreaturen-g-i/golddrache",
    en: "/dnd/creatures-g-i/gold-dragon",
    fr: "/dnd/creatures-gi/dragon-d-or",
    it: "/dnd/creature-g-i/drago-d-oro",
    es: "/dnd/criaturas-g-i/dragon-dorado",
    pl: "/dnd/stworzenia-g-i/zloty-smok",
    cs: "/dnd/tvorove-g-i/zlaty-drak",
    nl: "/dnd/wezens-g-i/gouden-draak",
    sv: "/dnd/varelser-g-i/guld-drake",
    no: "/dnd/skapninger-g-i/gull-drage",
    fi: "/dnd/olennot-g-i/kultainen-lohikaeaerme",
    da: "/dnd/vaesner-g-i/guld-drage",
    ru: "/dnd/suschestva/zolotoy-drakon",
  },
  "/dnd/g-i/goliath": {
    de: "/dnd/kreaturen-g-i/goliath",
    en: "/dnd/creatures-g-i/goliath",
    fr: "/dnd/creatures-gi/goliath",
    it: "/dnd/creature-g-i/golia",
    es: "/dnd/criaturas-g-i/goliat",
    pl: "/dnd/stworzenia-g-i/goliat",
    cs: "/dnd/tvorove-g-i/golias",
    nl: "/dnd/wezens-g-i/goliath",
    sv: "/dnd/varelser-g-i/goliat",
    no: "/dnd/skapninger-g-i/goliat",
    fi: "/dnd/olennot-g-i/goljat",
    da: "/dnd/vaesner-g-i/goliat",
    ru: "/dnd/suschestva/goliaf",
  },
  "/dnd/g-i/green-dragon": {
    de: "/dnd/kreaturen-g-i/gruener-drache",
    en: "/dnd/creatures-g-i/green-dragon",
    fr: "/dnd/creatures-gi/dragon-vert",
    it: "/dnd/creature-g-i/dragone-verde",
    es: "/dnd/criaturas-g-i/dragon-verde",
    pl: "/dnd/stworzenia-g-i/zielony-smok",
    cs: "/dnd/tvorove-g-i/zeleny-drak",
    nl: "/dnd/wezens-g-i/groene-draak",
    sv: "/dnd/varelser-g-i/groen-drake",
    no: "/dnd/skapninger-g-i/gronn-drage",
    fi: "/dnd/olennot-g-i/vihreae-lohikaeaerme",
    da: "/dnd/vaesner-g-i/gron-drage",
    ru: "/dnd/suschestva/zeleniy-drakon",
  },
  "/dnd/g-i/grung": {
    de: "/dnd/kreaturen-g-i/grung",
    en: "/dnd/creatures-g-i/grung",
    fr: "/dnd/creatures-gi/grunge",
    it: "/dnd/creature-g-i/grung",
    es: "/dnd/criaturas-g-i/grunge",
    pl: "/dnd/stworzenia-g-i/grung",
    cs: "/dnd/tvorove-g-i/grung",
    nl: "/dnd/wezens-g-i/grung",
    sv: "/dnd/varelser-g-i/grung",
    no: "/dnd/skapninger-g-i/grung",
    fi: "/dnd/olennot-g-i/grung",
    da: "/dnd/vaesner-g-i/grung",
    ru: "/dnd/suschestva/grung",
  },
  "/dnd/g-i/half-elf": {
    de: "/dnd/kreaturen-g-i/halbelf",
    en: "/dnd/creatures-g-i/half-elf",
    fr: "/dnd/creatures-gi/demi-elfe",
    it: "/dnd/creature-g-i/mezzelfo",
    es: "/dnd/criaturas-g-i/semielfo",
    pl: "/dnd/stworzenia-g-i/pol-elf",
    cs: "/dnd/tvorove-g-i/pulelf",
    nl: "/dnd/wezens-g-i/half-elf",
    sv: "/dnd/varelser-g-i/halv-elf",
    no: "/dnd/skapninger-g-i/halv-elf",
    fi: "/dnd/olennot-g-i/puolitonttu",
    da: "/dnd/vaesner-g-i/halv-elver",
    ru: "/dnd/suschestva/poluelf",
  },
  "/dnd/g-i/half-orc": {
    de: "/dnd/kreaturen-g-i/halb-ork",
    en: "/dnd/creatures-g-i/half-orc",
    fr: "/dnd/creatures-gi/demi-orque",
    it: "/dnd/creature-g-i/mezzorco",
    es: "/dnd/criaturas-g-i/semiorco",
    pl: "/dnd/stworzenia-g-i/pol-ork",
    cs: "/dnd/tvorove-g-i/pulskret",
    nl: "/dnd/wezens-g-i/half-orc",
    sv: "/dnd/varelser-g-i/halv-orc",
    no: "/dnd/skapninger-g-i/halv-ork",
    fi: "/dnd/olennot-g-i/puoliorkki",
    da: "/dnd/vaesner-g-i/halv-orc",
    ru: "/dnd/suschestva/poluork",
  },
  "/dnd/g-i/halfling": {
    de: "/dnd/kreaturen-g-i/halbling",
    en: "/dnd/creatures-g-i/halfling",
    fr: "/dnd/creatures-gi/halfelin",
    it: "/dnd/creature-g-i/mezzuomo",
    es: "/dnd/criaturas-g-i/mediano",
    pl: "/dnd/stworzenia-g-i/niziolek",
    cs: "/dnd/tvorove-g-i/pulcik",
    nl: "/dnd/wezens-g-i/halfling",
    sv: "/dnd/varelser-g-i/halvning",
    no: "/dnd/skapninger-g-i/halvering",
    fi: "/dnd/olennot-g-i/puolittuva",
    da: "/dnd/vaesner-g-i/halvering",
    ru: "/dnd/suschestva/khalfling",
  },
  "/dnd/g-i/harengon": {
    de: "/dnd/kreaturen-g-i/harengon",
    en: "/dnd/creatures-g-i/harengon",
    fr: "/dnd/creatures-gi/harengon",
    it: "/dnd/creature-g-i/harengon",
    es: "/dnd/criaturas-g-i/harengon",
    pl: "/dnd/stworzenia-g-i/harengon",
    cs: "/dnd/tvorove-g-i/harengon",
    nl: "/dnd/wezens-g-i/harengon",
    sv: "/dnd/varelser-g-i/harengon",
    no: "/dnd/skapninger-g-i/harengon",
    fi: "/dnd/olennot-g-i/harengon",
    da: "/dnd/vaesner-g-i/harengon",
    ru: "/dnd/suschestva/kharengon",
  },
  "/dnd/g-i/hobgoblin": {
    de: "/dnd/kreaturen-g-i/kobold",
    en: "/dnd/creatures-g-i/hobgoblin",
    fr: "/dnd/creatures-gi/lutin",
    it: "/dnd/creature-g-i/hobgoblin",
    es: "/dnd/criaturas-g-i/duende",
    pl: "/dnd/stworzenia-g-i/chochlik",
    cs: "/dnd/tvorove-g-i/skritek",
    nl: "/dnd/wezens-g-i/kobold",
    sv: "/dnd/varelser-g-i/troll",
    no: "/dnd/skapninger-g-i/hobgoblin",
    fi: "/dnd/olennot-g-i/peikko",
    da: "/dnd/vaesner-g-i/hobgoblin",
    ru: "/dnd/suschestva/khobgoblin",
  },
  "/dnd/g-i/human": {
    de: "/dnd/kreaturen-g-i/menschlich",
    en: "/dnd/creatures-g-i/human",
    fr: "/dnd/creatures-gi/humain",
    it: "/dnd/creature-g-i/umano",
    es: "/dnd/criaturas-g-i/humano",
    pl: "/dnd/stworzenia-g-i/czlowiek",
    cs: "/dnd/tvorove-g-i/clovek",
    nl: "/dnd/wezens-g-i/menselijk",
    sv: "/dnd/varelser-g-i/maensklig",
    no: "/dnd/skapninger-g-i/menneskelig",
    fi: "/dnd/olennot-g-i/ihmisen",
    da: "/dnd/vaesner-g-i/human",
    ru: "/dnd/suschestva/chelovek",
  },
  "/dnd/j-l/kalashtar": {
    de: "/dnd/kreaturen-j-l/kalaschtar",
    en: "/dnd/creatures-j-l/kalashtar",
    fr: "/dnd/creatures-j-l/kalashtar",
    it: "/dnd/creature-j-l/kalashtar",
    es: "/dnd/criaturas-j-l/kalashtar",
    pl: "/dnd/stworzenia-j-l/kalasztar",
    cs: "/dnd/bytosti-j-l/kalastar",
    nl: "/dnd/wezens-j-l/kalashtar",
    sv: "/dnd/varelser-j-l/kalashtar",
    no: "/dnd/skapninger-j-l/kalashtar",
    fi: "/dnd/olennot-j-l/kalashtar",
    da: "/dnd/vaesner-j-l/kalashtar",
    ru: "/dnd/suschestva-dzhey-el/kalashtar",
  },
  "/dnd/j-l/kenku": {
    de: "/dnd/kreaturen-j-l/kenku",
    en: "/dnd/creatures-j-l/kenku",
    fr: "/dnd/creatures-j-l/kenku",
    it: "/dnd/creature-j-l/kenku",
    es: "/dnd/criaturas-j-l/kenku",
    pl: "/dnd/stworzenia-j-l/kenku",
    cs: "/dnd/bytosti-j-l/kenku",
    nl: "/dnd/wezens-j-l/kenku",
    sv: "/dnd/varelser-j-l/kenku",
    no: "/dnd/skapninger-j-l/kenku",
    fi: "/dnd/olennot-j-l/kenku",
    da: "/dnd/vaesner-j-l/kenku",
    ru: "/dnd/suschestva-dzhey-el/kenku",
  },
  "/dnd/j-l/kobold": {
    de: "/dnd/kreaturen-j-l/kobold",
    en: "/dnd/creatures-j-l/kobold",
    fr: "/dnd/creatures-j-l/kobold",
    it: "/dnd/creature-j-l/folletto",
    es: "/dnd/criaturas-j-l/kobold",
    pl: "/dnd/stworzenia-j-l/kobold",
    cs: "/dnd/bytosti-j-l/kobold",
    nl: "/dnd/wezens-j-l/kobold",
    sv: "/dnd/varelser-j-l/kobold",
    no: "/dnd/skapninger-j-l/kobold",
    fi: "/dnd/olennot-j-l/kobold",
    da: "/dnd/vaesner-j-l/kobold",
    ru: "/dnd/suschestva-dzhey-el/kobold",
  },
  "/dnd/j-l/leonin": {
    de: "/dnd/kreaturen-j-l/leonin",
    en: "/dnd/creatures-j-l/leonin",
    fr: "/dnd/creatures-j-l/leonin",
    it: "/dnd/creature-j-l/leonin",
    es: "/dnd/criaturas-j-l/leonina",
    pl: "/dnd/stworzenia-j-l/leonina",
    cs: "/dnd/bytosti-j-l/leonin",
    nl: "/dnd/wezens-j-l/leonin",
    sv: "/dnd/varelser-j-l/leonin",
    no: "/dnd/skapninger-j-l/leonin",
    fi: "/dnd/olennot-j-l/leonin",
    da: "/dnd/vaesner-j-l/leonin",
    ru: "/dnd/suschestva-dzhey-el/leonin",
  },
  "/dnd/j-l/loxodon": {
    de: "/dnd/kreaturen-j-l/loxodon",
    en: "/dnd/creatures-j-l/loxodon",
    fr: "/dnd/creatures-j-l/loxodon",
    it: "/dnd/creature-j-l/lossodonte",
    es: "/dnd/criaturas-j-l/loxodon",
    pl: "/dnd/stworzenia-j-l/loxodon",
    cs: "/dnd/bytosti-j-l/loxodon",
    nl: "/dnd/wezens-j-l/loxodon",
    sv: "/dnd/varelser-j-l/loxodon",
    no: "/dnd/skapninger-j-l/loxodon",
    fi: "/dnd/olennot-j-l/loxodon",
    da: "/dnd/vaesner-j-l/loxodon",
    ru: "/dnd/suschestva-dzhey-el/loksodon",
  },
  "/dnd/m-o/mind-flayer": {
    de: "/dnd/kreaturen-m-o/gedankenschinder",
    en: "/dnd/creatures-m-o/mind-flayer",
    fr: "/dnd/creatures-m-o/flagelleur-mental",
    it: "/dnd/creature-m-o/mind-flayer",
    es: "/dnd/criaturas-mo/desollador-mental",
    pl: "/dnd/stworzenia-m-o/lupiezca-umyslow",
    cs: "/dnd/tvorove-m-o/mysl-flayer",
    nl: "/dnd/wezens-m-o/mind-flayer",
    sv: "/dnd/varelser-m-o/mind-flayer",
    no: "/dnd/skapninger-m-o/mind-flayer",
    fi: "/dnd/olennot-m-o/mielen-flayer",
    da: "/dnd/vaesner-m-o/mind-flayer",
    ru: "/dnd/suschestva-m-o/svezhevatel-razuma",
  },
  "/dnd/m-o/orc": {
    de: "/dnd/kreaturen-m-o/ork",
    en: "/dnd/creatures-m-o/orc",
    fr: "/dnd/creatures-m-o/orque",
    it: "/dnd/creature-m-o/orco",
    es: "/dnd/criaturas-mo/orco",
    pl: "/dnd/stworzenia-m-o/ork",
    cs: "/dnd/tvorove-m-o/orc",
    nl: "/dnd/wezens-m-o/ork",
    sv: "/dnd/varelser-m-o/orc",
    no: "/dnd/skapninger-m-o/orc",
    fi: "/dnd/olennot-m-o/orc",
    da: "/dnd/vaesner-m-o/orc",
    ru: "/dnd/suschestva-m-o/ork",
  },
  "/dnd/p-r/red-dragon": {
    de: "/dnd/kreaturen-p-r/roter-drache",
    en: "/dnd/creatures-p-r/red-dragon",
    fr: "/dnd/creatures-p-r/dragon-rouge",
    it: "/dnd/creature-p-r/drago-rosso",
    es: "/dnd/criaturas-p-r/dragon-rojo",
    pl: "/dnd/stworzenia-p-r/czerwony-smok",
    cs: "/dnd/tvorove-p-r/cerveny-drak",
    nl: "/dnd/wezens-p-r/rode-draak",
    sv: "/dnd/varelser-p-r/roed-drake",
    no: "/dnd/skapninger-p-r/rod-drage",
    fi: "/dnd/olennot-p-r/punainen-lohikaeaerme",
    da: "/dnd/vaesner-p-r/rod-drage",
    ru: "/dnd/suschestva/krasniy-drakon",
  },
  "/dnd/p-r/satyr": {
    de: "/dnd/kreaturen-p-r/satyr",
    en: "/dnd/creatures-p-r/satyr",
    fr: "/dnd/creatures-p-r/satyre",
    it: "/dnd/creature-p-r/satiro",
    es: "/dnd/criaturas-p-r/satiro",
    pl: "/dnd/stworzenia-p-r/satyr",
    cs: "/dnd/tvorove-p-r/satyr",
    nl: "/dnd/wezens-p-r/sater",
    sv: "/dnd/varelser-p-r/satyr",
    no: "/dnd/skapninger-p-r/satyr",
    fi: "/dnd/olennot-p-r/satyyri",
    da: "/dnd/vaesner-p-r/satyr",
    ru: "/dnd/suschestva/satir",
  },
  "/dnd/p-r/shadar-kai": {
    de: "/dnd/kreaturen-p-r/shadar-kai",
    en: "/dnd/creatures-p-r/shadar-kai",
    fr: "/dnd/creatures-p-r/shadar-kai",
    it: "/dnd/creature-p-r/shadar-kai",
    es: "/dnd/criaturas-p-r/shadar-kai",
    pl: "/dnd/stworzenia-p-r/shadar-kai",
    cs: "/dnd/tvorove-p-r/shadar-kai",
    nl: "/dnd/wezens-p-r/shadar-kai",
    sv: "/dnd/varelser-p-r/shadar-kai",
    no: "/dnd/skapninger-p-r/shadar-kai",
    fi: "/dnd/olennot-p-r/shadar-kai",
    da: "/dnd/vaesner-p-r/shadar-kai",
    ru: "/dnd/suschestva/shadar-kay",
  },
  "/dnd/p-r/shifter": {
    de: "/dnd/kreaturen-p-r/schalthebel",
    en: "/dnd/creatures-p-r/shifter",
    fr: "/dnd/creatures-p-r/manette-de-vitesse",
    it: "/dnd/creature-p-r/cambio",
    es: "/dnd/criaturas-p-r/palanca-de-cambios",
    pl: "/dnd/stworzenia-p-r/zmieniacz",
    cs: "/dnd/tvorove-p-r/prehazovacka",
    nl: "/dnd/wezens-p-r/versteller",
    sv: "/dnd/varelser-p-r/vaexlare",
    no: "/dnd/skapninger-p-r/shifter",
    fi: "/dnd/olennot-p-r/vaihde",
    da: "/dnd/vaesner-p-r/skifter",
    ru: "/dnd/suschestva/pereklyuchatel",
  },
  "/dnd/s-u/silver-dragon": {
    de: "/dnd/kreaturen-s-u/silberdrache",
    en: "/dnd/creatures-s-u/silver-dragon",
    fr: "/dnd/creatures-s-u/dragon-d-argent",
    it: "/dnd/creature-s-u/drago-d-argento",
    es: "/dnd/criaturas-s-u/dragon-plateado",
    pl: "/dnd/stworzenia-s-u/srebrny-smok",
    cs: "/dnd/bytosti-s-u/stribrny-drak",
    nl: "/dnd/wezens-s-u/zilveren-draak",
    sv: "/dnd/varelser-s-u/silverdrake",
    no: "/dnd/skapninger-s-u/solv-drage",
    fi: "/dnd/olennot-s-u/hopea-lohikaeaerme",
    da: "/dnd/vaesner-s-u/solv-drage",
    ru: "/dnd/suschestva-s-u/serebryaniy-drakon",
  },
  "/dnd/s-u/tabaxi": {
    de: "/dnd/kreaturen-s-u/tabaxi",
    en: "/dnd/creatures-s-u/tabaxi",
    fr: "/dnd/creatures-s-u/tabaxi",
    it: "/dnd/creature-s-u/tabaxi",
    es: "/dnd/criaturas-s-u/tabaxi",
    pl: "/dnd/stworzenia-s-u/tabaxi",
    cs: "/dnd/bytosti-s-u/tabaxi",
    nl: "/dnd/wezens-s-u/tabaxi",
    sv: "/dnd/varelser-s-u/tabaxi",
    no: "/dnd/skapninger-s-u/tabaxi",
    fi: "/dnd/olennot-s-u/tabaxi",
    da: "/dnd/vaesner-s-u/tabaxi",
    ru: "/dnd/suschestva-s-u/tabaksi",
  },
  "/dnd/s-u/tiefling": {
    de: "/dnd/kreaturen-s-u/tiefling",
    en: "/dnd/creatures-s-u/tiefling",
    fr: "/dnd/creatures-s-u/tieffelin",
    it: "/dnd/creature-s-u/tiefling",
    es: "/dnd/criaturas-s-u/tiflin",
    pl: "/dnd/stworzenia-s-u/diabelstwo",
    cs: "/dnd/bytosti-s-u/tiefling",
    nl: "/dnd/wezens-s-u/tiefling",
    sv: "/dnd/varelser-s-u/tiefling",
    no: "/dnd/skapninger-s-u/tiefling",
    fi: "/dnd/olennot-s-u/tiefling",
    da: "/dnd/vaesner-s-u/tiefling",
    ru: "/dnd/suschestva-s-u/tifling",
  },
  "/dnd/s-u/tortle": {
    de: "/dnd/kreaturen-s-u/tortle",
    en: "/dnd/creatures-s-u/tortle",
    fr: "/dnd/creatures-s-u/tortue",
    it: "/dnd/creature-s-u/tortora",
    es: "/dnd/criaturas-s-u/tortuga",
    pl: "/dnd/stworzenia-s-u/tort",
    cs: "/dnd/bytosti-s-u/tortle",
    nl: "/dnd/wezens-s-u/tortel",
    sv: "/dnd/varelser-s-u/tortle",
    no: "/dnd/skapninger-s-u/tortle",
    fi: "/dnd/olennot-s-u/tortle",
    da: "/dnd/vaesner-s-u/tortle",
    ru: "/dnd/suschestva-s-u/tortl",
  },
  "/dnd/s-u/triton": {
    de: "/dnd/kreaturen-s-u/triton",
    en: "/dnd/creatures-s-u/triton",
    fr: "/dnd/creatures-s-u/triton",
    it: "/dnd/creature-s-u/tritone",
    es: "/dnd/criaturas-s-u/triton",
    pl: "/dnd/stworzenia-s-u/tryton",
    cs: "/dnd/bytosti-s-u/triton",
    nl: "/dnd/wezens-s-u/triton",
    sv: "/dnd/varelser-s-u/triton",
    no: "/dnd/skapninger-s-u/triton",
    fi: "/dnd/olennot-s-u/triton",
    da: "/dnd/vaesner-s-u/triton",
    ru: "/dnd/suschestva-s-u/triton",
  },
  "/dnd/s-u/troll": {
    de: "/dnd/kreaturen-s-u/troll",
    en: "/dnd/creatures-s-u/troll",
    fr: "/dnd/creatures-s-u/troll",
    it: "/dnd/creature-s-u/troll",
    es: "/dnd/criaturas-s-u/troll",
    pl: "/dnd/stworzenia-s-u/troll",
    cs: "/dnd/bytosti-s-u/troll",
    nl: "/dnd/wezens-s-u/trol",
    sv: "/dnd/varelser-s-u/troll",
    no: "/dnd/skapninger-s-u/troll",
    fi: "/dnd/olennot-s-u/peikko",
    da: "/dnd/vaesner-s-u/trold",
    ru: "/dnd/suschestva-s-u/troll",
  },
  "/dnd/v-z/warforged": {
    de: "/dnd/kreaturen-v-z/kriegsgeschmiedet",
    en: "/dnd/creatures-v-z/warforged",
    fr: "/dnd/creatures-vz/forgeron-de-guerre",
    it: "/dnd/creature-v-z/forgiato",
    es: "/dnd/criaturas-v-z/forjado",
    pl: "/dnd/stworzenia-v-z/wykuty-w-wojnie",
    cs: "/dnd/bytosti-v-z/warforged",
    nl: "/dnd/wezens-v-z/oorlogsgesmeed",
    sv: "/dnd/varelser-v-z/warforged",
    no: "/dnd/skapninger-v-z/warforged",
    fi: "/dnd/olennot-v-z/sotataottu",
    da: "/dnd/vaesner-v-z/warforged",
    ru: "/dnd/suschestva-v-z/zakalenniy-v-boyu",
  },
  "/dnd/v-z/white-dragon": {
    de: "/dnd/kreaturen-v-z/weisser-drache",
    en: "/dnd/creatures-v-z/white-dragon",
    fr: "/dnd/creatures-vz/dragon-blanc",
    it: "/dnd/creature-v-z/dragone-bianco",
    es: "/dnd/criaturas-v-z/dragon-blanco",
    pl: "/dnd/stworzenia-v-z/bialy-smok",
    cs: "/dnd/bytosti-v-z/bily-drak",
    nl: "/dnd/wezens-v-z/witte-draak",
    sv: "/dnd/varelser-v-z/vit-drake",
    no: "/dnd/skapninger-v-z/hvit-drage",
    fi: "/dnd/olennot-v-z/valkoinen-lohikaeaerme",
    da: "/dnd/vaesner-v-z/hvid-drage",
    ru: "/dnd/suschestva-v-z/beliy-drakon",
  },
  "/dnd/v-z/zandalari-troll": {
    de: "/dnd/kreaturen-v-z/zandalari-troll",
    en: "/dnd/creatures-v-z/zandalari-troll",
    fr: "/dnd/creatures-vz/troll-zandalari",
    it: "/dnd/creature-v-z/troll-zandalari",
    es: "/dnd/criaturas-v-z/trol-zandalari",
    pl: "/dnd/stworzenia-v-z/troll-zandalari",
    cs: "/dnd/bytosti-v-z/zandalari-troll",
    nl: "/dnd/wezens-v-z/zandalari-trol",
    sv: "/dnd/varelser-v-z/zandalari-troll",
    no: "/dnd/skapninger-v-z/zandalari-troll",
    fi: "/dnd/olennot-v-z/zandalarin-trolli",
    da: "/dnd/vaesner-v-z/zandalari-trold",
    ru: "/dnd/suschestva-v-z/zandalarskiy-troll",
  },
  "/gaming/gamertag/gamer-name": {
    de: "/spielen/gamertag/gamertag",
    en: "/gaming/gamertag/gamertag",
    fr: "/jeux/gamertag/gamertag",
    it: "/gioco/tag-gioco/tag-gioco",
    es: "/juego-de-azar/etiqueta-de-jugador/etiqueta-de-jugador",
    pl: "/hazard/tag-gracza/tag-gracza",
    cs: "/hrani/gamertag/gamertag",
    nl: "/gamen/gamertag/gamertag",
    sv: "/spelande/gamertag/gamertag",
    no: "/gaming/gamertag/gamertag",
    fi: "/pelaaminen/gamertag/gamertag",
    da: "/spil/gamertag/gamertag",
    ru: "/igry/teg-igroka/teg-igroka",
  },
  "/gaming/gamertag/gamer-name-part2": {
    de: "/spielen/gamertag/gamertag-teil-2",
    en: "/gaming/gamertag/gamertag-part-2",
    fr: "/jeux/gamertag/gamertag-partie-2",
    it: "/gioco/tag-gioco/gamertag-parte-2",
    es: "/juego-de-azar/etiqueta-de-jugador/etiqueta-de-jugador-parte-2",
    pl: "/hazard/tag-gracza/tag-gracza-czesc-2",
    cs: "/hrani/gamertag/gamertag-cast-2",
    nl: "/gamen/gamertag/gamertag-deel-2",
    sv: "/spelande/gamertag/gamertag-del-2",
    no: "/gaming/gamertag/gamertag-del-2",
    fi: "/pelaaminen/gamertag/gamertag-osa-2",
    da: "/spil/gamertag/gamertag-del-2",
    ru: "/igry/teg-igroka/teg-igroka-chast-2",
  },
  "/gaming/gamertag/gamer-name-part3": {
    de: "/spielen/gamertag/gamertag-teil-3",
    en: "/gaming/gamertag/gamertag-part-3",
    fr: "/jeux/gamertag/gamertag-partie-3",
    it: "/gioco/tag-gioco/gamertag-parte-3",
    es: "/juego-de-azar/etiqueta-de-jugador/etiqueta-de-jugador-parte-3",
    pl: "/hazard/tag-gracza/tag-gracza-czesc-3",
    cs: "/hrani/gamertag/gamertag-cast-3",
    nl: "/gamen/gamertag/gamertag-deel-3",
    sv: "/spelande/gamertag/gamertag-del-3",
    no: "/gaming/gamertag/gamertag-del-3",
    fi: "/pelaaminen/gamertag/gamertag-osa-3",
    da: "/spil/gamertag/gamertag-del-3",
    ru: "/igry/teg-igroka/teg-igroka-chast-3",
  },
  "/gaming/gamertag/gamer-name-part4": {
    de: "/spielen/gamertag/gamertag-teil-4",
    en: "/gaming/gamertag/gamertag-part-4",
    fr: "/jeux/gamertag/gamertag-partie-4",
    it: "/gioco/tag-gioco/gamertag-parte-4",
    es: "/juego-de-azar/etiqueta-de-jugador/etiqueta-de-jugador-parte-4",
    pl: "/hazard/tag-gracza/tag-gracza-czesc-4",
    cs: "/hrani/gamertag/gamertag-cast-4",
    nl: "/gamen/gamertag/gamertag-deel-4",
    sv: "/spelande/gamertag/gamertag-del-4",
    no: "/gaming/gamertag/gamertag-del-4",
    fi: "/pelaaminen/gamertag/gamertag-osa-4",
    da: "/spil/gamertag/gamertag-del-4",
    ru: "/igry/teg-igroka/teg-igroka-chast-4",
  },
  "/gaming/platform/mobile": {
    de: "/spielen/plattform/handy-mobiltelefon",
    en: "/gaming/platform/mobile",
    fr: "/jeux/plate-forme/mobile",
    it: "/gioco/piattaforma/mobile",
    es: "/juego-de-azar/plataforma/movil",
    pl: "/hazard/platforma/mobilny",
    cs: "/hrani/plosina/mobilni-pohyblivi",
    nl: "/gamen/platform/mobiel",
    sv: "/spelande/plattform/mobil",
    no: "/gaming/plattform/mobil",
    fi: "/pelaaminen/alusta/mobiili",
    da: "/spil/platform/mobil",
    ru: "/igry/platforma/mobilniy",
  },
  "/gaming/platform/nintendo": {
    de: "/spielen/plattform/nintendo",
    en: "/gaming/platform/nintendo",
    fr: "/jeux/plate-forme/nintendo",
    it: "/gioco/piattaforma/nintendo",
    es: "/juego-de-azar/plataforma/nintendo",
    pl: "/hazard/platforma/nintendo",
    cs: "/hrani/plosina/nintendo",
    nl: "/gamen/platform/nintendo",
    sv: "/spelande/plattform/nintendo",
    no: "/gaming/plattform/nintendo",
    fi: "/pelaaminen/alusta/nintendo",
    da: "/spil/platform/nintendo",
    ru: "/igry/platforma/nintendo",
  },
  "/gaming/platform/playstation": {
    de: "/spielen/plattform/playstation",
    en: "/gaming/platform/playstation",
    fr: "/jeux/plate-forme/playstation",
    it: "/gioco/piattaforma/playstation",
    es: "/juego-de-azar/plataforma/playstation",
    pl: "/hazard/platforma/playstation",
    cs: "/hrani/plosina/play-station",
    nl: "/gamen/platform/playstation",
    sv: "/spelande/plattform/playstation",
    no: "/gaming/plattform/playstation",
    fi: "/pelaaminen/alusta/peli-asema",
    da: "/spil/platform/playstation",
    ru: "/igry/platforma/playstation",
  },
  "/gaming/platform/twitch-tv": {
    de: "/spielen/plattform/twitch-tv",
    en: "/gaming/platform/twitch-tv",
    fr: "/jeux/plate-forme/twitch-tv",
    it: "/gioco/piattaforma/twitch-tv",
    es: "/juego-de-azar/plataforma/twitch-tv",
    pl: "/hazard/platforma/twitch-tv",
    cs: "/hrani/plosina/twitch-tv",
    nl: "/gamen/platform/twitch-tv",
    sv: "/spelande/plattform/twitch-tv",
    no: "/gaming/plattform/twitch-tv",
    fi: "/pelaaminen/alusta/twitch-tv",
    da: "/spil/platform/twitch-tv",
    ru: "/igry/platforma/twitch-tv",
  },
  "/gaming/platform/xbox": {
    de: "/spielen/plattform/xbox",
    en: "/gaming/platform/xbox",
    fr: "/jeux/plate-forme/xbox",
    it: "/gioco/piattaforma/xbox",
    es: "/juego-de-azar/plataforma/xbox",
    pl: "/hazard/platforma/xbox",
    cs: "/hrani/plosina/xbox",
    nl: "/gamen/platform/xbox",
    sv: "/spelande/plattform/xbox",
    no: "/gaming/plattform/xbox",
    fi: "/pelaaminen/alusta/xbox",
    da: "/spil/platform/xbox",
    ru: "/igry/platforma/xbox",
  },
  "/gaming/teams/clan": {
    de: "/spielen/teams/clan",
    en: "/gaming/teams/clan",
    fr: "/jeux/equipes/clan",
    it: "/gioco/squadre/clan",
    es: "/juego-de-azar/equipos/clan",
    pl: "/hazard/zespoly/klan",
    cs: "/hrani/tymy/klan",
    nl: "/gamen/teams/clan",
    sv: "/spelande/lag/klan",
    no: "/gaming/lag/klan",
    fi: "/pelaaminen/joukkueet/klaani",
    da: "/spil/hold/klan",
    ru: "/igry/komandy/klan",
  },
  "/gaming/teams/e-sports": {
    de: "/spielen/teams/e-sport",
    en: "/gaming/teams/e-sports",
    fr: "/jeux/equipes/sports-electroniques",
    it: "/gioco/squadre/e-sport",
    es: "/juego-de-azar/equipos/deportes-electronicos",
    pl: "/hazard/zespoly/sport-e",
    cs: "/hrani/tymy/e-sport",
    nl: "/gamen/teams/e-sport",
    sv: "/spelande/lag/e-sport",
    no: "/gaming/lag/e-sport",
    fi: "/pelaaminen/joukkueet/e-urheilu",
    da: "/spil/hold/e-sport",
    ru: "/igry/komandy/elektronniy-sport",
  },
  "/gaming/teams/guild": {
    de: "/spielen/teams/gilde",
    en: "/gaming/teams/guild",
    fr: "/jeux/equipes/guilde",
    it: "/gioco/squadre/gilda",
    es: "/juego-de-azar/equipos/gremio",
    pl: "/hazard/zespoly/gildia",
    cs: "/hrani/tymy/cech",
    nl: "/gamen/teams/gilde",
    sv: "/spelande/lag/gille",
    no: "/gaming/lag/klanen",
    fi: "/pelaaminen/joukkueet/kilta",
    da: "/spil/hold/guild",
    ru: "/igry/komandy/gildiya",
  },
  "/gaming/teams/squad": {
    de: "/spielen/teams/squad",
    en: "/gaming/teams/squad",
    fr: "/jeux/equipes/equipe",
    it: "/gioco/squadre/squadra",
    es: "/juego-de-azar/equipos/equipo",
    pl: "/hazard/zespoly/druzyna",
    cs: "/hrani/tymy/ceta",
    nl: "/gamen/teams/ploeg",
    sv: "/spelande/lag/trupp",
    no: "/gaming/lag/troppen",
    fi: "/pelaaminen/joukkueet/ryhmae",
    da: "/spil/hold/squad",
    ru: "/igry/komandy/otryad",
  },
  "/gaming/teams/team": {
    de: "/spielen/teams/team",
    en: "/gaming/teams/team",
    fr: "/jeux/equipes/equipe",
    it: "/gioco/squadre/squadra",
    es: "/juego-de-azar/equipos/equipo",
    pl: "/hazard/zespoly/zespol",
    cs: "/hrani/tymy/tym",
    nl: "/gamen/teams/team",
    sv: "/spelande/lag/team",
    no: "/gaming/lag/team",
    fi: "/pelaaminen/joukkueet/tiimi",
    da: "/spil/hold/hold",
    ru: "/igry/komandy/komanda",
  },
  "/video-games/animal-crossing/character-names": {
    de: "/videospiele/animal-crossing/charakternamen",
    en: "/video-games/animal-crossing/character-names",
    fr: "/jeux-video/animal-crossing/noms-des-personnages",
    it: "/videogiochi/animal-crossing/nomi-dei-personaggi",
    es: "/juegos-de-video/animal-crossing/nombres-de-personajes",
    pl: "/gry-wideo/animal-crossing/imiona-postaci",
    cs: "/videohry/animal-crossing/jmena-postav",
    nl: "/computerspellen/animal-crossing/karakternamen",
    sv: "/videospel/animal-crossing/karaktaersnamn",
    no: "/videospill/animal-crossing/karakternavn",
    fi: "/videopelit/animal-crossing/hahmon-nimet",
    da: "/computerspil/animal-crossing/karakternavne",
    ru: "/videoigry/animal-crossing/imena-personazhey",
  },
  "/video-games/animal-crossing/island-names": {
    de: "/videospiele/animal-crossing/inselnamen",
    en: "/video-games/animal-crossing/island-names",
    fr: "/jeux-video/animal-crossing/noms-des-iles",
    it: "/videogiochi/animal-crossing/nomi-delle-isole",
    es: "/juegos-de-video/animal-crossing/nombres-de-islas",
    pl: "/gry-wideo/animal-crossing/nazwy-wysp",
    cs: "/videohry/animal-crossing/jmena-ostrovu",
    nl: "/computerspellen/animal-crossing/eilandnamen",
    sv: "/videospel/animal-crossing/oenamn",
    no: "/videospill/animal-crossing/oynavn",
    fi: "/videopelit/animal-crossing/saaren-nimet",
    da: "/computerspil/animal-crossing/o-navne",
    ru: "/videoigry/animal-crossing/nazvaniya-ostrovov",
  },
  "/video-games/animal-crossing/names": {
    de: "/videospiele/animal-crossing/namen",
    en: "/video-games/animal-crossing/names",
    fr: "/jeux-video/animal-crossing/des-noms",
    it: "/videogiochi/animal-crossing/nomi",
    es: "/juegos-de-video/animal-crossing/nombres",
    pl: "/gry-wideo/animal-crossing/nazwy",
    cs: "/videohry/animal-crossing/jmena",
    nl: "/computerspellen/animal-crossing/namen",
    sv: "/videospel/animal-crossing/namn",
    no: "/videospill/animal-crossing/navn",
    fi: "/videopelit/animal-crossing/nimet",
    da: "/computerspil/animal-crossing/navne",
    ru: "/videoigry/animal-crossing/imena",
  },
  "/video-games/animal-crossing/town-names": {
    de: "/videospiele/animal-crossing/staedtenamen",
    en: "/video-games/animal-crossing/town-names",
    fr: "/jeux-video/animal-crossing/noms-des-villes",
    it: "/videogiochi/animal-crossing/nomi-di-citta",
    es: "/juegos-de-video/animal-crossing/nombres-de-ciudades",
    pl: "/gry-wideo/animal-crossing/nazwy-miast",
    cs: "/videohry/animal-crossing/nazvy-mest",
    nl: "/computerspellen/animal-crossing/stadsnamen",
    sv: "/videospel/animal-crossing/stadsnamn",
    no: "/videospill/animal-crossing/bynavn",
    fi: "/videopelit/animal-crossing/kaupunkien-nimet",
    da: "/computerspil/animal-crossing/bynavne",
    ru: "/videoigry/animal-crossing/nazvaniya-gorodov",
  },
  "/video-games/animal-crossing/villager-names": {
    de: "/videospiele/animal-crossing/dorfbewohnernamen",
    en: "/video-games/animal-crossing/villager-names",
    fr: "/jeux-video/animal-crossing/noms-des-villageois",
    it: "/videogiochi/animal-crossing/nomi-degli-abitanti-dei-villaggi",
    es: "/juegos-de-video/animal-crossing/nombres-de-aldeanos",
    pl: "/gry-wideo/animal-crossing/imiona-wiesniakow",
    cs: "/videohry/animal-crossing/jmena-vesnicanu",
    nl: "/computerspellen/animal-crossing/namen-van-dorpelingen",
    sv: "/videospel/animal-crossing/bybornas-namn",
    no: "/videospill/animal-crossing/navn-pa-landsbyboere",
    fi: "/videopelit/animal-crossing/kylaelaeisten-nimet",
    da: "/computerspil/animal-crossing/landsbyboernes-navne",
    ru: "/videoigry/animal-crossing/imena-selskikh-zhiteley",
  },
  "/video-games/fortnite/boys-names": {
    de: "/videospiele/fortnite/jungennamen",
    en: "/video-games/fortnite/boys-names",
    fr: "/jeux-video/fortnite/noms-de-garcons",
    it: "/videogiochi/fortnite/nomi-maschili",
    es: "/juegos-de-video/fortnite/nombres-de-ninos",
    pl: "/gry-wideo/fortnite/imiona-chlopcow",
    cs: "/videohry/fortnite/chlapecka-jmena",
    nl: "/computerspellen/fortnite/jongensnamen",
    sv: "/videospel/fortnite/pojknamn",
    no: "/videospill/fortnite/guttenavn",
    fi: "/videopelit/fortnite/poikien-nimet",
    da: "/computerspil/fortnite/drengenavne",
    ru: "/videoigry/fortnite/imena-malchikov",
  },
  "/video-games/fortnite/clan-names": {
    de: "/videospiele/fortnite/clannamen",
    en: "/video-games/fortnite/clan-names",
    fr: "/jeux-video/fortnite/noms-de-clan",
    it: "/videogiochi/fortnite/nomi-dei-clan",
    es: "/juegos-de-video/fortnite/nombres-de-clanes",
    pl: "/gry-wideo/fortnite/nazwy-klanow",
    cs: "/videohry/fortnite/jmena-klanu",
    nl: "/computerspellen/fortnite/clannamen",
    sv: "/videospel/fortnite/klannamn",
    no: "/videospill/fortnite/klannavn",
    fi: "/videopelit/fortnite/klaanien-nimet",
    da: "/computerspil/fortnite/klannavne",
    ru: "/videoigry/fortnite/nazvaniya-klanov",
  },
  "/video-games/fortnite/girls-names": {
    de: "/videospiele/fortnite/maedchennamen",
    en: "/video-games/fortnite/girls-names",
    fr: "/jeux-video/fortnite/noms-de-filles",
    it: "/videogiochi/fortnite/nomi-di-ragazze",
    es: "/juegos-de-video/fortnite/nombres-de-ninas",
    pl: "/gry-wideo/fortnite/imiona-dziewczat",
    cs: "/videohry/fortnite/divci-jmena",
    nl: "/computerspellen/fortnite/meisjesnamen",
    sv: "/videospel/fortnite/flicknamn",
    no: "/videospill/fortnite/jentenavn",
    fi: "/videopelit/fortnite/tyttoejen-nimet",
    da: "/computerspil/fortnite/pigenavne",
    ru: "/videoigry/fortnite/imena-dlya-devochek",
  },
  "/video-games/fortnite/names": {
    de: "/videospiele/fortnite/namen",
    en: "/video-games/fortnite/names",
    fr: "/jeux-video/fortnite/des-noms",
    it: "/videogiochi/fortnite/nomi",
    es: "/juegos-de-video/fortnite/nombres",
    pl: "/gry-wideo/fortnite/nazwy",
    cs: "/videohry/fortnite/jmena",
    nl: "/computerspellen/fortnite/namen",
    sv: "/videospel/fortnite/namn",
    no: "/videospill/fortnite/navn",
    fi: "/videopelit/fortnite/nimet",
    da: "/computerspil/fortnite/navne",
    ru: "/videoigry/fortnite/imena",
  },
  "/video-games/fortnite/sweaty-names": {
    de: "/videospiele/fortnite/sweaty-namen",
    en: "/video-games/fortnite/sweaty-names",
    fr: "/jeux-video/fortnite/sweaty-names",
    it: "/videogiochi/fortnite/sweaty-names",
    es: "/juegos-de-video/fortnite/sweaty-names",
    pl: "/gry-wideo/fortnite/sweaty-names",
    cs: "/videohry/fortnite/sweaty-jmena",
    nl: "/computerspellen/fortnite/sweaty-names",
    sv: "/videospel/fortnite/sweaty-names",
    no: "/videospill/fortnite/sweaty-names",
    fi: "/videopelit/fortnite/hikinen-nimet",
    da: "/computerspil/fortnite/sweaty-navne",
    ru: "/videoigry/fortnite/sweaty-names",
  },
  "/video-games/fortnite/symbols-names": {
    de: "/videospiele/fortnite/symbolnamen",
    en: "/video-games/fortnite/symbols-names",
    fr: "/jeux-video/fortnite/noms-des-symboles",
    it: "/videogiochi/fortnite/nomi-dei-simboli",
    es: "/juegos-de-video/fortnite/nombres-de-simbolos",
    pl: "/gry-wideo/fortnite/nazwy-symboli",
    cs: "/videohry/fortnite/nazvy-symbolu",
    nl: "/computerspellen/fortnite/symbolen-namen",
    sv: "/videospel/fortnite/symboler-namn",
    no: "/videospill/fortnite/symboler-navn",
    fi: "/videopelit/fortnite/symbolit-nimet",
    da: "/computerspil/fortnite/symboler-navne",
    ru: "/videoigry/fortnite/imena-simvolov",
  },
  "/video-games/fortnite/tryhard-names": {
    de: "/videospiele/fortnite/tryhard-namen",
    en: "/video-games/fortnite/tryhard-names",
    fr: "/jeux-video/fortnite/noms-tryhard",
    it: "/videogiochi/fortnite/nomi-tryhard",
    es: "/juegos-de-video/fortnite/nombres-dificiles",
    pl: "/gry-wideo/fortnite/nazwy-tryharda",
    cs: "/videohry/fortnite/jmena-tryhard",
    nl: "/computerspellen/fortnite/tryhard-namen",
    sv: "/videospel/fortnite/tryhard-names",
    no: "/videospill/fortnite/provharde-navn",
    fi: "/videopelit/fortnite/tryhard-nimet",
    da: "/computerspil/fortnite/forsogte-navne",
    ru: "/videoigry/fortnite/imena-traykharda",
  },
  "/video-games/pokemon/names": {
    de: "/videospiele/pokemon/namen",
    en: "/video-games/pokemon/names",
    fr: "/jeux-video/pokemon/des-noms",
    it: "/videogiochi/pokemon/nomi",
    es: "/juegos-de-video/pokemon/nombres",
    pl: "/gry-wideo/pokemon/nazwy",
    cs: "/videohry/pokemon/jmena",
    nl: "/computerspellen/pokemon/namen",
    sv: "/videospel/pokemon/namn",
    no: "/videospill/pokemon/navn",
    fi: "/videopelit/pokemon/nimet",
    da: "/computerspil/pokemon/navne",
    ru: "/videoigry/pokemon/imena",
  },
  "/video-games/pokemon/pokemon-go-names": {
    de: "/videospiele/pokemon/pokemon-go-namen",
    en: "/video-games/pokemon/pokemon-go-names",
    fr: "/jeux-video/pokemon/noms-pokemon-go",
    it: "/videogiochi/pokemon/nomi-pokemon-go",
    es: "/juegos-de-video/pokemon/nombres-de-pokemon-go",
    pl: "/gry-wideo/pokemon/nazwy-pokemon-go",
    cs: "/videohry/pokemon/jmena-pokemon-go",
    nl: "/computerspellen/pokemon/pokemon-go-namen",
    sv: "/videospel/pokemon/pokemon-go-namn",
    no: "/videospill/pokemon/pokemon-go-navn",
    fi: "/videopelit/pokemon/pokemon-go-nimet",
    da: "/computerspil/pokemon/pokemon-go-navne",
    ru: "/videoigry/pokemon/imena-pokemon-go",
  },
  "/video-games/pokemon/trainer-names": {
    de: "/videospiele/pokemon/trainernamen",
    en: "/video-games/pokemon/trainer-names",
    fr: "/jeux-video/pokemon/noms-des-formateurs",
    it: "/videogiochi/pokemon/nomi-degli-allenatori",
    es: "/juegos-de-video/pokemon/nombres-de-entrenadores",
    pl: "/gry-wideo/pokemon/nazwiska-trenerow",
    cs: "/videohry/pokemon/jmena-treneru",
    nl: "/computerspellen/pokemon/namen-van-trainers",
    sv: "/videospel/pokemon/traenares-namn",
    no: "/videospill/pokemon/trenernavn",
    fi: "/videopelit/pokemon/valmentajan-nimet",
    da: "/computerspil/pokemon/traener-navne",
    ru: "/videoigry/pokemon/imena-trenerov",
  },
  "/video-games/roblox/girl-names": {
    de: "/videospiele/roblox/maedchennamen",
    en: "/video-games/roblox/girl-names",
    fr: "/jeux-video/roblox/noms-de-fille",
    it: "/videogiochi/roblox/nomi-di-ragazze",
    es: "/juegos-de-video/roblox/nombres-de-nina",
    pl: "/gry-wideo/roblox/imiona-dziewczyn",
    cs: "/videohry/roblox/divci-jmena",
    nl: "/computerspellen/roblox/meisjesnamen",
    sv: "/videospel/roblox/flicknamn",
    no: "/videospill/roblox/jentenavn",
    fi: "/videopelit/roblox/tyttoejen-nimet",
    da: "/computerspil/roblox/pigenavne",
    ru: "/videoigry/robloks/imena-dlya-devochek",
  },
  "/video-games/roblox/myth-names": {
    de: "/videospiele/roblox/mythosnamen",
    en: "/video-games/roblox/myth-names",
    fr: "/jeux-video/roblox/noms-de-mythes",
    it: "/videogiochi/roblox/nomi-mitici",
    es: "/juegos-de-video/roblox/nombres-de-mitos",
    pl: "/gry-wideo/roblox/nazwy-mitow",
    cs: "/videohry/roblox/jmena-mytu",
    nl: "/computerspellen/roblox/mythe-namen",
    sv: "/videospel/roblox/mytnamn",
    no: "/videospill/roblox/mytenavn",
    fi: "/videopelit/roblox/myytti-nimet",
    da: "/computerspil/roblox/myte-navne",
    ru: "/videoigry/robloks/mificheskie-imena",
  },
  "/video-games/roblox/names": {
    de: "/videospiele/roblox/namen",
    en: "/video-games/roblox/names",
    fr: "/jeux-video/roblox/des-noms",
    it: "/videogiochi/roblox/nomi",
    es: "/juegos-de-video/roblox/nombres",
    pl: "/gry-wideo/roblox/nazwy",
    cs: "/videohry/roblox/jmena",
    nl: "/computerspellen/roblox/namen",
    sv: "/videospel/roblox/namn",
    no: "/videospill/roblox/navn",
    fi: "/videopelit/roblox/nimet",
    da: "/computerspil/roblox/navne",
    ru: "/videoigry/robloks/imena",
  },
  "/video-games/valorant/boy-names": {
    de: "/videospiele/valorant/jungennamen",
    en: "/video-games/valorant/boy-names",
    fr: "/jeux-video/valorant/noms-de-garcon",
    it: "/videogiochi/valorant/nomi-maschili",
    es: "/juegos-de-video/valorant/nombres-de-nino",
    pl: "/gry-wideo/valorant/imiona-chlopcow",
    cs: "/videohry/valorant/chlapecka-jmena",
    nl: "/computerspellen/valorant/jongensnamen",
    sv: "/videospel/valorant/pojknamn",
    no: "/videospill/valorant/guttenavn",
    fi: "/videopelit/valorant/poikien-nimet",
    da: "/computerspil/valorant/drengenavne",
    ru: "/videoigry/valorant/imena-malchikov",
  },
  "/video-games/valorant/clan-names": {
    de: "/videospiele/valorant/clannamen",
    en: "/video-games/valorant/clan-names",
    fr: "/jeux-video/valorant/noms-de-clan",
    it: "/videogiochi/valorant/nomi-dei-clan",
    es: "/juegos-de-video/valorant/nombres-de-clanes",
    pl: "/gry-wideo/valorant/nazwy-klanow",
    cs: "/videohry/valorant/jmena-klanu",
    nl: "/computerspellen/valorant/clannamen",
    sv: "/videospel/valorant/klannamn",
    no: "/videospill/valorant/klannavn",
    fi: "/videopelit/valorant/klaanien-nimet",
    da: "/computerspil/valorant/klannavne",
    ru: "/videoigry/valorant/nazvaniya-klanov",
  },
  "/video-games/valorant/girl-names": {
    de: "/videospiele/valorant/maedchennamen",
    en: "/video-games/valorant/girl-names",
    fr: "/jeux-video/valorant/noms-de-fille",
    it: "/videogiochi/valorant/nomi-di-ragazze",
    es: "/juegos-de-video/valorant/nombres-de-nina",
    pl: "/gry-wideo/valorant/imiona-dziewczyn",
    cs: "/videohry/valorant/divci-jmena",
    nl: "/computerspellen/valorant/meisjesnamen",
    sv: "/videospel/valorant/flicknamn",
    no: "/videospill/valorant/jentenavn",
    fi: "/videopelit/valorant/tyttoejen-nimet",
    da: "/computerspil/valorant/pigenavne",
    ru: "/videoigry/valorant/imena-dlya-devochek",
  },
  "/video-games/valorant/names": {
    de: "/videospiele/valorant/namen",
    en: "/video-games/valorant/names",
    fr: "/jeux-video/valorant/des-noms",
    it: "/videogiochi/valorant/nomi",
    es: "/juegos-de-video/valorant/nombres",
    pl: "/gry-wideo/valorant/nazwy",
    cs: "/videohry/valorant/jmena",
    nl: "/computerspellen/valorant/namen",
    sv: "/videospel/valorant/namn",
    no: "/videospill/valorant/navn",
    fi: "/videopelit/valorant/nimet",
    da: "/computerspil/valorant/navne",
    ru: "/videoigry/valorant/imena",
  },
  "/video-games/valorant/symbols-names": {
    de: "/videospiele/valorant/symbolnamen",
    en: "/video-games/valorant/symbols-names",
    fr: "/jeux-video/valorant/noms-des-symboles",
    it: "/videogiochi/valorant/nomi-dei-simboli",
    es: "/juegos-de-video/valorant/nombres-de-simbolos",
    pl: "/gry-wideo/valorant/nazwy-symboli",
    cs: "/videohry/valorant/nazvy-symbolu",
    nl: "/computerspellen/valorant/symbolen-namen",
    sv: "/videospel/valorant/symboler-namn",
    no: "/videospill/valorant/symboler-navn",
    fi: "/videopelit/valorant/symbolit-nimet",
    da: "/computerspil/valorant/symboler-navne",
    ru: "/videoigry/valorant/imena-simvolov",
  },
  "/video-games/valorant/team-names": {
    de: "/videospiele/valorant/teamnamen",
    en: "/video-games/valorant/team-names",
    fr: "/jeux-video/valorant/noms-des-equipes",
    it: "/videogiochi/valorant/nomi-delle-squadre",
    es: "/juegos-de-video/valorant/nombres-de-equipo",
    pl: "/gry-wideo/valorant/nazwy-druzyn",
    cs: "/videohry/valorant/nazvy-tymu",
    nl: "/computerspellen/valorant/teamnamen",
    sv: "/videospel/valorant/lagnamn",
    no: "/videospill/valorant/lagnavn",
    fi: "/videopelit/valorant/joukkueiden-nimet",
    da: "/computerspil/valorant/holdnavne",
    ru: "/videoigry/valorant/nazvaniya-komand",
  },
  "/video-games/valorant/tryhard-names": {
    de: "/videospiele/valorant/tryhard-namen",
    en: "/video-games/valorant/tryhard-names",
    fr: "/jeux-video/valorant/noms-tryhard",
    it: "/videogiochi/valorant/nomi-tryhard",
    es: "/juegos-de-video/valorant/nombres-dificiles",
    pl: "/gry-wideo/valorant/nazwy-tryharda",
    cs: "/videohry/valorant/jmena-tryhard",
    nl: "/computerspellen/valorant/tryhard-namen",
    sv: "/videospel/valorant/tryhard-names",
    no: "/videospill/valorant/provharde-navn",
    fi: "/videopelit/valorant/tryhard-nimet",
    da: "/computerspil/valorant/forsogte-navne",
    ru: "/videoigry/valorant/imena-traykharda",
  },
  "/video-games/skyrim/argonian-names": {
    de: "/videospiele/skyrim/argonische-namen",
    en: "/video-games/skyrim/argonian-names",
    fr: "/jeux-video/skyrim/noms-argoniens",
    it: "/videogiochi/skyrim/nomi-argoniani",
    es: "/juegos-de-video/skyrim/nombres-argonianos",
    pl: "/gry-wideo/skyrim/imiona-argonianskie",
    cs: "/videohry/skyrim/argonianska-jmena",
    nl: "/computerspellen/skyrim/argoniaanse-namen",
    sv: "/videospel/skyrim/argoniska-namn",
    no: "/videospill/skyrim/argonske-navn",
    fi: "/videopelit/skyrim/argonian-nimet",
    da: "/computerspil/skyrim/argonske-navne",
    ru: "/videoigry/skayrim/argonianskie-imena",
  },
  "/video-games/skyrim/bosmer-names": {
    de: "/videospiele/skyrim/bosmer-namen",
    en: "/video-games/skyrim/bosmer-names",
    fr: "/jeux-video/skyrim/noms-bosmers",
    it: "/videogiochi/skyrim/nomi-bosmer",
    es: "/juegos-de-video/skyrim/nombres-bosmer",
    pl: "/gry-wideo/skyrim/nazwy-bosmerow",
    cs: "/videohry/skyrim/bosmer-jmena",
    nl: "/computerspellen/skyrim/bosmer-namen",
    sv: "/videospel/skyrim/bosmer-namn",
    no: "/videospill/skyrim/bosmer-navn",
    fi: "/videopelit/skyrim/bosmer-nimet",
    da: "/computerspil/skyrim/bosmer-navne",
    ru: "/videoigry/skayrim/bosmerskie-imena",
  },
  "/video-games/skyrim/breton-names": {
    de: "/videospiele/skyrim/bretonische-namen",
    en: "/video-games/skyrim/breton-names",
    fr: "/jeux-video/skyrim/prenoms-bretons",
    it: "/videogiochi/skyrim/nomi-bretoni",
    es: "/juegos-de-video/skyrim/nombres-bretones",
    pl: "/gry-wideo/skyrim/imiona-bretonskie",
    cs: "/videohry/skyrim/bretonska-jmena",
    nl: "/computerspellen/skyrim/bretonse-namen",
    sv: "/videospel/skyrim/bretonska-namn",
    no: "/videospill/skyrim/bretonske-navn",
    fi: "/videopelit/skyrim/bretonin-nimet",
    da: "/computerspil/skyrim/bretonske-navne",
    ru: "/videoigry/skayrim/bretonskie-imena",
  },
  "/video-games/skyrim/character-names": {
    de: "/videospiele/skyrim/charakternamen",
    en: "/video-games/skyrim/character-names",
    fr: "/jeux-video/skyrim/noms-des-personnages",
    it: "/videogiochi/skyrim/nomi-dei-personaggi",
    es: "/juegos-de-video/skyrim/nombres-de-personajes",
    pl: "/gry-wideo/skyrim/imiona-postaci",
    cs: "/videohry/skyrim/jmena-postav",
    nl: "/computerspellen/skyrim/karakternamen",
    sv: "/videospel/skyrim/karaktaersnamn",
    no: "/videospill/skyrim/karakternavn",
    fi: "/videopelit/skyrim/hahmon-nimet",
    da: "/computerspil/skyrim/karakternavne",
    ru: "/videoigry/skayrim/imena-personazhey",
  },
  "/video-games/skyrim/dragon-names": {
    de: "/videospiele/skyrim/drachennamen",
    en: "/video-games/skyrim/dragon-names",
    fr: "/jeux-video/skyrim/noms-de-dragons",
    it: "/videogiochi/skyrim/nomi-dei-draghi",
    es: "/juegos-de-video/skyrim/nombres-de-dragones",
    pl: "/gry-wideo/skyrim/imiona-smokow",
    cs: "/videohry/skyrim/draci-jmena",
    nl: "/computerspellen/skyrim/drakennamen",
    sv: "/videospel/skyrim/draknamn",
    no: "/videospill/skyrim/dragenavn",
    fi: "/videopelit/skyrim/lohikaeaermeiden-nimet",
    da: "/computerspil/skyrim/drage-navne",
    ru: "/videoigry/skayrim/imena-drakonov",
  },
  "/video-games/skyrim/imperial-names": {
    de: "/videospiele/skyrim/kaiserliche-namen",
    en: "/video-games/skyrim/imperial-names",
    fr: "/jeux-video/skyrim/noms-imperiaux",
    it: "/videogiochi/skyrim/nomi-imperiali",
    es: "/juegos-de-video/skyrim/nombres-imperiales",
    pl: "/gry-wideo/skyrim/imiona-imperialne",
    cs: "/videohry/skyrim/imperialni-jmena",
    nl: "/computerspellen/skyrim/keizerlijke-namen",
    sv: "/videospel/skyrim/imperialistiska-namn",
    no: "/videospill/skyrim/keiserlige-navn",
    fi: "/videopelit/skyrim/keisarilliset-nimet",
    da: "/computerspil/skyrim/kejserlige-navne",
    ru: "/videoigry/skayrim/imperatorskie-imena",
  },
  "/video-games/skyrim/khajiit-names": {
    de: "/videospiele/skyrim/khajiit-namen",
    en: "/video-games/skyrim/khajiit-names",
    fr: "/jeux-video/skyrim/noms-khajiits",
    it: "/videogiochi/skyrim/nomi-khajiiti",
    es: "/juegos-de-video/skyrim/nombres-khajiitas",
    pl: "/gry-wideo/skyrim/imiona-khajiitow",
    cs: "/videohry/skyrim/khajiitska-jmena",
    nl: "/computerspellen/skyrim/khajiit-namen",
    sv: "/videospel/skyrim/khajiit-namn",
    no: "/videospill/skyrim/khajiit-navn",
    fi: "/videopelit/skyrim/khajiit-nimet",
    da: "/computerspil/skyrim/khajiit-navne",
    ru: "/videoigry/skayrim/imena-kadzhitov",
  },
  "/video-games/skyrim/names": {
    de: "/videospiele/skyrim/namen",
    en: "/video-games/skyrim/names",
    fr: "/jeux-video/skyrim/des-noms",
    it: "/videogiochi/skyrim/nomi",
    es: "/juegos-de-video/skyrim/nombres",
    pl: "/gry-wideo/skyrim/nazwy",
    cs: "/videohry/skyrim/jmena",
    nl: "/computerspellen/skyrim/namen",
    sv: "/videospel/skyrim/namn",
    no: "/videospill/skyrim/navn",
    fi: "/videopelit/skyrim/nimet",
    da: "/computerspil/skyrim/navne",
    ru: "/videoigry/skayrim/imena",
  },
  "/video-games/skyrim/nord-names": {
    de: "/videospiele/skyrim/nord-namen",
    en: "/video-games/skyrim/nord-names",
    fr: "/jeux-video/skyrim/noms-nordiques",
    it: "/videogiochi/skyrim/nomi-nord",
    es: "/juegos-de-video/skyrim/nombres-nordicos",
    pl: "/gry-wideo/skyrim/nazwy-nordow",
    cs: "/videohry/skyrim/nord-names",
    nl: "/computerspellen/skyrim/noordelijke-namen",
    sv: "/videospel/skyrim/nord-names",
    no: "/videospill/skyrim/nord-navn",
    fi: "/videopelit/skyrim/nord-nimet",
    da: "/computerspil/skyrim/nord-navne",
    ru: "/videoigry/skayrim/nordskie-imena",
  },
  "/video-games/skyrim/orc-names": {
    de: "/videospiele/skyrim/ork-namen",
    en: "/video-games/skyrim/orc-names",
    fr: "/jeux-video/skyrim/noms-des-orques",
    it: "/videogiochi/skyrim/nomi-degli-orchi",
    es: "/juegos-de-video/skyrim/nombres-de-orcos",
    pl: "/gry-wideo/skyrim/imiona-orkow",
    cs: "/videohry/skyrim/skreti-jmena",
    nl: "/computerspellen/skyrim/orc-namen",
    sv: "/videospel/skyrim/orc-namn",
    no: "/videospill/skyrim/orc-navn",
    fi: "/videopelit/skyrim/orkkien-nimet",
    da: "/computerspil/skyrim/orc-navne",
    ru: "/videoigry/skayrim/imena-orkov",
  },
  "/video-games/skyrim/redguard-names": {
    de: "/videospiele/skyrim/rothwardonennamen",
    en: "/video-games/skyrim/redguard-names",
    fr: "/jeux-video/skyrim/noms-des-rougegardes",
    it: "/videogiochi/skyrim/nomi-della-guardia-rossa",
    es: "/juegos-de-video/skyrim/nombres-de-guardias-rojos",
    pl: "/gry-wideo/skyrim/nazwy-redgardzkie",
    cs: "/videohry/skyrim/jmena-redguardu",
    nl: "/computerspellen/skyrim/redguard-namen",
    sv: "/videospel/skyrim/redguard-namn",
    no: "/videospill/skyrim/redguard-navn",
    fi: "/videopelit/skyrim/redguardin-nimet",
    da: "/computerspil/skyrim/redguard-navne",
    ru: "/videoigry/skayrim/imena-redgardov",
  },
  "/video-games/league-of-legends/champion-names": {
    de: "/videospiele/league-of-legends/championnamen",
    en: "/video-games/league-of-legends/champion-names",
    fr: "/jeux-video/league-of-legends/noms-des-champions",
    it: "/videogiochi/league-of-legends/nomi-dei-campioni",
    es: "/juegos-de-video/league-of-legends/nombres-de-campeones",
    pl: "/gry-wideo/league-of-legends/imiona-mistrzow",
    cs: "/videohry/league-of-legends/jmena-sampionu",
    nl: "/computerspellen/league-of-legends/namen-van-kampioenen",
    sv: "/videospel/league-of-legends/maestarnamn",
    no: "/videospill/league-of-legends/mesternavn",
    fi: "/videopelit/league-of-legends/mestarien-nimet",
    da: "/computerspil/liga-af-legender/mesternavne",
    ru: "/videoigry/league-of-legends/imena-chempionov",
  },
  "/video-games/league-of-legends/names": {
    de: "/videospiele/league-of-legends/namen",
    en: "/video-games/league-of-legends/names",
    fr: "/jeux-video/league-of-legends/des-noms",
    it: "/videogiochi/league-of-legends/nomi",
    es: "/juegos-de-video/league-of-legends/nombres",
    pl: "/gry-wideo/league-of-legends/nazwy",
    cs: "/videohry/league-of-legends/jmena",
    nl: "/computerspellen/league-of-legends/namen",
    sv: "/videospel/league-of-legends/namn",
    no: "/videospill/league-of-legends/navn",
    fi: "/videopelit/league-of-legends/nimet",
    da: "/computerspil/liga-af-legender/navne",
    ru: "/videoigry/league-of-legends/imena",
  },
  "/video-games/league-of-legends/team-names": {
    de: "/videospiele/league-of-legends/teamnamen",
    en: "/video-games/league-of-legends/team-names",
    fr: "/jeux-video/league-of-legends/noms-des-equipes",
    it: "/videogiochi/league-of-legends/nomi-delle-squadre",
    es: "/juegos-de-video/league-of-legends/nombres-de-equipo",
    pl: "/gry-wideo/league-of-legends/nazwy-druzyn",
    cs: "/videohry/league-of-legends/nazvy-tymu",
    nl: "/computerspellen/league-of-legends/teamnamen",
    sv: "/videospel/league-of-legends/lagnamn",
    no: "/videospill/league-of-legends/lagnavn",
    fi: "/videopelit/league-of-legends/joukkueiden-nimet",
    da: "/computerspil/liga-af-legender/holdnavne",
    ru: "/videoigry/league-of-legends/nazvaniya-komand",
  },
  "/video-games/dota-2/names": {
    de: "/videospiele/dota-2/namen",
    en: "/video-games/dota-2/names",
    fr: "/jeux-video/dota-2/des-noms",
    it: "/videogiochi/dota-2/nomi",
    es: "/juegos-de-video/dota-2/nombres",
    pl: "/gry-wideo/dota-2/nazwy",
    cs: "/videohry/dota-2/jmena",
    nl: "/computerspellen/dota-2/namen",
    sv: "/videospel/dota-2/namn",
    no: "/videospill/dota-2/navn",
    fi: "/videopelit/dota-2/nimet",
    da: "/computerspil/dota-2/navne",
    ru: "/videoigry/dota-2/imena",
  },
  "/video-games/dota-2/player-names": {
    de: "/videospiele/dota-2/spielernamen",
    en: "/video-games/dota-2/player-names",
    fr: "/jeux-video/dota-2/noms-des-joueurs",
    it: "/videogiochi/dota-2/nomi-dei-giocatori",
    es: "/juegos-de-video/dota-2/nombres-de-jugadores",
    pl: "/gry-wideo/dota-2/nazwy-graczy",
    cs: "/videohry/dota-2/jmena-hracu",
    nl: "/computerspellen/dota-2/namen-van-spelers",
    sv: "/videospel/dota-2/spelarnamn",
    no: "/videospill/dota-2/spillernavn",
    fi: "/videopelit/dota-2/pelaajien-nimet",
    da: "/computerspil/dota-2/spiller-navne",
    ru: "/videoigry/dota-2/imena-igrokov",
  },
  "/video-games/dota-2/team-names": {
    de: "/videospiele/dota-2/teamnamen",
    en: "/video-games/dota-2/team-names",
    fr: "/jeux-video/dota-2/noms-des-equipes",
    it: "/videogiochi/dota-2/nomi-delle-squadre",
    es: "/juegos-de-video/dota-2/nombres-de-equipo",
    pl: "/gry-wideo/dota-2/nazwy-druzyn",
    cs: "/videohry/dota-2/nazvy-tymu",
    nl: "/computerspellen/dota-2/teamnamen",
    sv: "/videospel/dota-2/lagnamn",
    no: "/videospill/dota-2/lagnavn",
    fi: "/videopelit/dota-2/joukkueiden-nimet",
    da: "/computerspil/dota-2/holdnavne",
    ru: "/videoigry/dota-2/nazvaniya-komand",
  },
  "/video-games/call-of-duty/clan-names": {
    de: "/videospiele/call-of-duty/clannamen",
    en: "/video-games/call-of-duty/clan-names",
    fr: "/jeux-video/call-of-duty/noms-de-clan",
    it: "/videogiochi/call-of-duty/nomi-dei-clan",
    es: "/juegos-de-video/call-of-duty/nombres-de-clanes",
    pl: "/gry-wideo/call-of-duty/nazwy-klanow",
    cs: "/videohry/call-of-duty/jmena-klanu",
    nl: "/computerspellen/call-of-duty/clannamen",
    sv: "/videospel/call-of-duty/klannamn",
    no: "/videospill/call-of-duty/klannavn",
    fi: "/videopelit/velvollisuuden-kutsu/klaanien-nimet",
    da: "/computerspil/call-of-duty/klannavne",
    ru: "/videoigry/call-of-duty/nazvaniya-klanov",
  },
  "/video-games/call-of-duty/mobile-names": {
    de: "/videospiele/call-of-duty/mobile-namen",
    en: "/video-games/call-of-duty/mobile-names",
    fr: "/jeux-video/call-of-duty/noms-mobiles",
    it: "/videogiochi/call-of-duty/nomi-cellulari",
    es: "/juegos-de-video/call-of-duty/nombres-de-moviles",
    pl: "/gry-wideo/call-of-duty/nazwy-telefonow-komorkowych",
    cs: "/videohry/call-of-duty/mobilni-jmena",
    nl: "/computerspellen/call-of-duty/mobiele-namen",
    sv: "/videospel/call-of-duty/mobilnamn",
    no: "/videospill/call-of-duty/mobilnavn",
    fi: "/videopelit/velvollisuuden-kutsu/mobiilinimet",
    da: "/computerspil/call-of-duty/mobilnavne",
    ru: "/videoigry/call-of-duty/mobilnye-imena",
  },
  "/video-games/call-of-duty/names": {
    de: "/videospiele/call-of-duty/namen",
    en: "/video-games/call-of-duty/names",
    fr: "/jeux-video/call-of-duty/des-noms",
    it: "/videogiochi/call-of-duty/nomi",
    es: "/juegos-de-video/call-of-duty/nombres",
    pl: "/gry-wideo/call-of-duty/nazwy",
    cs: "/videohry/call-of-duty/jmena",
    nl: "/computerspellen/call-of-duty/namen",
    sv: "/videospel/call-of-duty/namn",
    no: "/videospill/call-of-duty/navn",
    fi: "/videopelit/velvollisuuden-kutsu/nimet",
    da: "/computerspil/call-of-duty/navne",
    ru: "/videoigry/call-of-duty/imena",
  },
  "/video-games/call-of-duty/team-names": {
    de: "/videospiele/call-of-duty/teamnamen",
    en: "/video-games/call-of-duty/team-names",
    fr: "/jeux-video/call-of-duty/noms-des-equipes",
    it: "/videogiochi/call-of-duty/nomi-delle-squadre",
    es: "/juegos-de-video/call-of-duty/nombres-de-equipo",
    pl: "/gry-wideo/call-of-duty/nazwy-druzyn",
    cs: "/videohry/call-of-duty/nazvy-tymu",
    nl: "/computerspellen/call-of-duty/teamnamen",
    sv: "/videospel/call-of-duty/lagnamn",
    no: "/videospill/call-of-duty/lagnavn",
    fi: "/videopelit/velvollisuuden-kutsu/joukkueiden-nimet",
    da: "/computerspil/call-of-duty/holdnavne",
    ru: "/videoigry/call-of-duty/nazvaniya-komand",
  },
  "/video-games/escape-from-tarkov/names": {
    de: "/videospiele/escape-from-tarkov/namen",
    en: "/video-games/escape-from-tarkov/names",
    fr: "/jeux-video/escape-from-tarkov/des-noms",
    it: "/videogiochi/escape-from-tarkov/nomi",
    es: "/juegos-de-video/escape-from-tarkov/nombres",
    pl: "/gry-wideo/escape-from-tarkov/nazwy",
    cs: "/videohry/escape-from-tarkov/jmena",
    nl: "/computerspellen/escape-from-tarkov/namen",
    sv: "/videospel/escape-from-tarkov/namn",
    no: "/videospill/escape-from-tarkov/navn",
    fi: "/videopelit/pakene-tarkovista/nimet",
    da: "/computerspil/escape-from-tarkov/navne",
    ru: "/videoigry/escape-from-tarkov/imena",
  },
  "/video-games/diablo-4/barbarian-names": {
    de: "/videospiele/diablo-4/barbarennamen",
    en: "/video-games/diablo-4/barbarian-names",
    fr: "/jeux-video/diablo-4/noms-barbares",
    it: "/videogiochi/diablo-4/nomi-barbarici",
    es: "/juegos-de-video/diablo-4/nombres-barbaros",
    pl: "/gry-wideo/diablo-4/imiona-barbarzyncow",
    cs: "/videohry/diablo-4/barbarska-jmena",
    nl: "/computerspellen/diablo-4/barbaarse-namen",
    sv: "/videospel/diablo-4/barbarians-namn",
    no: "/videospill/diablo-4/barbariske-navn",
    fi: "/videopelit/diablo-4/barbaarien-nimet",
    da: "/computerspil/diablo-4/barbariske-navne",
    ru: "/videoigry/diablo-4/varvarskie-imena",
  },
  "/video-games/diablo-4/clan-names": {
    de: "/videospiele/diablo-4/clannamen",
    en: "/video-games/diablo-4/clan-names",
    fr: "/jeux-video/diablo-4/noms-de-clan",
    it: "/videogiochi/diablo-4/nomi-dei-clan",
    es: "/juegos-de-video/diablo-4/nombres-de-clanes",
    pl: "/gry-wideo/diablo-4/nazwy-klanow",
    cs: "/videohry/diablo-4/jmena-klanu",
    nl: "/computerspellen/diablo-4/clannamen",
    sv: "/videospel/diablo-4/klannamn",
    no: "/videospill/diablo-4/klannavn",
    fi: "/videopelit/diablo-4/klaanien-nimet",
    da: "/computerspil/diablo-4/klannavne",
    ru: "/videoigry/diablo-4/nazvaniya-klanov",
  },
  "/video-games/diablo-4/druid-names": {
    de: "/videospiele/diablo-4/druidennamen",
    en: "/video-games/diablo-4/druid-names",
    fr: "/jeux-video/diablo-4/noms-des-druides",
    it: "/videogiochi/diablo-4/nomi-druidi",
    es: "/juegos-de-video/diablo-4/nombres-de-druidas",
    pl: "/gry-wideo/diablo-4/imiona-druidow",
    cs: "/videohry/diablo-4/jmena-druidu",
    nl: "/computerspellen/diablo-4/druide-namen",
    sv: "/videospel/diablo-4/druidnamn",
    no: "/videospill/diablo-4/druide-navn",
    fi: "/videopelit/diablo-4/druidien-nimet",
    da: "/computerspil/diablo-4/druide-navne",
    ru: "/videoigry/diablo-4/imena-druidov",
  },
  "/video-games/diablo-4/guild-names": {
    de: "/videospiele/diablo-4/gildennamen",
    en: "/video-games/diablo-4/guild-names",
    fr: "/jeux-video/diablo-4/noms-de-guilde",
    it: "/videogiochi/diablo-4/nomi-delle-gilde",
    es: "/juegos-de-video/diablo-4/nombres-de-gremio",
    pl: "/gry-wideo/diablo-4/nazwy-gildii",
    cs: "/videohry/diablo-4/jmena-cechu",
    nl: "/computerspellen/diablo-4/gildenamen",
    sv: "/videospel/diablo-4/gildenamn",
    no: "/videospill/diablo-4/gildenavn",
    fi: "/videopelit/diablo-4/killan-nimet",
    da: "/computerspil/diablo-4/gildenavne",
    ru: "/videoigry/diablo-4/nazvaniya-gildiy",
  },
  "/video-games/diablo-4/hunter-names": {
    de: "/videospiele/diablo-4/jaegernamen",
    en: "/video-games/diablo-4/hunter-names",
    fr: "/jeux-video/diablo-4/noms-des-chasseurs",
    it: "/videogiochi/diablo-4/nomi-dei-cacciatori",
    es: "/juegos-de-video/diablo-4/nombres-de-cazadores",
    pl: "/gry-wideo/diablo-4/imiona-mysliwych",
    cs: "/videohry/diablo-4/jmena-lovcu",
    nl: "/computerspellen/diablo-4/jager-namen",
    sv: "/videospel/diablo-4/jaegares-namn",
    no: "/videospill/diablo-4/jegernavn",
    fi: "/videopelit/diablo-4/hunter-nimet",
    da: "/computerspil/diablo-4/jaegernavne",
    ru: "/videoigry/diablo-4/imena-okhotnikov",
  },
  "/video-games/diablo-4/names": {
    de: "/videospiele/diablo-4/namen",
    en: "/video-games/diablo-4/names",
    fr: "/jeux-video/diablo-4/des-noms",
    it: "/videogiochi/diablo-4/nomi",
    es: "/juegos-de-video/diablo-4/nombres",
    pl: "/gry-wideo/diablo-4/nazwy",
    cs: "/videohry/diablo-4/jmena",
    nl: "/computerspellen/diablo-4/namen",
    sv: "/videospel/diablo-4/namn",
    no: "/videospill/diablo-4/navn",
    fi: "/videopelit/diablo-4/nimet",
    da: "/computerspil/diablo-4/navne",
    ru: "/videoigry/diablo-4/imena",
  },
  "/video-games/diablo-4/necromancer-names": {
    de: "/videospiele/diablo-4/namen-von-nekromanten",
    en: "/video-games/diablo-4/necromancer-names",
    fr: "/jeux-video/diablo-4/noms-des-necromanciens",
    it: "/videogiochi/diablo-4/nomi-dei-negromanti",
    es: "/juegos-de-video/diablo-4/nombres-de-nigromantes",
    pl: "/gry-wideo/diablo-4/imiona-nekromanty",
    cs: "/videohry/diablo-4/jmena-nekromantu",
    nl: "/computerspellen/diablo-4/necromancer-namen",
    sv: "/videospel/diablo-4/necromancer-namn",
    no: "/videospill/diablo-4/necromancer-navn",
    fi: "/videopelit/diablo-4/necromancer-nimet",
    da: "/computerspil/diablo-4/necromancer-navne",
    ru: "/videoigry/diablo-4/imena-nekromantov",
  },
  "/video-games/cyberpunk/bar-names": {
    de: "/videospiele/cyberpunk/barnamen",
    en: "/video-games/cyberpunk/bar-names",
    fr: "/jeux-video/cyberpunk/noms-des-bars",
    it: "/videogiochi/cyberpunk/nomi-delle-barre",
    es: "/juegos-de-video/ciberpunk/nombres-de-barras",
    pl: "/gry-wideo/cyberpunk/nazwy-paskow",
    cs: "/videohry/cyberpunk/nazvy-baru",
    nl: "/computerspellen/cyberpunk/barnamen",
    sv: "/videospel/cyberpunk/barnamn",
    no: "/videospill/cyberpunk/barnavn",
    fi: "/videopelit/kyberpunk/baarien-nimet",
    da: "/computerspil/cyberpunk/barnavne",
    ru: "/videoigry/kiberpank/nazvaniya-barov",
  },
  "/video-games/cyberpunk/business-names": {
    de: "/videospiele/cyberpunk/firmennamen",
    en: "/video-games/cyberpunk/business-names",
    fr: "/jeux-video/cyberpunk/noms-d-entreprise",
    it: "/videogiochi/cyberpunk/nomi-aziendali",
    es: "/juegos-de-video/ciberpunk/nombres-comerciales",
    pl: "/gry-wideo/cyberpunk/nazwy-firm",
    cs: "/videohry/cyberpunk/obchodni-nazvy",
    nl: "/computerspellen/cyberpunk/bedrijfsnamen",
    sv: "/videospel/cyberpunk/foeretagsnamn",
    no: "/videospill/cyberpunk/bedriftsnavn",
    fi: "/videopelit/kyberpunk/yritysten-nimet",
    da: "/computerspil/cyberpunk/virksomhedsnavne",
    ru: "/videoigry/kiberpank/nazvaniya-kompaniy",
  },
  "/video-games/cyberpunk/character-names": {
    de: "/videospiele/cyberpunk/charakternamen",
    en: "/video-games/cyberpunk/character-names",
    fr: "/jeux-video/cyberpunk/noms-des-personnages",
    it: "/videogiochi/cyberpunk/nomi-dei-personaggi",
    es: "/juegos-de-video/ciberpunk/nombres-de-personajes",
    pl: "/gry-wideo/cyberpunk/imiona-postaci",
    cs: "/videohry/cyberpunk/jmena-postav",
    nl: "/computerspellen/cyberpunk/karakternamen",
    sv: "/videospel/cyberpunk/karaktaersnamn",
    no: "/videospill/cyberpunk/karakternavn",
    fi: "/videopelit/kyberpunk/hahmon-nimet",
    da: "/computerspil/cyberpunk/karakternavne",
    ru: "/videoigry/kiberpank/imena-personazhey",
  },
  "/video-games/cyberpunk/city-names": {
    de: "/videospiele/cyberpunk/staedtenamen",
    en: "/video-games/cyberpunk/city-names",
    fr: "/jeux-video/cyberpunk/noms-de-villes",
    it: "/videogiochi/cyberpunk/nomi-di-citta",
    es: "/juegos-de-video/ciberpunk/nombres-de-ciudades",
    pl: "/gry-wideo/cyberpunk/nazwy-miast",
    cs: "/videohry/cyberpunk/nazvy-mest",
    nl: "/computerspellen/cyberpunk/stadsnamen",
    sv: "/videospel/cyberpunk/stadsnamn",
    no: "/videospill/cyberpunk/bynavn",
    fi: "/videopelit/kyberpunk/kaupunkien-nimet",
    da: "/computerspil/cyberpunk/bynavne",
    ru: "/videoigry/kiberpank/nazvaniya-gorodov",
  },
  "/video-games/cyberpunk/corporation-names": {
    de: "/videospiele/cyberpunk/unternehmensnamen",
    en: "/video-games/cyberpunk/corporation-names",
    fr: "/jeux-video/cyberpunk/noms-de-societes",
    it: "/videogiochi/cyberpunk/nomi-di-societa",
    es: "/juegos-de-video/ciberpunk/nombres-de-corporaciones",
    pl: "/gry-wideo/cyberpunk/nazwy-korporacji",
    cs: "/videohry/cyberpunk/nazvy-spolecnosti",
    nl: "/computerspellen/cyberpunk/namen-van-bedrijven",
    sv: "/videospel/cyberpunk/foeretagsnamn",
    no: "/videospill/cyberpunk/bedriftsnavn",
    fi: "/videopelit/kyberpunk/yritysten-nimet",
    da: "/computerspil/cyberpunk/selskabsnavne",
    ru: "/videoigry/kiberpank/nazvaniya-korporatsiy",
  },
  "/video-games/cyberpunk/female-names": {
    de: "/videospiele/cyberpunk/weibliche-namen",
    en: "/video-games/cyberpunk/female-names",
    fr: "/jeux-video/cyberpunk/noms-feminins",
    it: "/videogiochi/cyberpunk/nomi-femminili",
    es: "/juegos-de-video/ciberpunk/nombres-femeninos",
    pl: "/gry-wideo/cyberpunk/imiona-zenskie",
    cs: "/videohry/cyberpunk/zenska-jmena",
    nl: "/computerspellen/cyberpunk/vrouwelijke-namen",
    sv: "/videospel/cyberpunk/kvinnliga-namn",
    no: "/videospill/cyberpunk/kvinnelige-navn",
    fi: "/videopelit/kyberpunk/naisten-nimet",
    da: "/computerspil/cyberpunk/kvindenavne",
    ru: "/videoigry/kiberpank/zhenskie-imena",
  },
  "/video-games/cyberpunk/gang-names": {
    de: "/videospiele/cyberpunk/bandennamen",
    en: "/video-games/cyberpunk/gang-names",
    fr: "/jeux-video/cyberpunk/noms-des-gangs",
    it: "/videogiochi/cyberpunk/nomi-delle-gang",
    es: "/juegos-de-video/ciberpunk/nombres-de-pandillas",
    pl: "/gry-wideo/cyberpunk/nazwy-gangow",
    cs: "/videohry/cyberpunk/jmena-gangu",
    nl: "/computerspellen/cyberpunk/bendenamen",
    sv: "/videospel/cyberpunk/gaengnamn",
    no: "/videospill/cyberpunk/gjengenavn",
    fi: "/videopelit/kyberpunk/jengien-nimet",
    da: "/computerspil/cyberpunk/bandenavne",
    ru: "/videoigry/kiberpank/nazvaniya-band",
  },
  "/video-games/cyberpunk/male-names": {
    de: "/videospiele/cyberpunk/maennliche-namen",
    en: "/video-games/cyberpunk/male-names",
    fr: "/jeux-video/cyberpunk/noms-masculins",
    it: "/videogiochi/cyberpunk/nomi-maschili",
    es: "/juegos-de-video/ciberpunk/nombres-masculinos",
    pl: "/gry-wideo/cyberpunk/imiona-meskie",
    cs: "/videohry/cyberpunk/muzska-jmena",
    nl: "/computerspellen/cyberpunk/mannelijke-namen",
    sv: "/videospel/cyberpunk/manliga-namn",
    no: "/videospill/cyberpunk/mannlige-navn",
    fi: "/videopelit/kyberpunk/miesten-nimet",
    da: "/computerspil/cyberpunk/mandlige-navne",
    ru: "/videoigry/kiberpank/muzhskie-imena",
  },
  "/video-games/cyberpunk/names": {
    de: "/videospiele/cyberpunk/namen",
    en: "/video-games/cyberpunk/names",
    fr: "/jeux-video/cyberpunk/des-noms",
    it: "/videogiochi/cyberpunk/nomi",
    es: "/juegos-de-video/ciberpunk/nombres",
    pl: "/gry-wideo/cyberpunk/nazwy",
    cs: "/videohry/cyberpunk/jmena",
    nl: "/computerspellen/cyberpunk/namen",
    sv: "/videospel/cyberpunk/namn",
    no: "/videospill/cyberpunk/navn",
    fi: "/videopelit/kyberpunk/nimet",
    da: "/computerspil/cyberpunk/navne",
    ru: "/videoigry/kiberpank/imena",
  },
  "/video-games/hogwarts-legacy/house-names": {
    de: "/videospiele/hogwarts-legacy/hausnamen",
    en: "/video-games/hogwarts-legacy/house-names",
    fr: "/jeux-video/hogwarts-legacy/noms-de-maisons",
    it: "/videogiochi/hogwarts-legacy/nomi-delle-case",
    es: "/juegos-de-video/hogwarts-legacy/nombres-de-casas",
    pl: "/gry-wideo/hogwarts-legacy/nazwy-domow",
    cs: "/videohry/hogwarts-legacy/jmena-domu",
    nl: "/computerspellen/hogwarts-legacy/huisnamen",
    sv: "/videospel/hogwarts-legacy/husnamn",
    no: "/videospill/hogwarts-legacy/husnavn",
    fi: "/videopelit/tylypahkan-perintoe/talojen-nimet",
    da: "/computerspil/hogwarts-legacy/husnavne",
    ru: "/videoigry/hogwarts-legacy/nazvaniya-domov",
  },
  "/video-games/hogwarts-legacy/namen": {
    de: "/videospiele/hogwarts-legacy/namen",
    en: "/video-games/hogwarts-legacy/namen",
    fr: "/jeux-video/hogwarts-legacy/nom",
    it: "/videogiochi/hogwarts-legacy/nome",
    es: "/juegos-de-video/hogwarts-legacy/nombre",
    pl: "/gry-wideo/hogwarts-legacy/imie",
    cs: "/videohry/hogwarts-legacy/namen",
    nl: "/computerspellen/hogwarts-legacy/namen",
    sv: "/videospel/hogwarts-legacy/namen",
    no: "/videospill/hogwarts-legacy/namen",
    fi: "/videopelit/tylypahkan-perintoe/namen",
    da: "/computerspil/hogwarts-legacy/namen",
    ru: "/videoigry/hogwarts-legacy/namen",
  },
  "/video-games/hogwarts-legacy/slytherin-names": {
    de: "/videospiele/hogwarts-legacy/slytherin-namen",
    en: "/video-games/hogwarts-legacy/slytherin-names",
    fr: "/jeux-video/hogwarts-legacy/noms-de-serpentard",
    it: "/videogiochi/hogwarts-legacy/nomi-serpeverde",
    es: "/juegos-de-video/hogwarts-legacy/nombres-de-slytherin",
    pl: "/gry-wideo/hogwarts-legacy/imiona-slytherinu",
    cs: "/videohry/hogwarts-legacy/zmijozelska-jmena",
    nl: "/computerspellen/hogwarts-legacy/zwadderich-namen",
    sv: "/videospel/hogwarts-legacy/slytherin-namn",
    no: "/videospill/hogwarts-legacy/slytherin-navn",
    fi: "/videopelit/tylypahkan-perintoe/slytherin-nimet",
    da: "/computerspil/hogwarts-legacy/slytherin-navne",
    ru: "/videoigry/hogwarts-legacy/imena-slizerina",
  },
  "/video-games/hogwarts-legacy/witch-names": {
    de: "/videospiele/hogwarts-legacy/hexennamen",
    en: "/video-games/hogwarts-legacy/witch-names",
    fr: "/jeux-video/hogwarts-legacy/noms-de-sorcieres",
    it: "/videogiochi/hogwarts-legacy/nomi-delle-streghe",
    es: "/juegos-de-video/hogwarts-legacy/nombres-de-brujas",
    pl: "/gry-wideo/hogwarts-legacy/imiona-czarownic",
    cs: "/videohry/hogwarts-legacy/jmena-carodejnic",
    nl: "/computerspellen/hogwarts-legacy/heksennamen",
    sv: "/videospel/hogwarts-legacy/haexnamn",
    no: "/videospill/hogwarts-legacy/heksenavn",
    fi: "/videopelit/tylypahkan-perintoe/noidan-nimet",
    da: "/computerspil/hogwarts-legacy/hekse-navne",
    ru: "/videoigry/hogwarts-legacy/imena-vedm",
  },
  "/video-games/hogwarts-legacy/wizard-names": {
    de: "/videospiele/hogwarts-legacy/zauberernamen",
    en: "/video-games/hogwarts-legacy/wizard-names",
    fr: "/jeux-video/hogwarts-legacy/noms-des-assistants",
    it: "/videogiochi/hogwarts-legacy/nomi-dei-maghi",
    es: "/juegos-de-video/hogwarts-legacy/nombres-de-magos",
    pl: "/gry-wideo/hogwarts-legacy/imiona-czarodziejow",
    cs: "/videohry/hogwarts-legacy/jmena-carodeju",
    nl: "/computerspellen/hogwarts-legacy/namen-van-wizards",
    sv: "/videospel/hogwarts-legacy/trollkarlens-namn",
    no: "/videospill/hogwarts-legacy/veivisernavn",
    fi: "/videopelit/tylypahkan-perintoe/ohjattujen-toimintojen-nimet",
    da: "/computerspil/hogwarts-legacy/troldmands-navne",
    ru: "/videoigry/hogwarts-legacy/imena-masterov",
  },
  "/video-games/minecraft/boys-names": {
    de: "/videospiele/minecraft/jungennamen",
    en: "/video-games/minecraft/boys-names",
    fr: "/jeux-video/minecraft/noms-de-garcons",
    it: "/videogiochi/minecraft/nomi-maschili",
    es: "/juegos-de-video/minecraft/nombres-de-ninos",
    pl: "/gry-wideo/minecraft/imiona-chlopcow",
    cs: "/videohry/minecraft/chlapecka-jmena",
    nl: "/computerspellen/minecraft/jongensnamen",
    sv: "/videospel/minecraft/pojknamn",
    no: "/videospill/minecraft/guttenavn",
    fi: "/videopelit/minecraft/poikien-nimet",
    da: "/computerspil/minecraft/drengenavne",
    ru: "/videoigry/minecraft/imena-malchikov",
  },
  "/video-games/minecraft/girls-names": {
    de: "/videospiele/minecraft/maedchennamen",
    en: "/video-games/minecraft/girls-names",
    fr: "/jeux-video/minecraft/noms-de-filles",
    it: "/videogiochi/minecraft/nomi-di-ragazze",
    es: "/juegos-de-video/minecraft/nombres-de-ninas",
    pl: "/gry-wideo/minecraft/imiona-dziewczat",
    cs: "/videohry/minecraft/divci-jmena",
    nl: "/computerspellen/minecraft/meisjesnamen",
    sv: "/videospel/minecraft/flicknamn",
    no: "/videospill/minecraft/jentenavn",
    fi: "/videopelit/minecraft/tyttoejen-nimet",
    da: "/computerspil/minecraft/pigenavne",
    ru: "/videoigry/minecraft/imena-dlya-devochek",
  },
  "/video-games/minecraft/names": {
    de: "/videospiele/minecraft/namen",
    en: "/video-games/minecraft/names",
    fr: "/jeux-video/minecraft/des-noms",
    it: "/videogiochi/minecraft/nomi",
    es: "/juegos-de-video/minecraft/nombres",
    pl: "/gry-wideo/minecraft/nazwy",
    cs: "/videohry/minecraft/jmena",
    nl: "/computerspellen/minecraft/namen",
    sv: "/videospel/minecraft/namn",
    no: "/videospill/minecraft/navn",
    fi: "/videopelit/minecraft/nimet",
    da: "/computerspil/minecraft/navne",
    ru: "/videoigry/minecraft/imena",
  },
  "/video-games/minecraft/server-names": {
    de: "/videospiele/minecraft/servernamen",
    en: "/video-games/minecraft/server-names",
    fr: "/jeux-video/minecraft/noms-de-serveur",
    it: "/videogiochi/minecraft/nomi-dei-server",
    es: "/juegos-de-video/minecraft/nombres-de-servidores",
    pl: "/gry-wideo/minecraft/nazwy-serwerow",
    cs: "/videohry/minecraft/nazvy-serveru",
    nl: "/computerspellen/minecraft/servernamen",
    sv: "/videospel/minecraft/servernamn",
    no: "/videospill/minecraft/servernavn",
    fi: "/videopelit/minecraft/palvelinten-nimet",
    da: "/computerspil/minecraft/servernavne",
    ru: "/videoigry/minecraft/imena-serverov",
  },
  "/video-games/minecraft/tryhard-names": {
    de: "/videospiele/minecraft/tryhard-namen",
    en: "/video-games/minecraft/tryhard-names",
    fr: "/jeux-video/minecraft/noms-tryhard",
    it: "/videogiochi/minecraft/nomi-tryhard",
    es: "/juegos-de-video/minecraft/nombres-dificiles",
    pl: "/gry-wideo/minecraft/nazwy-tryharda",
    cs: "/videohry/minecraft/jmena-tryhard",
    nl: "/computerspellen/minecraft/tryhard-namen",
    sv: "/videospel/minecraft/tryhard-names",
    no: "/videospill/minecraft/provharde-navn",
    fi: "/videopelit/minecraft/tryhard-nimet",
    da: "/computerspil/minecraft/forsogte-navne",
    ru: "/videoigry/minecraft/imena-traykharda",
  },
  "/video-games/world-of-warcraft/blood-elf-names": {
    de: "/videospiele/world-of-warcraft/blutelfen-namen",
    en: "/video-games/world-of-warcraft/blood-elf-names",
    fr: "/jeux-video/world-of-warcraft/noms-des-elfes-de-sang",
    it: "/videogiochi/world-of-warcraft/nomi-degli-elfi-del-sangue",
    es: "/juegos-de-video/world-of-warcraft/nombres-de-elfos-de-sangre",
    pl: "/gry-wideo/world-of-warcraft/imiona-krwawych-elfow",
    cs: "/videohry/world-of-warcraft/jmena-krvavych-elfu",
    nl: "/computerspellen/world-of-warcraft/bloedelf-namen",
    sv: "/videospel/world-of-warcraft/blod-elf-namn",
    no: "/videospill/world-of-warcraft/blod-alvenavn",
    fi: "/videopelit/world-of-warcraft/verihaltioiden-nimet",
    da: "/computerspil/world-of-warcraft/blod-elver-navne",
    ru: "/videoigry/world-of-warcraft/imena-elfov-krovi",
  },
  "/video-games/world-of-warcraft/dracthyr-names": {
    de: "/videospiele/world-of-warcraft/dractyr-namen",
    en: "/video-games/world-of-warcraft/dracthyr-names",
    fr: "/jeux-video/world-of-warcraft/noms-de-dracthyrs",
    it: "/videogiochi/world-of-warcraft/nomi-dei-dracthyr",
    es: "/juegos-de-video/world-of-warcraft/nombres-dracthyr",
    pl: "/gry-wideo/world-of-warcraft/imiona-dracthyrow",
    cs: "/videohry/world-of-warcraft/dracthyrska-jmena",
    nl: "/computerspellen/world-of-warcraft/dracthyr-namen",
    sv: "/videospel/world-of-warcraft/dracthyrs-namn",
    no: "/videospill/world-of-warcraft/dracthyr-navn",
    fi: "/videopelit/world-of-warcraft/dracthyrin-nimet",
    da: "/computerspil/world-of-warcraft/dracthyr-navne",
    ru: "/videoigry/world-of-warcraft/imena-draktirov",
  },
  "/video-games/world-of-warcraft/draenei-names": {
    de: "/videospiele/world-of-warcraft/draenei-namen",
    en: "/video-games/world-of-warcraft/draenei-names",
    fr: "/jeux-video/world-of-warcraft/noms-draenei",
    it: "/videogiochi/world-of-warcraft/nomi-draenei",
    es: "/juegos-de-video/world-of-warcraft/nombres-draenei",
    pl: "/gry-wideo/world-of-warcraft/imiona-draenei",
    cs: "/videohry/world-of-warcraft/jmena-draenei",
    nl: "/computerspellen/world-of-warcraft/draenei-namen",
    sv: "/videospel/world-of-warcraft/draenei-namn",
    no: "/videospill/world-of-warcraft/draenei-navn",
    fi: "/videopelit/world-of-warcraft/draenein-nimet",
    da: "/computerspil/world-of-warcraft/draenei-navne",
    ru: "/videoigry/world-of-warcraft/imena-dreneev",
  },
  "/video-games/world-of-warcraft/forsaken-names": {
    de: "/videospiele/world-of-warcraft/verlassene-namen",
    en: "/video-games/world-of-warcraft/forsaken-names",
    fr: "/jeux-video/world-of-warcraft/noms-abandonnes",
    it: "/videogiochi/world-of-warcraft/nomi-abbandonati",
    es: "/juegos-de-video/world-of-warcraft/nombres-abandonados",
    pl: "/gry-wideo/world-of-warcraft/zapomniane-imiona",
    cs: "/videohry/world-of-warcraft/forsaken-names",
    nl: "/computerspellen/world-of-warcraft/verlaten-namen",
    sv: "/videospel/world-of-warcraft/oevergivna-namn",
    no: "/videospill/world-of-warcraft/forlatte-navn",
    fi: "/videopelit/world-of-warcraft/hylaetyt-nimet",
    da: "/computerspil/world-of-warcraft/forladte-navne",
    ru: "/videoigry/world-of-warcraft/zabytye-imena",
  },
  "/video-games/world-of-warcraft/gnome-names": {
    de: "/videospiele/world-of-warcraft/gnomennamen",
    en: "/video-games/world-of-warcraft/gnome-names",
    fr: "/jeux-video/world-of-warcraft/noms-des-gnomes",
    it: "/videogiochi/world-of-warcraft/nomi-degli-gnomi",
    es: "/juegos-de-video/world-of-warcraft/nombres-de-gnomos",
    pl: "/gry-wideo/world-of-warcraft/imiona-gnomow",
    cs: "/videohry/world-of-warcraft/jmena-gnome",
    nl: "/computerspellen/world-of-warcraft/namen-van-kabouters",
    sv: "/videospel/world-of-warcraft/gnomnamn",
    no: "/videospill/world-of-warcraft/gnome-navn",
    fi: "/videopelit/world-of-warcraft/gnome-nimet",
    da: "/computerspil/world-of-warcraft/gnome-navne",
    ru: "/videoigry/world-of-warcraft/imena-gnomov",
  },
  "/video-games/world-of-warcraft/goblin-names": {
    de: "/videospiele/world-of-warcraft/koboldnamen",
    en: "/video-games/world-of-warcraft/goblin-names",
    fr: "/jeux-video/world-of-warcraft/noms-des-gobelins",
    it: "/videogiochi/world-of-warcraft/nomi-dei-goblin",
    es: "/juegos-de-video/world-of-warcraft/nombres-de-duendes",
    pl: "/gry-wideo/world-of-warcraft/imiona-goblinow",
    cs: "/videohry/world-of-warcraft/goblin-jmena",
    nl: "/computerspellen/world-of-warcraft/goblin-namen",
    sv: "/videospel/world-of-warcraft/goblin-namn",
    no: "/videospill/world-of-warcraft/goblin-navn",
    fi: "/videopelit/world-of-warcraft/goblin-nimet",
    da: "/computerspil/world-of-warcraft/goblin-navne",
    ru: "/videoigry/world-of-warcraft/imena-goblinov",
  },
  "/video-games/world-of-warcraft/human-names": {
    de: "/videospiele/world-of-warcraft/menschliche-namen",
    en: "/video-games/world-of-warcraft/human-names",
    fr: "/jeux-video/world-of-warcraft/noms-humains",
    it: "/videogiochi/world-of-warcraft/nomi-umani",
    es: "/juegos-de-video/world-of-warcraft/nombres-humanos",
    pl: "/gry-wideo/world-of-warcraft/imiona-ludzkie",
    cs: "/videohry/world-of-warcraft/lidska-jmena",
    nl: "/computerspellen/world-of-warcraft/menselijke-namen",
    sv: "/videospel/world-of-warcraft/maenniskonamn",
    no: "/videospill/world-of-warcraft/menneskelige-navn",
    fi: "/videopelit/world-of-warcraft/ihmisten-nimet",
    da: "/computerspil/world-of-warcraft/menneskelige-navne",
    ru: "/videoigry/world-of-warcraft/chelovecheskie-imena",
  },
  "/video-games/world-of-warcraft/night-elf-names": {
    de: "/videospiele/world-of-warcraft/namen-der-nachtelfen",
    en: "/video-games/world-of-warcraft/night-elf-names",
    fr: "/jeux-video/world-of-warcraft/noms-des-elfes-de-la-nuit",
    it: "/videogiochi/world-of-warcraft/nomi-degli-elfi-della-notte",
    es: "/juegos-de-video/world-of-warcraft/nombres-de-elfos-de-la-noche",
    pl: "/gry-wideo/world-of-warcraft/imiona-nocnych-elfow",
    cs: "/videohry/world-of-warcraft/jmena-nocnich-elfu",
    nl: "/computerspellen/world-of-warcraft/namen-van-nachtelfjes",
    sv: "/videospel/world-of-warcraft/night-elf-namn",
    no: "/videospill/world-of-warcraft/nattalvenavn",
    fi: "/videopelit/world-of-warcraft/night-elf-nimet",
    da: "/computerspil/world-of-warcraft/night-elf-navne",
    ru: "/videoigry/world-of-warcraft/imena-nochnykh-elfov",
  },
  "/video-games/world-of-warcraft/orc-names": {
    de: "/videospiele/world-of-warcraft/ork-namen",
    en: "/video-games/world-of-warcraft/orc-names",
    fr: "/jeux-video/world-of-warcraft/noms-des-orques",
    it: "/videogiochi/world-of-warcraft/nomi-degli-orchi",
    es: "/juegos-de-video/world-of-warcraft/nombres-de-orcos",
    pl: "/gry-wideo/world-of-warcraft/imiona-orkow",
    cs: "/videohry/world-of-warcraft/skreti-jmena",
    nl: "/computerspellen/world-of-warcraft/orc-namen",
    sv: "/videospel/world-of-warcraft/orc-namn",
    no: "/videospill/world-of-warcraft/orc-navn",
    fi: "/videopelit/world-of-warcraft/orkkien-nimet",
    da: "/computerspil/world-of-warcraft/orc-navne",
    ru: "/videoigry/world-of-warcraft/imena-orkov",
  },
  "/video-games/world-of-warcraft/pandaren-names": {
    de: "/videospiele/world-of-warcraft/pandaren-namen",
    en: "/video-games/world-of-warcraft/pandaren-names",
    fr: "/jeux-video/world-of-warcraft/noms-pandarens",
    it: "/videogiochi/world-of-warcraft/nomi-dei-pandaren",
    es: "/juegos-de-video/world-of-warcraft/nombres-pandaren",
    pl: "/gry-wideo/world-of-warcraft/imiona-pandarenow",
    cs: "/videohry/world-of-warcraft/pandarenska-jmena",
    nl: "/computerspellen/world-of-warcraft/pandaren-namen",
    sv: "/videospel/world-of-warcraft/pandarens-namn",
    no: "/videospill/world-of-warcraft/pandaren-navn",
    fi: "/videopelit/world-of-warcraft/pandarenin-nimet",
    da: "/computerspil/world-of-warcraft/pandarens-navne",
    ru: "/videoigry/world-of-warcraft/pandarenskie-imena",
  },
  "/video-games/world-of-warcraft/petname-names": {
    de: "/videospiele/world-of-warcraft/kosenamen",
    en: "/video-games/world-of-warcraft/petname-names",
    fr: "/jeux-video/world-of-warcraft/noms-d-animaux",
    it: "/videogiochi/world-of-warcraft/nomi-di-animali-domestici",
    es: "/juegos-de-video/world-of-warcraft/nombres-de-mascotas",
    pl: "/gry-wideo/world-of-warcraft/imiona-zwierzat",
    cs: "/videohry/world-of-warcraft/jmena-domacich-mazlicku",
    nl: "/computerspellen/world-of-warcraft/namen-van-huisdiernamen",
    sv: "/videospel/world-of-warcraft/saellskapsnamn",
    no: "/videospill/world-of-warcraft/kjaeledyrnavn",
    fi: "/videopelit/world-of-warcraft/lemmikkinimien-nimet",
    da: "/computerspil/world-of-warcraft/kaeledyrsnavne",
    ru: "/videoigry/world-of-warcraft/imena-domashnikh-zhivotnykh",
  },
  "/video-games/world-of-warcraft/race-names": {
    de: "/videospiele/world-of-warcraft/rassennamen",
    en: "/video-games/world-of-warcraft/race-names",
    fr: "/jeux-video/world-of-warcraft/noms-des-courses",
    it: "/videogiochi/world-of-warcraft/nomi-di-razza",
    es: "/juegos-de-video/world-of-warcraft/nombres-de-carreras",
    pl: "/gry-wideo/world-of-warcraft/nazwy-ras",
    cs: "/videohry/world-of-warcraft/jmena-ras",
    nl: "/computerspellen/world-of-warcraft/ras-namen",
    sv: "/videospel/world-of-warcraft/rasnamn",
    no: "/videospill/world-of-warcraft/rasenavn",
    fi: "/videopelit/world-of-warcraft/rotujen-nimet",
    da: "/computerspil/world-of-warcraft/race-navne",
    ru: "/videoigry/world-of-warcraft/nazvaniya-ras",
  },
  "/video-games/world-of-warcraft/tauren-names": {
    de: "/videospiele/world-of-warcraft/tauren-namen",
    en: "/video-games/world-of-warcraft/tauren-names",
    fr: "/jeux-video/world-of-warcraft/noms-des-taurens",
    it: "/videogiochi/world-of-warcraft/nomi-dei-tauren",
    es: "/juegos-de-video/world-of-warcraft/nombres-tauren",
    pl: "/gry-wideo/world-of-warcraft/imiona-taurenow",
    cs: "/videohry/world-of-warcraft/taurenska-jmena",
    nl: "/computerspellen/world-of-warcraft/tauren-namen",
    sv: "/videospel/world-of-warcraft/taurens-namn",
    no: "/videospill/world-of-warcraft/tauren-navn",
    fi: "/videopelit/world-of-warcraft/tauren-nimet",
    da: "/computerspil/world-of-warcraft/taurens-navne",
    ru: "/videoigry/world-of-warcraft/imena-taurenov",
  },
  "/video-games/world-of-warcraft/troll-names": {
    de: "/videospiele/world-of-warcraft/trollnamen",
    en: "/video-games/world-of-warcraft/troll-names",
    fr: "/jeux-video/world-of-warcraft/noms-de-trolls",
    it: "/videogiochi/world-of-warcraft/nomi-dei-troll",
    es: "/juegos-de-video/world-of-warcraft/nombres-de-trolls",
    pl: "/gry-wideo/world-of-warcraft/imiona-trolli",
    cs: "/videohry/world-of-warcraft/troll-jmena",
    nl: "/computerspellen/world-of-warcraft/trollen-namen",
    sv: "/videospel/world-of-warcraft/trollnamn",
    no: "/videospill/world-of-warcraft/troll-navn",
    fi: "/videopelit/world-of-warcraft/trollien-nimet",
    da: "/computerspil/world-of-warcraft/trolde-navne",
    ru: "/videoigry/world-of-warcraft/imena-trolley",
  },
  "/video-games/world-of-warcraft/vulpera-names": {
    de: "/videospiele/world-of-warcraft/vulpera-namen",
    en: "/video-games/world-of-warcraft/vulpera-names",
    fr: "/jeux-video/world-of-warcraft/noms-de-vulpera",
    it: "/videogiochi/world-of-warcraft/nomi-vulpera",
    es: "/juegos-de-video/world-of-warcraft/nombres-vulperas",
    pl: "/gry-wideo/world-of-warcraft/imiona-vulpery",
    cs: "/videohry/world-of-warcraft/jmena-vulpera",
    nl: "/computerspellen/world-of-warcraft/vulpera-namen",
    sv: "/videospel/world-of-warcraft/vulpera-namn",
    no: "/videospill/world-of-warcraft/vulpera-navn",
    fi: "/videopelit/world-of-warcraft/vulperan-nimet",
    da: "/computerspil/world-of-warcraft/vulpera-navne",
    ru: "/videoigry/world-of-warcraft/imena-vulper",
  },
  "/video-games/world-of-warcraft/worgen-names": {
    de: "/videospiele/world-of-warcraft/worgen-namen",
    en: "/video-games/world-of-warcraft/worgen-names",
    fr: "/jeux-video/world-of-warcraft/noms-des-worgens",
    it: "/videogiochi/world-of-warcraft/nomi-worgen",
    es: "/juegos-de-video/world-of-warcraft/nombres-de-huargen",
    pl: "/gry-wideo/world-of-warcraft/imiona-worgenow",
    cs: "/videohry/world-of-warcraft/worgenska-jmena",
    nl: "/computerspellen/world-of-warcraft/worgen-namen",
    sv: "/videospel/world-of-warcraft/worgen-namn",
    no: "/videospill/world-of-warcraft/worgen-navn",
    fi: "/videopelit/world-of-warcraft/huonot-nimet",
    da: "/computerspil/world-of-warcraft/worgen-navne",
    ru: "/videoigry/world-of-warcraft/imena-vorgenov",
  },
  // Add other namegenerator paths here

  // This is for the <Link> component to link to specific namegen pages
  // Do not delete router will throw error when switching langauges on categories/gaming/all page e.g.
  // Rewrite /categories path with 2 dynamic segments
  "/categories/[category]/[subcategory]": {
    en: "/categories/[category]/[subcategory]",
    de: "/kategorien/[category]/[subcategory]",
    fr: "/categories/[category]/[subcategory]",
    it: "/categorie/[category]/[subcategory]",
    es: "/categorias/[category]/[subcategory]",
    pl: "/kategorie/[category]/[subcategory]",
    cs: "/kategorie/[category]/[subcategory]",
    nl: "/categorieen/[category]/[subcategory]",
    sv: "/kategorier/[category]/[subcategory]",
    no: "/kategorier/[category]/[subcategory]",
    fi: "/kategoriat/[category]/[subcategory]",
    da: "/kategorier/[category]/[subcategory]",
    ru: "/categories/[category]/[subcategory]",
    // Add other locales here
  },

  // Rewrite /categories path with 1 dynamic segment
  "/categories/[category]": {
    en: "/categories/[category]",
    de: "/kategorien/[category]",
    fr: "/categories/[category]",
    it: "/categorie/[category]",
    es: "/categorias/[category]",
    pl: "/kategorie/[category]",
    cs: "/kategorie/[category]",
    nl: "/categorieen/[category]",
    sv: "/kategorier/[category]",
    no: "/kategorier/[category]",
    fi: "/kategoriat/[category]",
    da: "/kategorier/[category]",
    ru: "/categories/[category]",
    // Add other locales here
  },

  // This is for the <Link> component to link to specific namegen pages
  "/[category]/[...slug]": {
    en: "/[category]/[...slug]",
    de: "/[category]/[...slug]",
    fr: "/[category]/[...slug]",
    it: "/[category]/[...slug]",
    es: "/[category]/[...slug]",
    pl: "/[category]/[...slug]",
    cs: "/[category]/[...slug]",
    nl: "/[category]/[...slug]",
    sv: "/[category]/[...slug]",
    no: "/[category]/[...slug]",
    fi: "/[category]/[...slug]",
    da: "/[category]/[...slug]",
    ru: "/[category]/[...slug]",
    // Add other locales here
  },
}

export const routing = defineRouting({
  defaultLocale: "en",
  localePrefix: "always",
  pathnames,
  locales,
  alternateLinks: true,
})

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter } =
  createNavigation(routing)
